import { flatObjectAll } from '../script.js'

let language = {
	advancedRelease: {
		children: {
			items: {
				acit1: {
					zh: "新建",
					en: "New",
					vi: "Tạo Mới",
					ru: "Создать",
					tr: "Yeni Oluştur",
					ja: "新規作成",
				},
				acit2: {
					zh: "发布",
					en: "Publish",
					vi: "Xuất Bản",
					ru: "Опубликовать",
					tr: "Yayınla",
					ja: "公開",
				},
				acit3: {
					zh: "添加",
					en: "Add",
					vi: "Thêm",
					ru: "Добавить",
					tr: "Ekle",
					ja: "追加",
				},
				acit4: {
					zh: "删除",
					en: "Delete",
					vi: "Xóa",
					ru: "Удалить",
					tr: "Sil",
					ja: "削除",
				},
				acit5: {
					zh: "节目名称",
					en: "Name",
					vi: "Tên Chương Trình",
					ru: "Название программы",
					tr: "Program Adı",
					ja: "プログラム名",
				},
				acit6: {
					zh: "播放次数",
					en: "Play Count",
					vi: "Số Lần Phát",
					ru: "Количество воспроизведений",
					tr: "Çalma Sayısı",
					ja: "再生回数",
				},
				acit7: {
					zh: "连续播放次数",
					en: "Continuous Play Count",
					vi: "Số Lần Phát Liên Tục",
					ru: "Количество непрерывных воспроизведений",
					tr: "Sürekli Çalma Sayısı",
					ja: "連続再生回数",
				},
				acit8: {
					zh: "播放时长",
					en: "Play Duration",
					vi: "Thời Gian Phát",
					ru: "Длительность воспроизведения",
					tr: "Çalma Süresi",
					ja: "再生時間",
				},
				acit9: {
					zh: "连续播放时间",
					en: "Continuous Play Time",
					vi: "Thời Gian Phát Liên Tục",
					ru: "Время непрерывного воспроизведения",
					tr: "Sürekli Çalma Süresi",
					ja: "連続再生時間",
				}
			},
			Loops: {
				acl1: {
					zh: "至少添加两个节目",
					en: "Add at least two programs",
					vi: "Thêm ít nhất hai chương trình",
					ru: "Добавьте как минимум два программы",
					tr: "En az iki program ekleyin",
					ja: "少なくとも2つのプログラムを追加してください",
				}
			},
			ProgramInfo: {
				acp1: {
					zh: "用于指令按设定的时间自动操作，如开关屏，亮度调节",
					en: "Used for commands to automatically operate at set times, such as turning the screen on/off, adjusting brightness",
					vi: "Dùng để các lệnh tự động hoạt động theo thời gian đã thiết lập, chẳng hạn như bật/tắt màn hình, điều chỉnh độ sáng",
					ru: "Используется для автоматической работы команд в установленное время, например, включение/выключение экрана, регулировка яркости",
					tr: "Ekran açma/kapatma, parlaklık ayarlama gibi belirli zamanlarda otomatik olarak çalışmak için komutlar için kullanılır",
					ja: "画面のオン/オフ、明るさの調整など、設定された時間に自動的に操作するコマンドに使用されます",
				},
				acp2: {
					zh: "指令名称",
					en: "Command Name",
					vi: "Tên Lệnh",
					ru: "Название команды",
					tr: "Komut Adı",
					ja: "コマンド名",
				},
				acp3: {
					zh: "执行规则",
					en: "Execution Rule",
					vi: "Quy Tắc Thực Hiện",
					ru: "Правило выполнения",
					tr: "Yürütme Kuralı",
					ja: "実行ルール",
				}
			},
			Timercom: {
				actc1: {
					zh: "指令名称",
					en: "Command Name",
					vi: "Tên Lệnh",
					ru: "Название команды",
					tr: "Komut Adı",
					ja: "コマンド名",
				},
				actc2: {
					zh: "执行规则",
					en: "Execution Rule",
					vi: "Quy Tắc Thực Hiện",
					ru: "Правило выполнения",
					tr: "Yürütme Kuralı",
					ja: "実行ルール",
				},
				actc3: {
					zh: "定时指令发布成功",
					en: "Timer command published successfully",
					vi: "Lệnh theo lịch đã xuất bản thành công",
					ru: "Команда таймера успешно опубликована",
					tr: "Zamanlanmış komut başarıyla yayınlandı",
					ja: "タイマーコマンドの公開に成功しました",
				},
				actc4: {
					zh: "定时指令已下发,需要审核员审核。",
					en: "Timer command has been sent and needs reviewer approval.",
					vi: "Lệnh theo lịch đã được gửi, cần người đánh giá phê duyệt.",
					ru: "Команда таймера отправлена, требуется одобрение рецензента.",
					tr: "Zamanlanmış komut gönderildi, inceleyen onayı gerekiyor.",
					ja: "タイマーコマンドは送信されました、審査員の審査が必要です。",
				},
				actc5: {
					zh: "定时指令发布失败",
					en: "Timer command publish failed",
					vi: "Xuất bản lệnh theo lịch thất bại",
					ru: "Не удалось опубликовать команду таймера",
					tr: "Zamanlanmış komut yayınlanamadı",
					ja: "タイマーコマンドの公開に失敗しました",
				}
			},
			Timerplay: {
				act1: {
					zh: "垫片",
					en: "Default",
					vi: "miếng đệm",
					ru: "прокладка",
					tr: "conta",
					ja: "ガスケット",
				},
				act2: {
					zh: "垫片节目",
					en: "Default",
					vi: "Chương trình Miếng Đệm",
					ru: "Шоу Прокладок",
					tr: "Conta Programı",
					ja: "ガスケットショー",
				},
				act3: {
					zh: "排程时间轴",
					en: "Schedule Timeline",
					vi: "Lịch Trình Trục Thời Gian",
					ru: "Временная шкала расписания",
					tr: "Zaman Çizelgesi Zaman Çizelgesi",
					ja: "スケジュールタイムライン",
				},
				act4: {
					zh: "添加计划",
					en: "Add Plan",
					vi: "Thêm Kế Hoạch",
					ru: "Добавить план",
					tr: "Plan Ekle",
					ja: "プランを追加",
				},
				act5: {
					zh: "设置时间",
					en: "Set Time",
					vi: "Đặt Thời Gian",
					ru: "Установить время",
					tr: "Zaman Ayarla",
					ja: "時間を設定",
				},
			},
			Tpchild: {
				actd1: {
					zh: "选择时间范围",
					en: "Select Time Range",
					vi: "Chọn Phạm Vi Thời Gian",
					ru: "Выберите диапазон времени",
					tr: "Zaman Aralığı Seçin",
					ja: "時間範囲を選択",
				}

			},
			Urgency: {
				acu1: {
					zh: "插播类型",
					en: "Insert Type",
					vi: "Loại Chèn",
					ru: "Тип вставки",
					tr: "Ekleme Türü",
					ja: "挿入タイプ",
				}
			},
			index: {
				aci1: {
					zh: "循环发布",
					en: "Loop",
					vi: "Phát Lặp Lại",
					ru: "Периодическая публикация",
					tr: "Döngü Yayını",
					ja: "ループ発行",
				},
				aci2: {
					zh: "定时发布",
					en: "Timing Play",
					vi: "Phát Theo Lịch",
					ru: "Запланированная публикация",
					tr: "Zamanlanmış Yayın",
					ja: "予定発行",
				},
				aci3: {
					zh: "紧急插播",
					en: "Urgency",
					vi: "Chèn Cấp Bách",
					ru: "Экстренная вставка",
					tr: "Acil Ekleme",
					ja: "緊急挿入",
				},
				aci4: {
					zh: "定时指令",
					en: "Command",
					vi: "Lệnh Theo Lịch",
					ru: "Запланированная команда",
					tr: "Zamanlanmış Komut",
					ja: "予定コマンド",
				},
				aci5: {
					zh: "发布进度",
					en: "Publish Progress",
					vi: "Tiến Độ Xuất Bản",
					ru: "Прогресс публикации",
					tr: "Yayın İlerlemesi",
					ja: "発行進捗",
				},
				aci6: {
					zh: "发布记录",
					en: "Publish Record",
					vi: "Lịch Sử Xuất Bản",
					ru: "Запись публикации",
					tr: "Yayın Kaydı",
					ja: "発行記録",
				},
				acit7: {
					zh: "发布详情",
					en: "Publish Details",
					vi: "Chi Tiết Xuất Bản",
					ru: "Детали публикации",
					tr: "Yayın Detayları",
					ja: "発行詳細",
				}
			}
		}
	},
	amap: {
		child: {
			cacc1: {
				zh: "设备名称：",
				en: "Device Name:",
				vi: "Tên thiết bị",
				ru: "Имя устройства:",
				tr: "Cihaz Adı:",
				ja: "デバイス名:",
			},
			cacc2: {
				zh: "所属机构：",
				en: "Affiliation:",
				vi: "liên kết",
				ru: "Присоединение:",
				tr: "Üyelik:",
				ja: "所属機関:",
			},
			cacc3: {
				zh: "分辨率：",
				en: "Resolution:",
				vi: "Độ phân giải",
				ru: "Разрешение:",
				tr: "Çözünürlük:",
				ja: "解像度:",
			},
			cacc4: {
				zh: "内存空间：",
				en: "Memory Space:",
				vi: "Không gian bộ nhớ",
				ru: "Объем памяти:",
				tr: "Bellek Alanı:",
				ja: "メモリ容量:",
			},
			cacc5: {
				zh: "版本号：",
				en: "version number:",
				vi: "số phiên bản",
				ru: "номер версии:",
				tr: "sürüm numarası:",
				ja: "バージョン番号:",
			},
			cacc6: {
				zh: "备注：",
				en: "Remark:",
				vi: "Nhận xét",
				ru: "Замечание:",
				tr: "Açıklama:",
				ja: "コメント:",
			},
			cacc7: {
				zh: "运行状态：",
				en: "Operating status:",
				vi: "Trạng thái hoạt động",
				ru: "Рабочее состояние:",
				tr: "Çalışma durumu:",
				ja: "実行ステータス:",
			},
			cacc8: {
				zh: "连续运行：",
				en: "continue to operate:",
				vi: "tiếp tục hoạt động",
				ru: "продолжает работать:",
				tr: "çalışmaya devam edin:",
				ja: "連続運転:",
			},
			cacc9: {
				zh: "最近心跳：",
				en: "Recent heartbeat:",
				vi: "Nhịp tim gần đây",
				ru: "Недавнее сердцебиение:",
				tr: "Son kalp atışı:",
				ja: "最近心拍数:",
			},
			cacc10: {
				zh: "盒子时钟：",
				en: "Box Clock:",
				vi: "Đồng hồ hộp",
				ru: "Встроенные часы:",
				tr: "Kutu Saati:",
				ja: "箱の時計:",
			},
			cacc11: {
				zh: "IP地址：",
				en: "IP Address:",
				vi: "Địa chỉ IP",
				ru: "ip-адрес:",
				tr: "IP Adresi:",
				ja: "IPアドレス:",
			},
			cacc12: {
				zh: "音量：",
				en: "volume:",
				vi: "âm lượng",
				ru: "громкость:",
				tr: "hacim:",
				ja: "音量:",
			},
			cacc13: {
				zh: "暂无数据",
				en: "No data",
				vi: "Không có dữ liệu",
				ru: "Нет данных",
				tr: "Veri yok",
				ja: "データがありません",
			},
			cacc14: {
				zh: "亮度：",
				en: "brightness:",
				vi: "độ sáng",
				ru: "о яркости:",
				tr: "parlaklık:",
				ja: "明るさ:",
			},
			cacc15: {
				zh: "请输入0-100的数字",
				en: "Please enter a number between 0 and 100",
				vi: "Vui lòng nhập số từ 0 đến 100",
				ru: "Пожалуйста, введите число от 0 до 100",
				tr: "Lütfen 0 ile 100 arasında bir sayı girin",
				ja: "0-100の数字を入力してください",
			}
		},
		dialog: {
			cadd1: {
				zh: "截图",
				en: "screenshot",
				vi: "Hình ảnh",
				ru: "скриншот",
				tr: "ekran görüntüsü",
				ja: "スクリーンショット",
			},
			cadd2: {
				zh: "节目单名称",
				en: "Name",
				vi: "Tên chương trình",
				ru: "Название программы",
				tr: "Program adı",
				ja: "プログラム名",
			},
			cadd3: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "Организационная структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cadd4: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "Разрешение:",
				tr: "Çözünürlük",
				ja: "解像度",
			},
			cadd5: {
				zh: "模版名称",
				en: "Template Name",
				vi: "Tên mẫu",
				ru: "Название шаблона",
				tr: "Şablon Adı",
				ja: "テンプレート名",
			},
			cadd6: {
				zh: "创建时间",
				en: "Creation time",
				vi: "Thời gian khởi tạo",
				ru: "Время создания",
				tr: "Yaratılış zamanı",
				ja: "作成時刻",
			},
			cadd7: {
				zh: "终端名称",
				en: "Terminal Name",
				vi: "Tên thiết bị đầu cuối",
				ru: "Название терминала",
				tr: "Terminal Adı",
				ja: "端末名",
			},
			cadd8: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "Организационная структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cadd9: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "Разрешение:",
				tr: "Çözünürlük",
				ja: "解像度",
			},
			cadd10: {
				zh: "设备类型",
				en: "Equipment type",
				vi: "Loại thiết bị",
				ru: "Тип оборудования",
				tr: "Ekipman türü",
				ja: "デバイスタイプ",
			},
			cadd11: {
				zh: "业务属性",
				en: "Business attributes",
				vi: "Thuộc tính nghiệp vụ",
				ru: "Бизнес-атрибуты",
				tr: "İşletme özellikleri",
				ja: "ビジネス属性",
			},
			cadd12: {
				zh: "请输入关键词",
				en: "Please enter a keyword",
				vi: "Vui lòng nhập từ khóa",
				ru: "Пожалуйста, введите ключевое слово",
				tr: "Lütfen bir anahtar kelime girin",
				ja: "キーワードを入力してください",
			},
			cadd13: {
				zh: "请输入设备名",
				en: "Please enter the device name",
				vi: "Vui lòng nhập tên thiết bị",
				ru: "Пожалуйста, введите название устройства",
				tr: "Lütfen cihaz adını girin",
				ja: "デバイス名を入力してください",
			},
			cadd14: {
				zh: "标题",
				en: "title",
				vi: "tiêu đề",
				ru: "название",
				tr: "başlık",
				ja: "タイトル",
			},
			cadd15: {
				zh: "未知错误",
				en: "unknown mistake",
				vi: "lỗi không xác định",
				ru: "неизвестно, ошибка",
				tr: "bilinmeyen hata",
				ja: "不明なエラー",
			},
			cadd16: {
				zh: "选择节目单",
				en: "Select program",
				vi: "Chọn chương trình",
				ru: "Выберите программу",
				tr: "Programı seç",
				ja: "プログラムを選択する",
			},
			cadd17: {
				zh: "选择设备",
				en: "Select device",
				vi: "Chọn thiết bị",
				ru: "Выберите устройство",
				tr: "Cihazı seçin",
				ja: "デバイスの選択",
			}
		},
		caa1: {
			zh: "请输入搜索关键词",
			en: "Enter search keywords",
			vi: "Nhập từ khóa tìm kiếm",
			ru: "Введите ключевые слова для поиск",
			tr: "Arama anahtar kelimelerini girin",
			ja: "検索キーワードを入力してください",
		},
		caa2: {
			zh: "未搜索到地址信息",
			en: "No address information found",
			vi: "Không tìm thấy thông tin địa chỉ",
			ru: "Адресная информация не найдена",
			tr: "Adres bilgisi bulunamadı",
			ja: "アドレス情報が見つかりませんでした",
		},
		caa3: {
			zh: "收起搜索结果",
			en: "Collapse Search Results",
			vi: "Thu gọn kết quả tìm kiếm",
			ru: "Свернуть результаты поиска",
			tr: "Arama Sonuçlarını Daralt",
			ja: "検索結果を閉じる",
		},
		caa4: {
			zh: "详细地址：",
			en: "Address:",
			vi: "Địa chỉ",
			ru: "Адрес:",
			tr: "Adres:",
			ja: "詳しい住所:",
		},
		caa5: {
			zh: "经度：",
			en: "longitude:",
			vi: "kinh độ",
			ru: "долгота:",
			tr: "boylam:",
			ja: "経度:",
		},
		caa6: {
			zh: "纬度：",
			en: "latitude:",
			vi: "vĩ độ",
			ru: "широта:",
			tr: "enlem:",
			ja: "緯度:",
		},
		caa7: {
			zh: "请在地图上选择设备所在地",
			en: "Please select the location of the device on the map",
			vi: "Vui lòng chọn vị trí của thiết bị trên bản đồ",
			ru: "Пожалуйста, выберите местоположение устройства на карте",
			tr: "Lütfen cihazın haritadaki konumunu seçin",
			ja: "地図上で設備の所在地を選択してください",
		},
		caa8: {
			zh: "一号设备",
			en: "Equipment No. 1",
			vi: "Thiết bị số 1",
			ru: "Оборудование № 1",
			tr: "Ekipman No.1",
			ja: "第1号設備",
		},
		caa9: {
			zh: "高德地图信息错误",
			en: "Amap information error",
			vi: "Lỗi thông tin Amap",
			ru: "Ошибка в информации Amap",
			tr: "Amap bilgi hatası",
			ja: "ゴールドマップ情報エラー",
		},
		caa10: {
			zh: "所选地址非精确坐标点，请重新选择",
			en: "The selected address is not an accurate coordinate point, please reselect",
			vi: "Địa chỉ đã chọn không phải là điểm tọa độ chính xác, vui lòng chọn lại",
			ru: "Выбранный адрес не соответствует точным координатам, пожалуйста, выберите его повторно",
			tr: "Seçilen adres doğru bir koordinat noktası değil, lütfen yeniden seçin",
			ja: "選択したアドレスは正確ではありません。再度選択してください",
		}
	},
	basics: {
		AddDialog: {
			cba1: {
				zh: "标 题",
				en: "Title",
				vi: "Tiêu đề",
				ru: "Заглавие",
				tr: "Başlık",
				ja: "タイトル",
			}
		},
		DateSet: {
			cbb1: {
				zh: "执行时间",
				en: "execution time",
				vi: "thời gian thực hiện",
				ru: "Время выполнения",
				tr: "yürütme süresi",
				ja: "実行時間",
			},
			cbb2: {
				zh: "日期",
				en: "date",
				vi: "ngày",
				ru: "дату",
				tr: "tarih",
				ja: "日付",
			},
			cbb3: {
				zh: "选择日期",
				en: "Select Date",
				vi: "Chọn ngày",
				ru: "Выберите дату",
				tr: "Tarih Seçin",
				ja: "日付を選択する",
			},
			cbb4: {
				zh: "至",
				en: "to",
				vi: "Đến",
				ru: "до",
				tr: "ile",
				ja: "至",
			},
			cbb5: {
				zh: "每周",
				en: "weekly",
				vi: "hàng tuần",
				ru: "каждая неделя",
				tr: "haftalık",
				ja: "毎週",
			}
		},
		Trees: {
			cbt1: {
				zh: "请输入关键字",
				en: "Please enter key words",
				vi: "Vui lòng nhập từ khóa",
				ru: "Пожалуйста, введите ключевые слова",
				tr: "Lütfen anahtar kelimeleri girin",
				ja: "キーワードを入力してください",
			},
			cbt2: {
				zh: "获取全部资源",
				en: "Get all resources",
				vi: "Nhận tất cả các nguồn",
				ru: "Получить все ресурсы",
				tr: "Tüm kaynakları alın",
				ja: "すべてのリソースを取得",
			},
			cbt3: {
				zh: "获取全部类型",
				en: "Get all types",
				vi: "Nhận tất cả các loại",
				ru: "Получить все типы",
				tr: "Tüm türleri alın",
				ja: "すべてのタイプを取得",
			},
			cbt4: {
				zh: "删除",
				en: "Delete",
				vi: "xóa bỏ",
				ru: "удалить",
				tr: "silmek",
				ja: "削除",
			},
			cbt5: {
				zh: "重命名",
				en: "Rename",
				vi: "Đổi tên",
				ru: "Переименовать",
				tr: "Yeniden isimlendirmek",
				ja: "名前の変更",
			}
		},
		UploadingList: {
			cbu1: {
				zh: "终端名称",
				en: "Terminal Name",
				vi: "Tên thiết bị đầu cuối",
				ru: "Название терминала",
				tr: "Terminal Adı",
				ja: "端末名",
			},
			cbu2: {
				zh: "发布进度",
				en: "Release progress",
				vi: "Tiến độ phát hành",
				ru: "Ход выпуска",
				tr: "Sürüm ilerlemesi",
				ja: "リリースの進捗",
			},
			cbu3: {
				zh: "状态",
				en: "state",
				vi: "trạng thái",
				ru: "состояние",
				tr: "durum",
				ja: "状態",
			},
			cbu4: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать",
				tr: "işletmek",
				ja: "操作",
			},
			cbu5: {
				zh: "节目名称",
				en: "Name of programme",
				vi: "Tên chương trình",
				ru: "Название программы",
				tr: "Programın adı",
				ja: "番組名",
			},
			cbu6: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "Разрешение:",
				tr: "Çözünürlük",
				ja: "解像度",
			},
			cbu7: {
				zh: "节目时长",
				en: "Duration",
				vi: "Thời lượng chương trình",
				ru: "Длительность",
				tr: "Program süresi",
				ja: "番組時間",
			}
		}
	},
	device: {
		children: {
			AcquisitionDevice: {
				cdca1: {
					zh: "服务器列表",
					en: "server list",
					vi: "danh sách máy chủ",
					ru: "список серверов",
					tr: "sunucu listesi",
					ja: "サーバーのリスト",
				},
				cdca2: {
					zh: "获取设备",
					en: "Get the device",
					vi: "Nhận thiết bị",
					ru: "Получить устройство",
					tr: "Cihazı alın",
					ja: "デバイスの取得",
				},
				cdca3: {
					zh: "确定",
					en: "Sure",
					vi: "Chắc chắn",
					ru: "уверенный",
					tr: "Elbette",
					ja: "を選択して、",
				},
				cdca4: {
					zh: "序号",
					en: "Serial number",
					vi: "Số seri",
					ru: "Серийный номер",
					tr: "Seri numarası",
					ja: "シーケンス番号",
				},
				cdca5: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Имя устройства:",
					tr: "Cihaz Adı",
					ja: "デバイス名",
				},
				cdca6: {
					zh: "位置",
					en: "Location",
					vi: "Vị trí",
					ru: "Местоположение",
					tr: "Konum",
					ja: "位置",
				},
				cdca7: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "Разрешение:",
					tr: "Çözünürlük",
					ja: "解像度",
				},
				cdca8: {
					zh: "状态",
					en: "state",
					vi: "Trạng thái",
					ru: "состояние",
					tr: "durum",
					ja: "ステータス",
				},
				cdca9: {
					zh: "普通",
					en: "ordinary",
					vi: "bình thường",
					ru: "обычный",
					tr: "sıradan",
					ja: "標準",
				},
				cdca10: {
					zh: "已同步",
					en: "Synchronized",
					vi: "Đã đồng bộ hóa",
					ru: "Синхронизированный",
					tr: "senkronize",
					ja: "同期済み",
				},
				cdca11: {
					zh: "未同步",
					en: "Not synced",
					vi: "Chưa được đồng bộ hóa",
					ru: "Несинхронизированный",
					tr: "Senkronize edilmedi",
					ja: "非同期",
				}
			},
			ExportDialog: {
				cdce1: {
					zh: "导出日志",
					en: "Export logs",
					vi: "Xuất nhật ký",
					ru: "Экспорт журналов",
					tr: "Günlükleri dışa aktar",
					ja: "エクスポートログ",
				},
				cdce2: {
					zh: "日期范围：",
					en: "Date Range:",
					vi: "Phạm vi ngày",
					ru: "Диапазон дат:",
					tr: "Tarih Aralığı:",
					ja: "日付範囲：",
				},
				cdce3: {
					zh: "至",
					en: "to",
					vi: "ĐẾN",
					ru: "до",
					tr: "ile",
					ja: "終了",
				},
				cdce4: {
					zh: "开始日期",
					en: "start date",
					vi: "ngày bắt đầu",
					ru: "даты начала",
					tr: "başlangıç ​​tarihi",
					ja: "開始日",
				},
				cdce5: {
					zh: "结束日期",
					en: "End Date",
					vi: "Ngày cuối",
					ru: "Дата окончания",
					tr: "Bitiş Tarihi",
					ja: "終了日",
				},
				cdce6: {
					zh: "确定",
					en: "Sure",
					vi: "Chắc chắn",
					ru: "уверенный",
					tr: "Elbette",
					ja: "を選択して、",
				},
				cdce7: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "Отменить",
					tr: "İptal etmek",
					ja: "キャンセル",
				},
				cdce8: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Название устройства",
					tr: "Cihaz Adı",
					ja: "デバイス名",
				},
				cdce9: {
					zh: "设备SN",
					en: "Equipment SN",
					vi: "Thiết bị SN",
					ru: "оборудования SN",
					tr: "Ekipman SN'si",
					ja: "デバイスSN",
				},
				cdce10: {
					zh: "组织结构",
					en: "Groups",
					vi: "Cơ cấu tổ chức",
					ru: "Организационная структура",
					tr: "Organizasyon Yapısı",
					ja: "組織構造",
				},
				cdce11: {
					zh: "类型",
					en: "type",
					vi: "Loại",
					ru: "тип",
					tr: "tip",
					ja: "を選択してオプションを設定します。",
				},
				cdce12: {
					zh: "操作时间",
					en: "Operation time",
					vi: "Thời gian hoạt động",
					ru: "Время работы",
					tr: "Operasyon süresi",
					ja: "そうさじかん",
				},
				cdce13: {
					zh: "日志.xlsx",
					en: "Log.xlsx",
					vi: "Log.xlsx",
					ru: "журнал .xlsx",
					tr: "Log.xlsx",
					ja: "ログ.xlsx",
				}
			},
			KommanderDetails: {
				cdck1: {
					zh: "设备名称：",
					en: "Device Name:",
					vi: "Tên thiết bị",
					ru: "Имя устройства:",
					tr: "Cihaz Adı:",
					ja: "デバイス名：",
				},
				cdck2: {
					zh: "所属机构：",
					en: "Affiliation:",
					vi: "liên kết",
					ru: "Присоединение:",
					tr: "Üyelik:",
					ja: "所属機関：",
				},
				cdck3: {
					zh: "分辨率：",
					en: "Resolution:",
					vi: "Độ phân giải",
					ru: "Разрешение:",
					tr: "Çözünürlük:",
					ja: "解像度:",
				},
				cdck4: {
					zh: "运行状态：",
					en: "Operating status:",
					vi: "Trạng thái hoạt động",
					ru: "Рабочее состояние:",
					tr: "Çalışma durumu:",
					ja: "運転状態：",
				},
				cdck5: {
					zh: "最近心跳：",
					en: "Recent heartbeat:",
					vi: "Nhịp tim gần đây",
					ru: "Недавнее сердцебиение:",
					tr: "Son kalp atışı:",
					ja: "最近のハートビート：",
				},
				cdck6: {
					zh: "节目排期",
					en: "Program Schedule",
					vi: "Lập lịch trình chương trình",
					ru: "Расписание программы",
					tr: "Program Programı",
					ja: "番組のスケジュール",
				},
				cdck7: {
					zh: "节目名称",
					en: "Name of programme",
					vi: "Tên chương trình",
					ru: "Название программы",
					tr: "Programın adı",
					ja: "番組名",
				},
				cdck8: {
					zh: "有效日期",
					en: "Effective Date",
					vi: "Ngày có hiệu lực",
					ru: "дата вступления в силу",
					tr: "Yürürlük Tarihi",
					ja: "有効日",
				},
				cdck9: {
					zh: "有效星期",
					en: "Valid week",
					vi: "Tuần có hiệu lực",
					ru: "Действительная неделя",
					tr: "Geçerli hafta",
					ja: "有効週",
				},
				cdck10: {
					zh: "播放时间",
					en: "play time",
					vi: "Thời gian phát",
					ru: "Время игры",
					tr: "oyun zamanı",
					ja: "再生時間",
				},
				cdck11: {
					zh: "节目列表",
					en: "Programme list",
					vi: "Danh sách chương trình",
					ru: "Список программ",
					tr: "Program listesi",
					ja: "プログラムリスト",
				},
				cdck12: {
					zh: "序号",
					en: "Serial number",
					vi: "Số seri",
					ru: "Серийный номер",
					tr: "Seri numarası",
					ja: "シーケンス番号",
				},
				cdck13: {
					zh: "节目名称",
					en: "Name of programme",
					vi: "Tên chương trình",
					ru: "Название программы",
					tr: "Programın adı",
					ja: "番組名",
				},
				cdck14: {
					zh: "在播预览",
					en: "Preview on Play",
					vi: "Xem trước trên Play",
					ru: "Предварительный просмотр при воспроизведении",
					tr: "Play'de önizleme",
					ja: "プレビュー",
				},
				cdck15: {
					zh: "拼命加载中",
					en: "Loading",
					vi: "Đang tải",
					ru: "Погрузка",
					tr: "Yükleniyor",
					ja: "命がけでロード中",
				},
				cdck16: {
					zh: "暂无信号，请稍后再试!",
					en: "No signal, please try again later!",
					vi: "Không có tín hiệu, vui lòng thử lại sau!",
					ru: "Нет сигнала, пожалуйста, повторите попытку позже!",
					tr: "Sinyal yok, lütfen daha sonra tekrar deneyin!",
					ja: "しばらく信号がありません。後で試してください。",
				},
				cdck17: {
					zh: "离线",
					en: "Offline",
					vi: "Offline",
					ru: "Не в сети",
					tr: "Çevrimdışı",
					ja: "オフライン",
				},
				cdck18: {
					zh: "节目排期",
					en: "Program Schedule",
					vi: "Lập lịch trình chương trình",
					ru: "Расписание программы",
					tr: "Program Programı",
					ja: "番組のスケジュール",
				},
				cdck19: {
					zh: "节目列表",
					en: "Programme list",
					vi: "Danh sách chương trình",
					ru: "Список программ",
					tr: "Program listesi",
					ja: "プログラムリスト",
				},
				cdck20: {
					zh: "在播预览",
					en: "Preview on Play",
					vi: "Xem trước trên Play",
					ru: "Предварительный просмотр при воспроизведении",
					tr: "Play'de önizleme",
					ja: "プレビュー",
				}
			},
			PandoraDetails: {
				cdcp1: {
					zh: "音量",
					en: "volume",
					vi: "âm lượng",
					ru: "громкость:",
					tr: "hacim",
					ja: "音量",
				},
				cdcp2: {
					zh: "亮度",
					en: "brightness",
					vi: "độ sáng",
					ru: "яркость",
					tr: "parlaklık",
					ja: "きど",
				},
				cdcp3: {
					zh: "节目排期",
					en: "Program Schedule",
					vi: "Lập lịch trình chương trình",
					ru: "Расписание программы",
					tr: "Program Programı",
					ja: "番組のスケジュール",
				},
				cdcp4: {
					zh: "节目名称",
					en: "Name of programme",
					vi: "Tên chương trình",
					ru: "Название программы",
					tr: "Programın adı",
					ja: "番組名",
				},
				cdcp5: {
					zh: "指令等级",
					en: "Instruction level",
					vi: "Cấp độ hướng dẫn",
					ru: "Уровень обучения",
					tr: "Talimat seviyesi",
					ja: "めいれいレベル",
				},
				cdcp6: {
					zh: "执行时间",
					en: "execution time",
					vi: "thời gian thực hiện",
					ru: "время выполнения",
					tr: "yürütme süresi",
					ja: "じっこうじかん",
				},
				cdcp7: {
					zh: "有效日期",
					en: "Effective Date",
					vi: "Ngày có hiệu lực",
					ru: "дата вступления в силу",
					tr: "Yürürlük Tarihi",
					ja: "有効日",
				},
				cdcp8: {
					zh: "有效星期",
					en: "Valid week",
					vi: "Tuần có hiệu lực",
					ru: "Действительная неделя",
					tr: "Geçerli hafta",
					ja: "有効週",
				},
				cdcp9: {
					zh: "连播次数",
					en: "Number of consecutive broadcasts",
					vi: "Số lần phát sóng liên tiếp",
					ru: "Количество последовательных передач",
					tr: "Ardışık yayın sayısı",
					ja: "れんぞくかいすう",
				},
				cdcp10: {
					zh: "节目列表",
					en: "Programme list",
					vi: "Danh sách chương trình",
					ru: "Список программ",
					tr: "Program listesi",
					ja: "プログラムリスト",
				},
				cdcp11: {
					zh: "序号",
					en: "Serial number",
					vi: "Số seri",
					ru: "Серийный номер",
					tr: "Seri numarası",
					ja: "シーケンス番号",
				},
				cdcp12: {
					zh: "截屏",
					en: "screenshot",
					vi: "ảnh chụp màn hình",
					ru: "скриншот",
					tr: "ekran görüntüsü",
					ja: "スクリーン枚",
				},
				cdcp13: {
					zh: "操作指令",
					en: "Operation Instructions",
					vi: "Hướng dẫn vận hành",
					ru: "Инструкции по эксплуатации",
					tr: "Çalıştırma Talimatları",
					ja: "オペレーション命令",
				},
				cdcp14: {
					zh: "值",
					en: "value",
					vi: "giá trị",
					ru: "ценность",
					tr: "değer",
					ja: "値＃アタイ＃",
				},
				cdcp15: {
					zh: "执行时间",
					en: "execution time",
					vi: "thời gian thực hiện",
					ru: "время выполнения",
					tr: "yürütme süresi",
					ja: "じっこうじかん",
				},
				cdcp16: {
					zh: "设备ID",
					en: "Device ID",
					vi: "ID thiết bị",
					ru: "Идентификатор устройства",
					tr: "Cihaz Kimliği",
					ja: "デバイスID",
				},
				cdcp17: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Имя устройства:",
					tr: "Cihaz Adı",
					ja: "デバイス名",
				},
				cdcp18: {
					zh: "所属机构",
					en: "Affiliation",
					vi: "liên kết",
					ru: "Присоединение:",
					tr: "Üyelik",
					ja: "所属機関",
				},
				cdcp19: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "Разрешение:",
					tr: "Çözünürlük",
					ja: "解像度",
				},
				cdcp20: {
					zh: "屏幕类型",
					en: "Screen type",
					vi: "Loại màn hình",
					ru: "Тип экрана",
					tr: "Ekran tipi",
					ja: "画面タイプ",
				},
				cdcp21: {
					zh: "业务类型",
					en: "business type",
					vi: "Loại hình nghiệp vụ",
					ru: "тип бизнеса",
					tr: "iş türü",
					ja: "ビジネス・タイプ",
				},
				cdcp22: {
					zh: "开屏时间",
					en: "Screen time",
					vi: "Thời gian sử dụng màn hình",
					ru: "Экранное время",
					tr: "Ekran süresi",
					ja: "かいめんじかん",
				},
				cdcp23: {
					zh: "关屏时间",
					en: "Screen off time",
					vi: "Thời gian tắt màn hình",
					ru: "Время выключения экрана",
					tr: "Ekran kapanma süresi",
					ja: "スクリーンオフ時間",
				},
				cdcp24: {
					zh: "内存空间",
					en: "Memory space",
					vi: "Không gian bộ nhớ",
					ru: "Объем памяти:",
					tr: "Bellek alanı",
					ja: "メモリ容量",
				},
				cdcp25: {
					zh: "版本号",
					en: "version number",
					vi: "số phiên bản",
					ru: "номер версии:",
					tr: "sürüm numarası",
					ja: "バージョン番号",
				},
				cdcp26: {
					zh: "运行状态",
					en: "Operating status",
					vi: "Trạng thái hoạt động",
					ru: "Рабочее состояние:",
					tr: "Çalışma durumu",
					ja: "運転状態",
				},
				cdcp27: {
					zh: "连续运行",
					en: "continue to operate",
					vi: "tiếp tục hoạt động",
					ru: "продолжайте работать",
					tr: "çalışmaya devam et",
					ja: "れんぞくうんてん",
				},
				cdcp28: {
					zh: "盒子时钟",
					en: "Box Clock",
					vi: "Đồng hồ hộp",
					ru: "Часы-шкатулка",
					tr: "Kutu Saati",
					ja: "箱時計",
				},
				cdcp29: {
					zh: "IP地址",
					en: "IP address",
					vi: "địa chỉ IP",
					ru: "ip-адрес",
					tr: "IP adresi",
					ja: "IPアドレス",
				},
				cdcp30: {
					zh: "最近心跳",
					en: "Recent heartbeat",
					vi: "Nhịp tim gần đây",
					ru: "Недавнее сердцебиение",
					tr: "Son kalp atışı",
					ja: "最近のハートビート",
				},
				cdcp31: {
					zh: "音量",
					en: "volume",
					vi: "âm lượng",
					ru: "громкость",
					tr: "hacim",
					ja: "音量",
				},
				cdcp32: {
					zh: "亮度",
					en: "brightness",
					vi: "độ sáng",
					ru: "яркость",
					tr: "parlaklık",
					ja: "きど",
				},
				cdcp33: {
					zh: "未设置日期",
					en: "No date set",
					vi: "Không có ngày nào được thiết lập",
					ru: "Дата не установлена",
					tr: "Tarih belirlenmedi",
					ja: "日付が設定されていません",
				},
				cdcp34: {
					zh: "未设置星期",
					en: "Day of the week not set",
					vi: "Không có ngày nào trong tuần được thiết lập",
					ru: "Неделя не установлена",
					tr: "Haftanın günü belirlenmedi",
					ja: "曜日が設定されていません",
				},
				cdcp35: {
					zh: "在线",
					en: "Online",
					vi: "Online",
					ru: "онлайн",
					tr: "Çevrimiçi",
					ja: "オンライン",
				},
				cdcp36: {
					zh: "离线",
					en: "Offline",
					vi: "Offline",
					ru: "не в сети",
					tr: "Çevrimdışı",
					ja: "オフライン",
				},
				cdcp37: {
					zh: "未设置",
					en: "Not set",
					vi: "Không được thiết lập",
					ru: "Не установлен",
					tr: "Ayarlanmadı",
					ja: "未設定",
				},
				cdcp38: {
					zh: "设备离线-暂无数据",
					en: "Device offline - no data",
					vi: "Thiết bị ngoại tuyến - không có dữ liệu",
					ru: "Устройство находится в автономном режиме - данные недоступны",
					tr: "Cihaz çevrimdışı - veri yok",
					ja: "デバイスがオフライン-データが一時的に存在しない",
				},
				cdcp39: {
					zh: "亮度调节",
					en: "Dimming",
					vi: "Điều chỉnh độ sáng",
					ru: "Регулировка яркости",
					tr: "Karartma",
					ja: "きどちょうせい",
				},
				cdcp40: {
					zh: "音量调节",
					en: "Volume adjustment",
					vi: "Điều chỉnh âm lượng",
					ru: "Регулировка громкости",
					tr: "Ses ayarı",
					ja: "音量調節",
				},
				cdcp41: {
					zh: "关闭屏幕",
					en: "Screen off",
					vi: "Tắt màn hình",
					ru: "Выключите экран",
					tr: "Ekranı kapat",
					ja: "画面を閉じる",
				},
				cdcp42: {
					zh: "开启屏幕",
					en: "Screen on",
					vi: "Bật màn hình",
					ru: "Включите экран",
					tr: "Ekranı aç",
					ja: "画面を開く",
				},
				cdcp43: {
					zh: "无状态",
					en: "no status",
					vi: "không có trạng thái",
					ru: "Без гражданства",
					tr: "durum yok",
					ja: "ステータスなし",
				}
			}
		},
		TerminalControl: {
			cdt1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			},
			cdt2: {
				zh: "命令菜单",
				en: "Command Menu",
				vi: "Menu lệnh",
				ru: "Командное меню",
				tr: "Komut Menüsü",
				ja: "コマンドメニュー",
			},
			cdt3: {
				zh: "在线：",
				en: "Online:",
				vi: "Online",
				ru: "онлайн：",
				tr: "Çevrimiçi:",
				ja: "オンライン：",
			},
			cdt4: {
				zh: "离线：",
				en: "Offline:",
				vi: "Offline",
				ru: "не в сети：",
				tr: "Çevrimdışı:",
				ja: "オフライン：",
			},
			cdt5: {
				zh: "请输入查询内容",
				en: "Please enter your query",
				vi: "Vui lòng nhập truy vấn của bạn",
				ru: "Пожалуйста, введите содержание запроса",
				tr: "Lütfen sorgunuzu girin",
				ja: "クエリーの内容を入力してください",
			},
			cdt6: {
				zh: "终端名称",
				en: "Terminal Name",
				vi: "Tên thiết bị đầu cuối",
				ru: "Название терминала",
				tr: "Terminal Adı",
				ja: "ターミナル名",
			},
			cdt7: {
				zh: "备注",
				en: "Remark",
				vi: "Nhận xét",
				ru: "Замечания",
				tr: "Açıklama",
				ja: "コメント",
			},
			cdt8: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cdt9: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Nghị quyết",
				ru: "разрешение",
				tr: "Çözünürlük",
				ja: "解像度",
			},
			cdt10: {
				zh: "状态",
				en: "state",
				vi: "tình trạng",
				ru: "состояние",
				tr: "durum",
				ja: "ステータス",
			},
			cdt11: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать",
				tr: "işletmek",
				ja: "操作",
			},
			cdt12: {
				zh: "提示",
				en: "hint",
				vi: "gợi ý",
				ru: "подсказка",
				tr: "ipucu",
				ja: "ヒント",
			},
			cdt13: {
				zh: "紧急插播",
				en: "Emergency Interruption",
				vi: "Gián đoạn khẩn cấp",
				ru: "Экстренный интерстициальный",
				tr: "Acil Durum Kesintisi",
				ja: "緊急補間",
			},
			cdt14: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять",
				tr: "İptal etmek",
				ja: "キャンセル",
			},
			cdt15: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять",
				tr: "Elbette",
				ja: "を選択して、",
			},
			cdt16: {
				zh: "控制筛选",
				en: "Control Filter",
				vi: "Bộ lọc điều khiển",
				ru: "Контрольная фильтрация",
				tr: "Kontrol Filtresi",
				ja: "フィルタの制御",
			},
			cdt17: {
				zh: "全选",
				en: "select all",
				vi: "chọn tất cả",
				ru: "Выбрать все",
				tr: "tümünü seç",
				ja: "すべて選択",
			},
			cdt18: {
				zh: "添加排程",
				en: "Add Schedule",
				vi: "Thêm lịch trình",
				ru: "Добавить расписание",
				tr: "Program Ekle",
				ja: "スケジュールの追加",
			},
			cdt19: {
				zh: "请选择模板",
				en: "Please select a template",
				vi: "Vui lòng chọn một mẫu",
				ru: "Пожалуйста, выберите шаблон",
				tr: "Lütfen bir şablon seçin",
				ja: "テンプレートを選択してください",
			},
			cdt20: {
				zh: "切换模板时请保存修改，否则将会丢失修改！",
				en: "Please save your changes when switching templates, otherwise they will be lost!",
				vi: "Vui lòng lưu các thay đổi của bạn khi chuyển đổi mẫu, nếu không chúng sẽ bị mất!",
				ru: "Пожалуйста, сохраняйте изменения при переключении шаблонов, иначе они будут потеряны!",
				tr: "Lütfen şablonları değiştirirken değişikliklerinizi kaydedin, aksi takdirde kaybolacaklardır!",
				ja: "テンプレートを切り替えるときは修正を保存してください。そうしないと修正が失われます！",
			},
			cdt21: {
				zh: "请选择模板或创建新的模板后，添加排程！",
				en: "Please select a template or create a new one, then add a schedule!",
				vi: "Vui lòng chọn mẫu hoặc tạo mẫu mới, sau đó thêm lịch trình!",
				ru: "Пожалуйста, выберите шаблон или создайте новый шаблон, чтобы добавить расписание!",
				tr: "Lütfen bir şablon seçin veya yeni bir şablon oluşturun ve ardından bir program ekleyin!",
				ja: "テンプレートを選択するか、新しいテンプレートを作成したら、スケジュールを追加してください！",
			},
			cdt22: {
				zh: "操作指令",
				en: "Operation Instructions",
				vi: "Hướng dẫn vận hành",
				ru: "Инструкции по эксплуатации",
				tr: "Çalıştırma Talimatları",
				ja: "オペレーション命令",
			},
			cdt23: {
				zh: "设置值",
				en: "Settings",
				vi: "Cài đặt",
				ru: "Установленное значение",
				tr: "Ayarlar",
				ja: "設定値",
			},
			cdt24: {
				zh: "执行时间",
				en: "execution time",
				vi: "thời gian thực hiện",
				ru: "Время выполнения",
				tr: "yürütme süresi",
				ja: "じっこうじかん",
			},
			cdt25: {
				zh: "有效日期",
				en: "Effective Date",
				vi: "Ngày có hiệu lực",
				ru: "Дата вступления в силу",
				tr: "Yürürlük Tarihi",
				ja: "有効日",
			},
			cdt26: {
				zh: "有限制",
				en: "limited",
				vi: "giới hạn",
				ru: "ограниченный",
				tr: "sınırlı",
				ja: "制限あり",
			},
			cdt27: {
				zh: "创建模板",
				en: "Create a template",
				vi: "Tạo một mẫu",
				ru: "Создать шаблон",
				tr: "Şablon oluştur",
				ja: "テンプレートの作成",
			},
			cdt28: {
				zh: "保存模板",
				en: "Save Template",
				vi: "Lưu mẫu",
				ru: "Сохранить шаблон",
				tr: "Şablonu Kaydet",
				ja: "テンプレートの保存",
			},
			cdt29: {
				zh: "发送排程",
				en: "Send Schedule",
				vi: "Gửi lịch trình",
				ru: "Расписание отправки",
				tr: "Plan Gönder",
				ja: "送信スケジュール",
			},
			cdt30: {
				zh: "取消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять",
				tr: "İptal etmek",
				ja: "キャンセル",
			},
			cdt31: {
				zh: "创建排程模板",
				en: "Create a schedule template",
				vi: "Tạo mẫu lịch trình",
				ru: "Создайте шаблон планирования",
				tr: "Zamanlama şablonu oluşturma",
				ja: "スケジュールテンプレートの作成",
			},
			cdt32: {
				zh: "模板名称",
				en: "Template Name",
				vi: "Tên mẫu",
				ru: "Имя шаблона",
				tr: "Şablon Adı",
				ja: "テンプレート名",
			},
			cdt33: {
				zh: "新增定时指令",
				en: "Added timing instructions",
				vi: "Đã thêm hướng dẫn về thời gian",
				ru: "Добавлена команда синхронизации",
				tr: "Zamanlama talimatları eklendi",
				ja: "新規タイミング命令",
			},
			cdt34: {
				zh: "操作指令",
				en: "Operation Instructions",
				vi: "Hướng dẫn vận hành",
				ru: "Инструкции по эксплуатации",
				tr: "Çalıştırma Talimatları",
				ja: "オペレーション命令",
			},
			cdt35: {
				zh: "请选择指令",
				en: "Please select the command",
				vi: "Hãy chọn lệnh",
				ru: "Пожалуйста, выберите инструкцию",
				tr: "Lütfen komutu seçin",
				ja: "命令を選択してください",
			},
			cdt36: {
				zh: "请设置屏幕操作时间",
				en: "Please set the screen time",
				vi: "Vui lòng đặt thời gian sử dụng màn hình",
				ru: "Пожалуйста, установите время работы экрана",
				tr: "Lütfen ekran süresini ayarlayın",
				ja: "スクリーン操作時間を設定してください",
			},
			cdt37: {
				zh: "紧急停止",
				en: "emergency stop",
				vi: "dừng khẩn cấp",
				ru: "аварийная остановка",
				tr: "acil durdurma",
				ja: "非常停止",
			},
			cdt38: {
				zh: "紧急插播",
				en: "Emergency Interruption",
				vi: "Gián đoạn khẩn cấp",
				ru: "Экстренный интерстициальный",
				tr: "Acil Durum Kesintisi",
				ja: "緊急補間",
			},
			cdt39: {
				zh: "添加排程",
				en: "Add Schedule",
				vi: "Thêm lịch trình",
				ru: "Добавить расписание",
				tr: "Program Ekle",
				ja: "スケジュールの追加",
			},
			cdt40: {
				zh: "重新启动",
				en: "Restart",
				vi: "Khởi động lại",
				ru: "перезапустить",
				tr: "Tekrar başlat",
				ja: "再起動",
			},
			cdt41: {
				zh: "开启屏幕",
				en: "Screen on",
				vi: "Bật màn hình",
				ru: "Включите экран",
				tr: "Ekranı aç",
				ja: "画面を開く",
			},
			cdt42: {
				zh: "关闭屏幕",
				en: "Screen off ",
				vi: "Tắt màn hình",
				ru: "Выключите экран",
				tr: "Ekranı kapat",
				ja: "画面を閉じる",
			},
			cdt43: {
				zh: "亮度调节",
				en: "Dimming",
				vi: "Điều chỉnh độ sáng",
				ru: "Регулировка яркости",
				tr: "Karartma",
				ja: "きどちょうせい",
			},
			cdt44: {
				zh: "音量调节",
				en: "Volume adjustment",
				vi: "Điều chỉnh âm lượng",
				ru: "Регулировка громкости",
				tr: "Ses ayarı",
				ja: "音量調節",
			},
			cdt45: {
				zh: "设备尺寸",
				en: "Equipment size",
				vi: "Kích thước thiết bị",
				ru: "Размер оборудования",
				tr: "Ekipman boyutu",
				ja: "デバイスサイズ",
			},
			cdt46: {
				zh: "设备状态",
				en: "device status",
				vi: "trạng thái thiết bị",
				ru: "Состояние устройства",
				tr: "cihaz durumu",
				ja: "デバイスの状態",
			},
			cdt47: {
				zh: "在线",
				en: "Online",
				vi: "Trực tuyến",
				ru: "онлайн",
				tr: "Çevrimiçi",
				ja: "オンライン",
			},
			cdt48: {
				zh: "离线",
				en: "Offline",
				vi: "Ngoại tuyến",
				ru: "не в сети",
				tr: "Çevrimdışı",
				ja: "オフライン",
			},
			cdt49: {
				zh: "设备已紧急停止！",
				en: "The equipment has stopped urgently!",
				vi: "Thiết bị đã dừng khẩn cấp!",
				ru: "Оборудование было срочно остановлено!",
				tr: "Ekipman acilen durduruldu!",
				ja: "設備が緊急停止しました！",
			},
			cdt50: {
				zh: "请选择终端设备！",
				en: "Please select the terminal device!",
				vi: "Vui lòng chọn thiết bị đầu cuối!",
				ru: "Пожалуйста, выберите оконечное устройство!",
				tr: "Lütfen terminal cihazını seçin!",
				ja: "端末を選んでください！",
			},
			cdt51: {
				zh: "设备已重新启动！",
				en: "The device has restarted!",
				vi: "Thiết bị đã khởi động lại!",
				ru: "Устройство было перезапущено!",
				tr: "Cihaz yeniden başlatıldı!",
				ja: "デバイスが再起動しました！",
			},
			cdt52: {
				zh: "创建排程模板成功！",
				en: "The scheduling template was created successfully!",
				vi: "Mẫu lịch trình đã được tạo thành công!",
				ru: "Создание шаблона планирования прошло успешно!",
				tr: "Planlama şablonu başarıyla oluşturuldu!",
				ja: "スケジュールテンプレートの作成に成功しました！",
			},
			cdt53: {
				zh: "定时指令开始时间不可以大于结束时间",
				en: "The start time of the timing instruction cannot be greater than the end time",
				vi: "Thời gian bắt đầu của lệnh tính giờ không thể lớn hơn thời gian kết thúc",
				ru: "Время начала выполнения команды синхронизации не может быть больше времени окончания",
				tr: "Zamanlama komutunun başlangıç ​​zamanı bitiş zamanından büyük olamaz",
				ja: "タイミング指令開始時間は終了時間より大きくしてはならない",
			},
			cdt54: {
				zh: "此操作将永久删除该模板, 是否继续?",
				en: "This operation will permanently delete the template, do you want to continue?",
				vi: "Thao tác này sẽ xóa vĩnh viễn mẫu, bạn có muốn tiếp tục không?",
				ru: "Эта операция приведет к необратимому удалению шаблона, будет ли она продолжена?",
				tr: "Bu işlem şablonu kalıcı olarak silecek, devam etmek istiyor musunuz?",
				ja: "この操作はテンプレートを永久に削除します。続行しますか？",
			},
			cdt55: {
				zh: "提示",
				en: "hint",
				vi: "gợi ý",
				ru: "подсказка",
				tr: "ipucu",
				ja: "ヒント",
			},
			cdt56: {
				zh: "删除成功",
				en: "successfully deleted",
				vi: "đã xóa thành công",
				ru: "Успешно удален",
				tr: "başarıyla silindi",
				ja: "削除に成功しました",
			},
			cdt57: {
				zh: "模板保存成功!",
				en: "Template saved successfully!",
				vi: "Đã lưu mẫu thành công!",
				ru: "Шаблон был успешно сохранен!",
				tr: "Şablon başarıyla kaydedildi!",
				ja: "テンプレートの保存に成功しました！",
			},
			cdt58: {
				zh: "未选中任何设备",
				en: "No devices selected",
				vi: "Không có thiết bị nào được chọn",
				ru: "Устройство не выбрано",
				tr: "Hiçbir cihaz seçilmedi",
				ja: "デバイスが選択されていません",
			},
			cdt59: {
				zh: "group_id不存在!",
				en: "group_id does not exist!",
				vi: "nhóm_id không tồn tại!",
				ru: "идентификатор_группы не существует!",
				tr: "",
				ja: "group _ idは存在しません！",
			}
		},
		TerminalLog__beifen: {
			cdtb1: {
				zh: "请输入关键字",
				en: "Please enter key words",
				vi: "Vui lòng nhập từ khóa",
				ru: "Пожалуйста, введите ключевые слова",
				tr: "Lütfen anahtar kelimeleri girin",
				ja: "キーワードを入力してください",
			},
			cdtb2: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала",
				tr: "başlangıç ​​tarihi",
				ja: "開始日",
			},
			cdtb3: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания",
				tr: "Bitiş Tarihi",
				ja: "終了日",
			},
			cdtb4: {
				zh: "发布单号查询",
				en: "Release order number query",
				vi: "Truy vấn số thứ tự phát hành",
				ru: "Запрос на публикацию номера заказа",
				tr: "Sipariş numarası sorgusunu serbest bırak",
				ja: "発行番号照会",
			},
			cdtb5: {
				zh: "设备名称",
				en: "Device Name",
				vi: "Tên thiết bị",
				ru: "Имя устройства",
				tr: "Cihaz Adı",
				ja: "デバイス名",
			},
			cdtb6: {
				zh: "设备SN",
				en: "Equipment SN",
				vi: "Thiết bị SN",
				ru: "Оборудование SN",
				tr: "Ekipman SN'si",
				ja: "デバイスSN",
			},
			cdtb7: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cdtb8: {
				zh: "类型",
				en: "type",
				vi: "kiểu",
				ru: "тип",
				tr: "tip",
				ja: "を選択してオプションを設定します。",
			},
			cdtb9: {
				zh: "操作时间",
				en: "Operation time",
				vi: "Thời gian hoạt động",
				ru: "Время работы",
				tr: "Operasyon süresi",
				ja: "そうさじかん",
			},
			cdtb10: {
				zh: "操作用户",
				en: "Operation User",
				vi: "Người dùng thao tác",
				ru: "Действующий пользователь",
				tr: "Operasyon Kullanıcısı",
				ja: "操作ユーザー",
			},
			cdtb11: {
				zh: "功能",
				en: "Function",
				vi: "Chức năng",
				ru: "функция",
				tr: "İşlev",
				ja: "機能",
			},
			cdtb12: {
				zh: "描述",
				en: "describe",
				vi: "mô tả",
				ru: "описание",
				tr: "betimlemek",
				ja: "説明",
			},
			cdtb13: {
				zh: "确定...",
				en: "Sure...",
				vi: "Chắc chắn...",
				ru: "уверенный...",
				tr: "Elbette...",
				ja: "確定...",
			},
			cdtb14: {
				zh: "终端退出了",
				en: "The terminal exited",
				vi: "Thiết bị đầu cuối đã thoát",
				ru: "Терминал вышел из строя",
				tr: "Terminalden çıkıldı",
				ja: "端末が終了しました",
			},
			cdtb15: {
				zh: "退出",
				en: "quit",
				vi: "Thoát",
				ru: "выходить из",
				tr: "çıkış yapmak",
				ja: "終了",
			},
			cdtb16: {
				zh: "终端登录了",
				en: "Terminal logged in",
				vi: "Thiết bị đầu cuối đã đăng nhập",
				ru: "Терминал вошел в систему",
				tr: "Terminalde oturum açıldı",
				ja: "端末がログインしました",
			},
			cdtb17: {
				zh: "登录",
				en: "Log in",
				vi: "Đăng nhập",
				ru: "войти",
				tr: "Giriş yapmak",
				ja: "ログイン＃ログイン＃",
			},
			cdtb18: {
				zh: "操作日志",
				en: "Operation log",
				vi: "Nhật ký hoạt động",
				ru: "Журнал операций",
				tr: "Operasyon günlüğü",
				ja: "操作ログ",
			},
			cdtb19: {
				zh: "导出",
				en: "Export",
				vi: "Xuất",
				ru: "экспорт",
				tr: "İhracat",
				ja: "エクスポート＃エクスポート＃",
			}
		},
		TerminalLog: {
			cdtl1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			},
			cdtl2: {
				zh: "设备名称",
				en: "Device Name",
				vi: "Tên thiết bị",
				ru: "Имя устройства",
				tr: "Cihaz Adı",
				ja: "デバイス名",
			},
			cdtl3: {
				zh: "设备SN",
				en: "Equipment SN",
				vi: "Thiết bị SN",
				ru: "Оборудование SN",
				tr: "Ekipman SN'si",
				ja: "デバイスSN",
			},
			cdtl4: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cdtl5: {
				zh: "类型",
				en: "type",
				vi: "Loại",
				ru: "тип",
				tr: "tip",
				ja: "を選択してオプションを設定します。",
			},
			cdtl6: {
				zh: "操作时间",
				en: "Operation time",
				vi: "Thời gian hoạt động",
				ru: "Время работы",
				tr: "Operasyon süresi",
				ja: "そうさじかん",
			},
			cdtl7: {
				zh: "终端退出了",
				en: "The terminal exited",
				vi: "Thiết bị đầu cuối đã thoát",
				ru: "Терминал вышел из строя",
				tr: "Terminalden çıkıldı",
				ja: "端末が終了しました",
			},
			cdtl8: {
				zh: "退出",
				en: "quit",
				vi: "Thoát",
				ru: "выходить из",
				tr: "çıkış yapmak",
				ja: "終了",
			},
			cdtl9: {
				zh: "终端登录了",
				en: "Terminal logged in",
				vi: "Thiết bị đầu cuối đã đăng nhập",
				ru: "Терминал вошел в систему",
				tr: "Terminalde oturum açıldı",
				ja: "端末がログインしました",
			},
			cdtl10: {
				zh: "登录",
				en: "Log in",
				vi: "Đăng nhập",
				ru: "войти",
				tr: "Giriş yapmak",
				ja: "ログイン＃ログイン＃",
			}
		},
		TerminalManage: {
			cdtm1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			},
			cdtm2: {
				zh: "请选择设备",
				en: "Please select your device",
				vi: "Vui lòng chọn thiết bị của bạn",
				ru: "Пожалуйста, выберите устройство",
				tr: "Lütfen cihazınızı seçin",
				ja: "デバイスを選択してください",
			},
			cdtm3: {
				zh: "终端名称",
				en: "Terminal Name",
				vi: "Tên thiết bị đầu cuối",
				ru: "Название терминала",
				tr: "Terminal Adı",
				ja: "ターミナル名",
			},
			cdtm4: {
				zh: "设备类型",
				en: "Equipment type",
				vi: "Loại thiết bị",
				ru: "Тип устройства",
				tr: "Ekipman türü",
				ja: "デバイスタイプ",
			},
			cdtm5: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cdtm6: {
				zh: "备注信息-1",
				en: "Remarks-1",
				vi: "Nhận xét-1",
				ru: "Замечания-1",
				tr: "Açıklamalar-1",
				ja: "メモ情報-1",
			},
			cdtm7: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "разрешение",
				tr: "Çözünürlük",
				ja: "解像度",
			},
			cdtm8: {
				zh: "设备状态",
				en: "device status",
				vi: "trạng thái thiết bị",
				ru: "Состояние устройства",
				tr: "cihaz durumu",
				ja: "デバイスの状態",
			},
			cdtm9: {
				zh: "离线",
				en: "Offline",
				vi: "Ngoại tuyến",
				ru: "не в сети",
				tr: "Çevrimdışı",
				ja: "オフライン",
			},
			cdtm10: {
				zh: "请问是否要永久删除当前(选中)终端？",
				en: "Do you want to permanently delete the current (selected) terminal?",
				vi: "Bạn có muốn xóa vĩnh viễn thiết bị đầu cuối hiện tại (đã chọn) không?",
				ru: "Вы хотите навсегда удалить текущий (выбранный) терминал?",
				tr: "Geçerli (seçili) terminali kalıcı olarak silmek istiyor musunuz?",
				ja: "現在選択されている端末を永久に削除しますか？",
			},
			cdtm11: {
				zh: "当前没有选中任何需要删除的终端！",
				en: "There are currently no terminals selected for deletion!",
				vi: "Hiện tại không có thiết bị đầu cuối nào được chọn để xóa!",
				ru: "В данный момент не выбраны терминалы, которые необходимо удалить!",
				tr: "Şu anda silinmek üzere seçilmiş terminal yok!",
				ja: "削除する端末は現在選択されていません！",
			},
			cdtm12: {
				zh: "新增设备",
				en: "New Equipment",
				vi: "Thiết bị mới",
				ru: "Новое оборудование",
				tr: "Yeni Ekipman",
				ja: "新規デバイス",
			},
			cdtm13: {
				zh: "编辑设备",
				en: "Editing Devices",
				vi: "Chỉnh sửa thiết bị",
				ru: "Монтажное оборудование",
				tr: "Cihazları Düzenleme",
				ja: "デバイスの編集",
			},
			cdtm14: {
				zh: "设备名称",
				en: "Device Name",
				vi: "Tên thiết bị",
				ru: "Имя устройства",
				tr: "Cihaz Adı",
				ja: "デバイス名",
			},
			cdtm15: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cdtm16: {
				zh: "请选择组织结构",
				en: "Please select your organizational structure",
				vi: "Vui lòng chọn cơ cấu tổ chức của bạn",
				ru: "Пожалуйста, выберите организационную структуру",
				tr: "Lütfen organizasyon yapınızı seçin",
				ja: "組織構造を選択してください",
			},
			cdtm17: {
				zh: "分辨率",
				en: "Resolution",
				vi: "Độ phân giải",
				ru: "разрешение",
				tr: "Çözünürlük",
				ja: "解像度",
			},
			cdtm18: {
				zh: "请选择屏幕分辨率",
				en: "Please select screen resolution",
				vi: "Vui lòng chọn độ phân giải màn hình",
				ru: "Пожалуйста, выберите разрешение экрана",
				tr: "Lütfen ekran çözünürlüğünü seçin",
				ja: "画面解像度を選択してください",
			},
			cdtm19: {
				zh: "自定义",
				en: "customize",
				vi: "tùy chỉnh",
				ru: "настроить",
				tr: "özelleştirmek",
				ja: "カスタム＃カスタム＃",
			},
			cdtm20: {
				zh: "设备类型",
				en: "Equipment type",
				vi: "Loại thiết bị",
				ru: "Тип устройства",
				tr: "Ekipman türü",
				ja: "デバイスタイプ",
			},
			cdtm21: {
				zh: "请选择设备类型",
				en: "Please select device type",
				vi: "Vui lòng chọn loại thiết bị",
				ru: "Пожалуйста, выберите тип устройства",
				tr: "Lütfen cihaz tipini seçin",
				ja: "デバイスタイプを選択してください",
			},
			cdtm22: {
				zh: "请输入SN",
				en: "Please enter SN",
				vi: "Vui lòng nhập SN",
				ru: "Пожалуйста, введите SN",
				tr: "Lütfen SN'yi girin",
				ja: "SNを入力してください",
			},
			cdtm23: {
				zh: "位置",
				en: "Location",
				vi: "Vị trí",
				ru: "положение",
				tr: "Konum",
				ja: "位置",
			},
			cdtm24: {
				zh: "密匙",
				en: "Key",
				vi: "Phím",
				ru: "ключ",
				tr: "Anahtar",
				ja: "みつさじ",
			},
			cdtm25: {
				zh: "备注1",
				en: "Note 1",
				vi: "Lưu ý 1",
				ru: "Замечания 1",
				tr: "Not 1",
				ja: "メモ1",
			},
			cdtm26: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять",
				tr: "İptal etmek",
				ja: "キャンセル",
			},
			cdtm27: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять",
				tr: "Elbette",
				ja: "を選択して、",
			},
			cdtm28: {
				zh: "设备名称不能为空",
				en: "Device name cannot be empty",
				vi: "Tên thiết bị không được để trống",
				ru: "Имя устройства не может быть пустым",
				tr: "Cihaz adı boş olamaz",
				ja: "デバイス名を空にすることはできません",
			},
			cdtm29: {
				zh: "组织结构不能为空",
				en: "Organization structure cannot be empty",
				vi: "Cơ cấu tổ chức không được để trống",
				ru: "Организационная структура не может быть пустой",
				tr: "Organizasyon yapısı boş olamaz",
				ja: "組織構造を空にすることはできません",
			},
			cdtm30: {
				zh: "SN不能为空",
				en: "SN cannot be empty",
				vi: "SN không thể trống",
				ru: "SN не может быть пустым",
				tr: "SN boş olamaz",
				ja: "SNを空にすることはできません",
			},
			cdtm31: {
				zh: "屏幕分辨率不能为空",
				en: "Screen resolution cannot be empty",
				vi: "Độ phân giải màn hình không được để trống",
				ru: "Разрешение экрана не может быть пустым",
				tr: "Ekran çözünürlüğü boş olamaz",
				ja: "画面解像度を空にすることはできません",
			},
			cdtm32: {
				zh: "分辨率W为空",
				en: "Resolution W is empty",
				vi: "Độ phân giải W trống",
				ru: "Разрешение W пустое",
				tr: "Çözünürlük W boş",
				ja: "解像度WがNULL",
			},
			cdtm33: {
				zh: "分辨率H为空",
				en: "Resolution H is empty",
				vi: "Độ phân giải H trống",
				ru: "Разрешение H пустое",
				tr: "Çözünürlük H boş",
				ja: "解像度HがNULL",
			},
			cdtm34: {
				zh: "位置X为空",
				en: "Position X is empty",
				vi: "Vị trí X trống",
				ru: "Позиция X пуста",
				tr: "X konumu boş",
				ja: "位置Xが空です",
			},
			cdtm35: {
				zh: "位置Y为空",
				en: "Position Y is empty",
				vi: "Vị trí Y trống",
				ru: "Позиция Y пуста",
				tr: "Y konumu boş",
				ja: "位置Yが空です",
			}
		}
	},
	explorer: {
		NewMediaList: {
			FileItem: {
				cenf1: {
					zh: "文件名",
					en: "file name",
					vi: "tên tập tin",
					ru: "Имя файла",
					tr: "dosya adı",
					ja: "ファイル名",
				}
			},
			index: {
				ceni1: {
					zh: "新建文件夹",
					en: "new folder",
					vi: "thư mục mới",
					ru: "Создайте новую папку",
					tr: "yeni klasör",
					ja: "新規フォルダ",
				},
				ceni2: {
					zh: "删除选中文件",
					en: "Delete selected files",
					vi: "Xóa các tập tin đã chọn",
					ru: "Удалить выбранный файл",
					tr: "Seçilen dosyaları sil",
					ja: "選択したファイルを削除",
				},
				ceni3: {
					zh: "请选择目录",
					en: "Please select a directory",
					vi: "Vui lòng chọn một thư mục",
					ru: "Пожалуйста, выберите оглавление",
					tr: "Lütfen bir dizin seçin",
					ja: "ディレクトリを選択してください",
				},
				ceni4: {
					zh: "文件编辑",
					en: "File Editing",
					vi: "Chỉnh sửa tập tin",
					ru: "Редактирование файлов",
					tr: "Dosya Düzenleme",
					ja: "ファイル編集",
				},
				ceni5: {
					zh: "请输入内容",
					en: "Please enter content",
					vi: "Vui lòng nhập nội dung",
					ru: "Пожалуйста, введите содержание",
					tr: "Lütfen içeriği girin",
					ja: "内容を入力してください",
				},
				ceni6: {
					zh: "请输入文件夹名称",
					en: "Please enter a folder name",
					vi: "Vui lòng nhập tên thư mục",
					ru: "Пожалуйста, введите название папки",
					tr: "Lütfen bir klasör adı girin",
					ja: "フォルダ名を入力してください",
				},
				ceni7: {
					zh: "警告",
					en: "Warning",
					vi: "Cảnh báo",
					ru: "Предупреждение",
					tr: "Uyarı",
					ja: "警告"
				},
				ceni8: {
					zh: "严禁利用本平台上传、传播暴力恐怖、色情及违法等违规信息，一经发现，将严格按照相关法律法规进行处理。",
					en: "It is strictly prohibited to use this platform to upload or disseminate any violent, terrorist, pornographic or other illegal information. Once discovered, it will be dealt with in strict accordance with relevant laws and regulations.",
					vi: "Nghiêm cấm sử dụng nền tảng này để tải lên hoặc truyền bá bất kỳ thông tin bạo lực, khủng bố, khiêu dâm hoặc các thông tin vi phạm pháp luật khác. Một khi phát hiện, sẽ được xử lý theo đúng quy định của pháp luật có liên quan.",
					ru: "Строго запрещается использовать эту платформу для загрузки или распространения любой информации, связанной с насилием, терроризмом, порнографией или другими нарушениями закона. В случае обнаружения будет проведено строгое рассмотрение в соответствии с соответствующими законами и правилами.",
					tr: "Bu platformu, şiddet, terör, pornografi veya diğer yasadışı bilgileri yüklemek veya yaymak için kullanmak kesinlikle yasaktır. Tespit edilmesi halinde, ilgili yasa ve yönetmeliklere uygun olarak kesin şekilde işlem yapılacaktır.",
					ja: "本プラットフォームを利用して暴力、テロ、ポルノ、その他の違法情報をアップロード、拡散することは固く禁じられています。発見次第、関連法規に厳格に基づいて処理します。"
				}
			},
			MediaList: {
				cenm1: {
					zh: "视频",
					en: "video",
					vi: "Video",
					ru: "видео",
					tr: "video",
					ja: "ビデオ",
				},
				cenm2: {
					zh: "图片",
					en: "picture",
					vi: "hình ảnh",
					ru: "картинка",
					tr: "resim",
					ja: "画像",
				},
				cenm3: {
					zh: "文本",
					en: "text",
					vi: "chữ",
					ru: "текст",
					tr: "metin",
					ja: "テキスト",
				},
				cenm4: {
					zh: "未定义类型",
					en: "Undefined Type",
					vi: "Loại không xác định",
					ru: "Тип не определен",
					tr: "Tanımsız Tür",
					ja: "タイプが定義されていません",
				}
			}
		},
		MediaList: {
			cem1: {
				zh: "名称",
				en: "name",
				vi: "tên",
				ru: "название",
				tr: "isim",
				ja: "の名前をあげる",
			},
			cem2: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cem3: {
				zh: "目录结构",
				en: "Directory Structure",
				vi: "Cấu trúc thư mục",
				ru: "Структура каталогов",
				tr: "Dizin Yapısı",
				ja: "ディレクトリ構造",
			},
			cem4: {
				zh: "类型",
				en: "type",
				vi: "Loại",
				ru: "тип",
				tr: "tip",
				ja: "を選択してオプションを設定します。",
			},
			cem5: {
				zh: "文件尺寸",
				en: "File size",
				vi: "Kích thước tập tin",
				ru: "Размер файла",
				tr: "Dosya boyutu",
				ja: "ファイルサイズ",
			},
			cem6: {
				zh: "上传时间",
				en: "Upload time",
				vi: "thời gian tải lên",
				ru: "Время загрузки",
				tr: "Yükleme zamanı",
				ja: "アップロード時間",
			},
			cem7: {
				zh: "删除媒体",
				en: "Delete Media",
				vi: "Xóa phương tiện",
				ru: "Удаление носителя",
				tr: "Medyayı Sil",
				ja: "メディアの削除",
			},
			cem8: {
				zh: "请问是否要永久删除当前选中多媒体？",
				en: "Do you want to permanently delete the currently selected multimedia?",
				vi: "Bạn có muốn xóa vĩnh viễn đa phương tiện hiện được chọn không?",
				ru: "Вы хотите безвозвратно удалить выбранные в данный момент мультимедийные файлы?",
				tr: "Seçili olan multimedyayı kalıcı olarak silmek istiyor musunuz?",
				ja: "現在選択されているマルチメディアを完全に削除しますか？",
			},
			cem9: {
				zh: "文件筛选",
				en: "File Filtering",
				vi: "Lọc tệp",
				ru: "Фильтрация файлов",
				tr: "Dosya Filtreleme",
				ja: "ファイルフィルタ",
			},
			cem10: {
				zh: "全选",
				en: "select all",
				vi: "chọn tất cả",
				ru: "Выбрать все",
				tr: "tümünü seç",
				ja: "すべて選択",
			},
			cem11: {
				zh: "视频",
				en: "video",
				vi: "Video",
				ru: "видео",
				tr: "video",
				ja: "ビデオ",
			},
			cem12: {
				zh: "图片",
				en: "picture",
				vi: "hình ảnh",
				ru: "картинка",
				tr: "resim",
				ja: "画像",
			},
			cem13: {
				zh: "文本",
				en: "text",
				vi: "chữ",
				ru: "текст",
				tr: "metin",
				ja: "テキスト",
			},
			cem14: {
				zh: "未定义类型",
				en: "Undefined Type",
				vi: "Loại không xác định",
				ru: "Тип не определен",
				tr: "Tanımsız Tür",
				ja: "タイプが定義されていません",
			},
			cem15: {
				zh: "音乐",
				en: "music",
				vi: "âm nhạc",
				ru: "музыка",
				tr: "müzik",
				ja: "音楽",
			},
			cem16: {
				zh: "文件类型",
				en: "file type",
				vi: "loại tệp",
				ru: "Тип файла",
				tr: "dosya türü",
				ja: "ファイルの種類",
			},
			cem17: {
				zh: "文件尺寸",
				en: "File size",
				vi: "Kích thước tập tin",
				ru: "Размер файла",
				tr: "Dosya boyutu",
				ja: "ファイルサイズ",
			},
			cem18: {
				zh: "文件大小",
				en: "File size",
				vi: "Kích cỡ  tập tin",
				ru: "Размер файла",
				tr: "Dosya boyutu",
				ja: "ファイルサイズ",
			}
		},
		MediaUp: {
			cemu1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			},
			cemu2: {
				zh: "上传",
				en: "Upload",
				vi: "Tải lên",
				ru: "загружать",
				tr: "Yüklemek",
				ja: "アップロード",
			},
			cemu3: {
				zh: "全部开始",
				en: "All Start",
				vi: "Tất cả bắt đầu",
				ru: "Все начинается",
				tr: "Tüm Başlangıç",
				ja: "すべて開始",
			},
			cemu4: {
				zh: "全部停止",
				en: "Stop All",
				vi: "Tất cả dừng lại",
				ru: "Остановить все",
				tr: "Tümünü Durdur",
				ja: "すべて停止",
			},
			cemu5: {
				zh: "清空完成",
				en: "Clear completed",
				vi: "Hoàn thành xoá",
				ru: "Опорожнение завершено",
				tr: "Tamamlananları temizle",
				ja: "クリア完了",
			},
			cemu6: {
				zh: "返回发布",
				en: "Back to Post",
				vi: "Quay lại bài viết",
				ru: "Вернуться к выпуску",
				tr: "Gönderiye Geri Dön",
				ja: "パブリケーションに戻る",
			},
			cemu7: {
				zh: "暂无上传文件",
				en: "No uploaded files yet",
				vi: "Chưa có tập tin nào được tải lên",
				ru: "Пока нет загруженных файлов",
				tr: "Henüz yüklenmiş dosya yok",
				ja: "ファイルをアップロードしていません",
			},
			cemu8: {
				zh: "文件名称",
				en: "file name",
				vi: "tên tập tin",
				ru: "Имя файла",
				tr: "dosya adı",
				ja: "ファイル名",
			},
			cemu9: {
				zh: "状态",
				en: "state",
				vi: "trạng thái",
				ru: "состояние",
				tr: "durum",
				ja: "ステータス",
			},
			cemu10: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать",
				tr: "işletmek",
				ja: "操作",
			},
			cemu11: {
				zh: "请问是否要取消上传当前文件？",
				en: "Do you want to cancel uploading the current file?",
				vi: "Bạn có muốn hủy tải lên tập tin hiện tại không?",
				ru: "Вы хотите отменить загрузку текущего файла?",
				tr: "Geçerli dosyanın yüklenmesini iptal etmek istiyor musunuz?",
				ja: "現在のファイルのアップロードをキャンセルしますか？",
			},
			cemu12: {
				zh: "上传完成",
				en: "upload completed",
				vi: "Hoàn tất tải lên",
				ru: "Загрузка завершена",
				tr: "yükleme tamamlandı",
				ja: "アップロード完了",
			},
			cemu13: {
				zh: "请选择上传文件!",
				en: "Please select upload file!",
				vi: "Vui lòng chọn file tải lên!",
				ru: "Пожалуйста, выберите загрузить файл!",
				tr: "Lütfen yükleme dosyasını seçin!",
				ja: "アップロードファイルを選択してください！",
			},
			cemu14: {
				zh: "请选择上传目录!",
				en: "Please select the upload directory!",
				vi: "Vui lòng chọn thư mục tải lên!",
				ru: "Пожалуйста, выберите каталог для загрузки!",
				tr: "Lütfen yükleme dizinini seçin!",
				ja: "アップロードディレクトリを選択してください！",
			},
			cemu15: {
				zh: "上传失败或成功执行！",
				en: "Upload failed or executed successfully!",
				vi: "Tải lên không thành công hoặc thực hiện thành công!",
				ru: "Загрузка завершилась неудачей или была выполнена успешно!",
				tr: "Yükleme başarısız oldu veya başarıyla yürütüldü!",
				ja: "アップロードに失敗したか、正常に実行されました！",
			},
			cemu16: {
				zh: "全部上传完成！",
				en: "All uploaded!",
				vi: "Tất cả đã được tải lên!",
				ru: "Все загрузки завершены!",
				tr: "Hepsi yüklendi!",
				ja: "すべてアップロード完了！",
			},
			cemu17: {
				zh: "文件上传个数不可以大于20个!",
				en: "The number of files uploaded cannot exceed 20!",
				vi: "Số lượng tệp được tải lên không thể vượt quá 20!",
				ru: "Количество загруженных файлов не может превышать 20!",
				tr: "Yüklenen dosya sayısı 20'yi geçemez!",
				ja: "ファイルのアップロード個数は20個を超えてはいけません！",
			},
			cemu18: {
				zh: "确定移除",
				en: "Confirm removal",
				vi: "Xác nhận xóa",
				ru: "Подтвердите удаление",
				tr: "Kaldırma işlemini onaylayın",
				ja: "削除の決定",
			},
			cemu19: {
				zh: "当前目录无文件类型",
				en: "There is no file type in the current directory",
				vi: "Không có loại tập tin trong thư mục hiện tại",
				ru: "Текущий каталог не имеет типа файла",
				tr: "Geçerli dizinde dosya türü yok",
				ja: "現在のディレクトリにファイルタイプがありません",
			},
			cemu20: {
				zh: "视频",
				en: "video",
				vi: "Video",
				ru: "видео",
				tr: "video",
				ja: "ビデオ",
			},
			cemu21: {
				zh: "图片",
				en: "picture",
				vi: "hình ảnh",
				ru: "картинка",
				tr: "resim",
				ja: "画像",
			},
			cemu22: {
				zh: "音乐",
				en: "music",
				vi: "âm nhạc",
				ru: "музыка",
				tr: "müzik",
				ja: "音楽",
			}
		}
	},
	home: {
		index: {
			chi1: {
				zh: "消息",
				en: "message",
				vi: "thông tin",
				ru: "новость",
				tr: "bilgi",
				ja: "メッセージ",
			},
			chi2: {
				zh: "系统消息",
				en: "system message",
				vi: "thông tin hệ thống",
				ru: "Системное сообщение",
				tr: "sistem bilgisi",
				ja: "システムメッセージ",
			},
			chi3: {
				zh: "导出设备MAC列表",
				en: "Export device MAC list",
				vi: "Xuất danh sách MAC của thiết bị",
				ru: "Экспорт списка MAC устройств",
				tr: "Cihaz MAC listesini dışa aktar",
				ja: "デバイスMACリストのエクスポート",
			},
			chi4: {
				zh: "拼命加载中",
				en: "Loading",
				vi: "Đang tải",
				ru: "Отчаянно загружаясь",
				tr: "Yükleniyor",
				ja: "命がけでロード中",
			},
			chi5: {
				zh: "播放统计",
				en: "Playback Statistics",
				vi: "Thống kê phát lại",
				ru: "Статистика",
				tr: "Oynatma İstatistikleri",
				ja: "再生統計",
			},
			chi6: {
				zh: "导出记录",
				en: "Export Records",
				vi: "Xuất bản ghi",
				ru: "Экспортная запись",
				tr: "Kayıtları Dışa Aktar",
				ja: "レコードのエクスポート",
			},
			chi7: {
				zh: "素材统计",
				en: "Media",
				vi: "Thống kê vật liệu",
				ru: "Материал",
				tr: "Malzeme İstatistikleri",
				ja: "マテリアル統計",
			},
			chi8: {
				zh: "节目统计",
				en: "Program",
				vi: "Thống kê chương trình",
				ru: "Программа",
				tr: "Program İstatistikleri",
				ja: "プログラム統計",
			},
			chi9: {
				zh: "暂无数据",
				en: "No data",
				vi: "Không có dữ liệu",
				ru: "Нет доступных данных",
				tr: "Veri yok",
				ja: "データが一時的にありません",
			},
			chi10: {
				zh: "输入名称搜索",
				en: "Enter name to search",
				vi: "Nhập tên để tìm kiếm",
				ru: "Введите имя для поиска",
				tr: "Aranacak adı girin",
				ja: "名前を入力して検索",
			},
			chi11: {
				zh: "底线",
				en: "Bottom Line",
				vi: "Dòng dưới cùng",
				ru: "граница",
				tr: "Sonuç olarak",
				ja: "ボトムライン",
			},
			chi12: {
				zh: "导出",
				en: "Export",
				vi: "Xuất",
				ru: "экспорт",
				tr: "İhracat",
				ja: "エクスポート＃エクスポート＃",
			},
			chi13: {
				zh: "至",
				en: "to",
				vi: "ĐẾN",
				ru: "до",
				tr: "ile",
				ja: "終了",
			},
			chi14: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала",
				tr: "başlangıç ​​tarihi",
				ja: "開始日",
			},
			chi15: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания",
				tr: "Bitiş Tarihi",
				ja: "終了日",
			},
			chi16: {
				zh: "单次最多导出5万条。",
				en: "A maximum of 50,000 records can be exported at a time.",
				vi: "Có thể xuất tối đa 50.000 bản ghi cùng một lúc.",
				ru: "Экспортируйте до 50 000 товаров одновременно.",
				tr: "Bir seferde en fazla 50.000 kayıt dışa aktarılabilir.",
				ja: "一度に最大5万本エクスポートされます。",
			},
			chi17: {
				zh: "欢迎使用Kares,让世界只有指尖的距离。Kares拥有完美的跨平台解决方案，其基于网络平台，采用分布式区域管理技术，可以有效整合各种多媒体资源，实现远程制作，发布和管理节目。",
				en: "Welcome to Kares, which makes the world just at your fingertips. Kares has a perfect cross-platform solution. It is based on a network platform and adopts distributed regional management technology. It can effectively integrate various multimedia resources and realize remote production, publishing and management of programs.",
				vi: "Chào mừng bạn đến với Kares, nơi khiến thế giới nằm trong tầm tay bạn. Kares có một giải pháp đa nền tảng hoàn hảo. Nó dựa trên nền tảng mạng và áp dụng công nghệ quản lý khu vực phân tán. Nó có thể tích hợp hiệu quả các tài nguyên đa phương tiện khác nhau và thực hiện việc sản xuất, xuất bản và quản lý chương trình từ xa.",
				ru: "Добро пожаловать в Kares, чтобы весь мир был на расстоянии вытянутой руки.Kares предлагает идеальное кроссплатформенное решение, основанное на сетевой платформе и использующее технологию распределенного регионального управления, которая позволяет эффективно интегрировать различные мультимедийные ресурсы и осуществлять удаленное производство, распространение и управление программами.",
				tr: "Dünyayı parmaklarınızın ucuna getiren Kares'e hoş geldiniz. Kares'in mükemmel bir platformlar arası çözümü var. Bir ağ platformuna dayanır ve dağıtılmış bölgesel yönetim teknolojisini benimser. Çeşitli multimedya kaynaklarını etkili bir şekilde entegre edebilir ve programların uzaktan üretimini, yayınlanmasını ve yönetimini gerçekleştirebilir.",
				ja: "Karesを使って、世界が指先だけの距離になるようにしてください。Karesは、ネットワークプラットフォームに基づいた完全なクロスプラットフォームソリューションを持ち、分散型領域管理技術を採用し、さまざまなマルチメディアリソースを効果的に統合し、遠隔制作、番組の配信、管理を実現することができます。",
			},
			chi18: {
				zh: "添加素材",
				en: "Adding Materials",
				vi: "Thêm tài liệu",
				ru: "Добавить материал",
				tr: "Malzeme Ekleme",
				ja: "素材を追加",
			},
			chi19: {
				zh: "批量上传，格式丰富，分类查找，海量素材快速定位",
				en: "Batch upload, rich formats, classified search, rapid location of massive materials",
				vi: "Tải lên hàng loạt, định dạng phong phú, tìm kiếm được phân loại, định vị nhanh chóng các tài liệu khổng lồ",
				ru: "Массовая загрузка, богатый формат",
				tr: "Toplu yükleme, zengin formatlar, sınıflandırılmış arama, büyük malzemelerin hızlı konumu",
				ja: "大量アップロード、フォーマット豊富、分類検索、大量素材迅速位置決め",
			},
			chi20: {
				zh: "节目制作",
				en: "program production",
				vi: "sản xuất chương trình",
				ru: "Редактирование",
				tr: "program prodüksiyonu",
				ja: "番組制作",
			},
			chi21: {
				zh: "拖拽式的操作，编排效果所见即所得，快速完成节目制作",
				en: "Drag-and-drop operation, what you see is what you get, quickly complete program production",
				vi: "Thao tác kéo và thả, những gì bạn thấy là những gì bạn nhận được, nhanh chóng hoàn thành việc sản xuất chương trình",
				ru: "Перетаскивание операций, быстрое завершение производства",
				tr: "Sürükle ve bırak işlemi, ne görüyorsanız onu alırsınız, program üretimini hızla tamamlayın",
				ja: "ドラッグ式の操作は、編成効果が見られるだけで得られ、番組制作を迅速に完了する",
			},
			chi22: {
				zh: "节目发布",
				en: "Program Release",
				vi: "Xuất bản",
				ru: "Выпуск программы",
				tr: "Programın Yayınlanması",
				ja: "番組配信",
			},
			chi23: {
				zh: "循环、定时，插播多种播放模式，节目投放井然有序",
				en: "Multiple playback modes such as loop, timing, and insert play ensure that programs are delivered in an orderly manner",
				vi: "Nhiều chế độ phát lại như lặp lại, định giờ và phát chèn đảm bảo rằng các chương trình được phân phối một cách có trật tự",
				ru: "Цикл, таймер, интерполяция и другие режимы",
				tr: "Döngü, zamanlama ve ekleme oynatma gibi çoklu oynatma modları, programların düzenli bir şekilde iletilmesini sağlar",
				ja: "循環、タイミング、多種類の放送モードを補間し、番組の投入が整然としている",
			},
			chi24: {
				zh: "终端控制",
				en: "Terminal Control",
				vi: "Kiểm soát",
				ru: "Контроль",
				tr: "Terminal Kontrolü",
				ja: "ターミナルコントロール",
			},
			chi25: {
				zh: "远程控制终端，一键批量操作，一人管千屏得心应手",
				en: "Remote control terminal, one-key batch operation, one person manages thousands of screens easily",
				vi: "Thiết bị đầu cuối điều khiển từ xa, thao tác hàng loạt bằng một phím, một người quản lý hàng nghìn màn hình một cách dễ dàng",
				ru: "Дистанционное управление, пакетная работа одним кликом",
				tr: "Uzaktan kumanda terminali, tek tuşla toplu işlem, tek kişi binlerce ekranı kolayca yönetir",
				ja: "遠隔制御端末、ワンタッチ一括操作、一人千画面対応",
			},
			chi26: {
				zh: "当前系统存储空间已使用",
				en: "The current system storage space is used",
				vi: "Dung lượng lưu trữ hệ thống hiện tại đã được sử dụng",
				ru: "Используется текущее системное пространство для хранения",
				tr: "Mevcut sistem depolama alanı kullanılıyor",
				ja: "現在のシステムストレージスペースが使用されている",
			},
			chi27: {
				zh: "当前数据存储空间已使用",
				en: "The current data storage space is used",
				vi: "Không gian lưu trữ dữ liệu hiện tại được sử dụng",
				ru: "Используется текущее пространство для хранения данных",
				tr: "Mevcut veri depolama alanı kullanılıyor",
				ja: "現在のデータ記憶領域が使用されている",
			},
			chi28: {
				zh: "当前时间段无任何数据",
				en: "There is no data for the current time period",
				vi: "Không có dữ liệu cho khoảng thời gian hiện tại",
				ru: "Нет данных за текущий период времени",
				tr: "Mevcut döneme ait veri yok",
				ja: "現在の期間にデータがありません",
			},
			chi29: {
				zh: "数据导出成功,正在下载中...",
				en: "Data exported successfully, downloading...",
				vi: "Đã xuất dữ liệu thành công, đang tải xuống...",
				ru: "Данные были успешно экспортированы и в настоящее время загружаются...",
				tr: "Veriler başarıyla dışa aktarıldı, indiriliyor...",
				ja: "データのエクスポートに成功しました。ダウンロード中です...",
			},
			chi30: {
				zh: "序号",
				en: "Serial number",
				vi: "Số seri",
				ru: "серийный номер",
				tr: "Seri numarası",
				ja: "シーケンス番号",
			},
			chi31: {
				zh: "设备分类",
				en: "Equipment Classification",
				vi: "Phân loại thiết bị",
				ru: "Классификация оборудования",
				tr: "Ekipman Sınıflandırması",
				ja: "デバイス分類",
			},
			chi32: {
				zh: "设称备名",
				en: "Device Name",
				vi: "Tên thiết bị",
				ru: "Установить альтернативное имя",
				tr: "Cihaz Adı",
				ja: "スペア名をつける",
			},
			chi33: {
				zh: "设备SN",
				en: "Equipment SN",
				vi: "Thiết bị SN",
				ru: "Оборудование SN",
				tr: "Ekipman SN'si",
				ja: "デバイスSN",
			},
			chi34: {
				zh: "节目名称",
				en: "Name of programme",
				vi: "Tên chương trình",
				ru: "Название программы",
				tr: "Programın adı",
				ja: "番組名",
			},
			chi35: {
				zh: "开始时间",
				en: "Starting time",
				vi: "Thời gian bắt đầu",
				ru: "Время начала",
				tr: "Başlangıç ​​zamanı",
				ja: "開始時間",
			},
			chi36: {
				zh: "结束时间",
				en: "End Time",
				vi: "Thời gian kết thúc",
				ru: "Время окончания",
				tr: "Bitiş Zamanı",
				ja: "終了時間",
			},
			chi37: {
				zh: "播放时间",
				en: "play time",
				vi: "Thời gian phát",
				ru: "Время игры",
				tr: "oyun zamanı",
				ja: "再生時間",
			},
			chi38: {
				zh: "节目播放记录",
				en: "Program playback record",
				vi: "Bản ghi phát lại chương trình",
				ru: "Запись воспроизведения программы",
				tr: "Program oynatma kaydı",
				ja: "番組放送記録",
			},
			chi39: {
				zh: "素材播放记录",
				en: "Material playback record",
				vi: "Bản ghi phát lại tài liệu",
				ru: "Запись воспроизведения материала",
				tr: "Malzeme oynatma kaydı",
				ja: "マテリアル再生記録",
			},
			chi40: {
				zh: "播放记录列表_",
				en: "Playback record list_",
				vi: "Danh sách bản ghi phát lại_",
				ru: "Воспроизведение списка записей_",
				tr: "Oynatma kayıt listesi_",
				ja: "プレイログリスト_",
			},
			chi41: {
				zh: "在线/离线",
				en: "Online/Offline",
				vi: "Online/Offline",
				ru: "Онлайн/оффлайн",
				tr: "Çevrimiçi/Çevrimdışı",
				ja: "オンライン/オフライン",
			},
			chi42: {
				zh: "分辨率图表",
				en: "Resolution chart",
				vi: "Biểu đồ độ phân giải",
				ru: "Диаграмма разрешения",
				tr: "Çözünürlük tablosu",
				ja: "解像度グラフ",
			},
			chi43: {
				zh: "设备分辨率",
				en: "Device resolution",
				vi: "Độ phân giải thiết bị",
				ru: "Разрешение устройства",
				tr: "Cihaz çözünürlüğü",
				ja: "デバイス解像度",
			},
			chi44: {
				zh: "素材统计",
				en: "Material Statistics",
				vi: "Thống kê cảnh quay",
				ru: "Существенная статистика",
				tr: "Malzeme İstatistikleri",
				ja: "マテリアル統計",
			},
			chi45: {
				zh: "图片",
				en: "picture",
				vi: "hình ảnh",
				ru: "картинка",
				tr: "resim",
				ja: "画像",
			},
			chi46: {
				zh: "视频",
				en: "video",
				vi: "băng hình",
				ru: "видео",
				tr: "video",
				ja: "ビデオ",
			},
			chi47: {
				zh: "素材数量",
				en: "Number of materials",
				vi: "Số lượng vật liệu",
				ru: "Количество материала",
				tr: "Malzeme sayısı",
				ja: "素材数",
			},
			chi48: {
				zh: "素材类型",
				en: "Material Type",
				vi: "Loại vật liệu",
				ru: "Тип материала",
				tr: "Malzeme Türü",
				ja: "素材タイプ",
			},
			chi49: {
				zh: "素材存储",
				en: "Material storage",
				vi: "Lưu trữ tài liệu",
				ru: "Хранение материалов",
				tr: "Malzeme depolama",
				ja: "マテリアルストレージ",
			},
			chi50: {
				zh: "素材计价",
				en: "Price",
				vi: "JiJia",
				ru: "Стоимость",
				tr: "İçerik fiyatlandırması",
				ja: "素材価格",
			},
			chi51: {
				zh: "正在下载中...",
				en: "downloading...",
				vi: "đang tải xuống...",
				ru: "Идёт загрузка файла...",
				tr: "indiriliyor...",
				ja: "ダウンロード中です...",
			},
			chi152: {
				zh: "范围",
				en: "Range",
				vi: "Phạm vi",
				ru: "Диапазон",
				tr: "Aralık",
				ja: "範囲",
			},
			chi151: {
				zh: "数据加载中",
				en: "Loading data",
				vi: "Đang tải dữ liệu",
				ru: "Загрузка данных",
				tr: "Veri yükleniyor",
				ja: "データ読み込み中",
			},
			chi150: {
				zh: "区间内",
				en: "In range",
				vi: "Trong khoảng",
				ru: "За период",
				tr: "Aralıkta",
				ja: "区間内",
			},
			chi149: {
				zh: "设备数",
				en: "Device Count",
				vi: "Số thiết bị",
				ru: "Кол-во устройств",
				tr: "Cihaz Sayısı",
				ja: "デバイス数",
			},
			chi148: {
				zh: "接口未提供该维度统计数据",
				en: "API does not provide this data",
				vi: "API chưa cung cấp dữ liệu này",
				ru: "API не предоставляет эти данные",
				tr: "API bu veriyi sağlamıyor",
				ja: "APIはこのデータを提供していません",
			},
			chi147: {
				zh: "Excel 已导出",
				en: "Excel exported",
				vi: "Đã xuất Excel",
				ru: "Excel экспортирован",
				tr: "Excel dışa aktarıldı",
				ja: "Excelをエクスポートしました",
			},
			chi146: {
				zh: "该功能暂无接口支持",
				en: "No API support for this feature",
				vi: "Chức năng chưa có API hỗ trợ",
				ru: "API для этой функции отсутствует",
				tr: "Bu özellik için API desteği yok",
				ja: "この機能はAPI未対応です",
			},

			chi123: {
				zh: "占比",
				en: "Share",
				vi: "Tỷ lệ",
				ru: "Доля",
				tr: "Oran",
				ja: "比率",
			},
			chi122: {
				zh: "平均时长",
				en: "Avg Duration",
				vi: "Thời lượng TB",
				ru: "Ср. длительность",
				tr: "Ort. Süre",
				ja: "平均時間",
			},
			chi121: {
				zh: "播放次数",
				en: "Play Count",
				vi: "Lượt phát",
				ru: "Воспроизведения",
				tr: "Oynatma Sayısı",
				ja: "再生回数",
			},
			chi120: {
				zh: "类型",
				en: "Type",
				vi: "Loại",
				ru: "Тип",
				tr: "Tür",
				ja: "タイプ",
			},
			chi119: {
				zh: "节目 / 素材明细",
				en: "Program / Media Details",
				vi: "Chi tiết chương trình / vật liệu",
				ru: "Детали программ / материалов",
				tr: "Program / Materyal Detayı",
				ja: "番組・素材明細",
			},
			chi118: {
				zh: "每日播放趋势",
				en: "Daily Playback Trend",
				vi: "Xu hướng phát hàng ngày",
				ru: "Дневная динамика воспроизведения",
				tr: "Günlük Oynatma Trendi",
				ja: "日次再生トレンド",
			},
			chi117: {
				zh: "分时段播放",
				en: "Hourly Playback",
				vi: "Phát theo khung giờ",
				ru: "Почасовое воспроизведение",
				tr: "Saatlik Oynatma",
				ja: "時間帯別再生",
			},
			chi116: {
				zh: "其他",
				en: "Others",
				vi: "Khác",
				ru: "Другие",
				tr: "Diğer",
				ja: "その他",
			},
			chi115: {
				zh: "播放次数占比",
				en: "Play Count Share",
				vi: "Tỷ lệ lượt phát",
				ru: "Доля воспроизведений",
				tr: "Oynatma Oranı",
				ja: "再生回数比率",
			},
			chi114: {
				zh: "次",
				en: "plays",
				vi: "lần",
				ru: "раз",
				tr: "kez",
				ja: "回",
			},
			chi113: {
				zh: "播放次数排名",
				en: "Play Count Ranking",
				vi: "Xếp hạng lượt phát",
				ru: "Рейтинг воспроизведений",
				tr: "Oynatma Sayısı Sıralaması",
				ja: "再生回数ランキング",
			},
			chi111: {
				zh: "总时长",
				en: "Total Duration",
				vi: "Tổng thời lượng",
				ru: "Общая длительность",
				tr: "Toplam Süre",
				ja: "総時間",
			},
			chi110: {
				zh: "总播放",
				en: "Total Plays",
				vi: "Tổng phát",
				ru: "Всего воспроизведений",
				tr: "Toplam Oynatma",
				ja: "総再生数",
			},
			chi109: {
				zh: "按节目/素材统计播放次数 · 多终端聚合",
				en: "Play counts by program/media across devices",
				vi: "Thống kê lượt phát theo chương trình/vật liệu",
				ru: "Количество воспроизведений по программам/материалам",
				tr: "Program/materyal bazında oynatma sayısı",
				ja: "番組・素材別の再生回数集計",
			},
			chi108: {
				zh: "节目播放统计",
				en: "Program Playback Statistics",
				vi: "Thống kê phát chương trình",
				ru: "Статистика воспроизведения программ",
				tr: "Program Oynatma İstatistikleri",
				ja: "番組再生統計",
			},
			chi107: {
				zh: "分钟",
				en: "min",
				vi: "phút",
				ru: "мин",
				tr: "dk",
				ja: "分",
			},
			chi106: {
				zh: "小时",
				en: "h",
				vi: "giờ",
				ru: "ч",
				tr: "saat",
				ja: "時間",
			},
			chi105: {
				zh: "会话运行时长",
				en: "Session Runtime",
				vi: "Thời gian phiên",
				ru: "Длительность сессии",
				tr: "Oturum süresi",
				ja: "セッション稼働時間",
			},
			chi104: {
				zh: "操作时间",
				en: "Time",
				vi: "Thời gian",
				ru: "Время",
				tr: "Zaman",
				ja: "操作時間",
			},
			chi103: {
				zh: "终端退出",
				en: "Terminal Logout",
				vi: "Thoát thiết bị",
				ru: "Выход терминала",
				tr: "Terminal Çıkışı",
				ja: "端末ログアウト",
			},
			chi102: {
				zh: "终端登录",
				en: "Terminal Login",
				vi: "Đăng nhập thiết bị",
				ru: "Вход терминала",
				tr: "Terminal Girişi",
				ja: "端末ログイン",
			},
			chi101: {
				zh: "事件",
				en: "Event",
				vi: "Sự kiện",
				ru: "Событие",
				tr: "Olay",
				ja: "イベント",
			},
			chi100: {
				zh: "自动配对上下线事件以计算每次运行会话",
				en: "Auto-paired on/off events to compute each session",
				vi: "Tự động ghép cặp sự kiện on/off để tính phiên",
				ru: "Автоматическое сопоставление событий питания",
				tr: "Otomatik eşleştirilmiş açma/kapama olayları",
				ja: "オンライン/オフラインイベントを自動ペアリングしてセッションを計算",
			},
			chi99: {
				zh: "电源与连接日志",
				en: "Power & Connection Log",
				vi: "Nhật ký nguồn & kết nối",
				ru: "Журнал питания и связи",
				tr: "Güç ve Bağlantı Günlüğü",
				ja: "電源と接続ログ",
			},

			chi96: {
				zh: "日均",
				en: "Daily Avg",
				vi: "TB ngày",
				ru: "В день",
				tr: "Günlük ort.",
				ja: "日平均",
			},
			chi95: {
				zh: "运行时长",
				en: "Runtime",
				vi: "Thời gian chạy",
				ru: "Время работы",
				tr: "Çalışma süresi",
				ja: "稼働時間",
			},
			chi94: {
				zh: "开机次数",
				en: "Power-ons",
				vi: "Số lần bật nguồn",
				ru: "Включения",
				tr: "Açılma sayısı",
				ja: "起動回数",
			},
			chi93: {
				zh: "状态",
				en: "Status",
				vi: "Trạng thái",
				ru: "Статус",
				tr: "Durum",
				ja: "状態",
			},
			chi92: {
				zh: "结构",
				en: "Structure",
				vi: "Cấu trúc",
				ru: "Структура",
				tr: "Yapı",
				ja: "組織",
			},
			chi91: {
				zh: "设备 SN",
				en: "Device SN",
				vi: "SN thiết bị",
				ru: "SN устройства",
				tr: "Cihaz SN",
				ja: "デバイスSN",
			},
			chi90: {
				zh: "名称",
				en: "Name",
				vi: "Tên",
				ru: "Имя",
				tr: "İsim",
				ja: "名称",
			},
			chi89: {
				zh: "每台设备在选定区间的运行时长",
				en: "Runtime of each device in the selected range",
				vi: "Thời gian chạy của từng thiết bị trong khoảng đã chọn",
				ru: "Время работы каждого устройства за период",
				tr: "Seçili aralıkta cihaz çalışma süresi",
				ja: "選択区間での各デバイスの稼働時間",
			},
			chi88: {
				zh: "设备使用汇总",
				en: "Device Usage Summary",
				vi: "Tổng hợp sử dụng thiết bị",
				ru: "Сводка использования устройств",
				tr: "Cihaz Kullanım Özeti",
				ja: "デバイス使用状況一覧",
			},
			chi87: {
				zh: "媒体播放",
				en: "Media Plays",
				vi: "Phát phương tiện",
				ru: "Воспроизведения",
				tr: "Medya Oynatma",
				ja: "メディア再生",
			},
			chi86: {
				zh: "重启次数",
				en: "Restarts",
				vi: "Số lần khởi động lại",
				ru: "Перезагрузки",
				tr: "Yeniden başlatma",
				ja: "再起動回数",
			},
			chi85: {
				zh: "离线时长",
				en: "Offline Duration",
				vi: "Thời gian offline",
				ru: "Время офлайн",
				tr: "Çevrimdışı süre",
				ja: "オフライン時間",
			},
			chi84: {
				zh: "在线时长",
				en: "Online Duration",
				vi: "Thời gian online",
				ru: "Время онлайн",
				tr: "Çevrimiçi süre",
				ja: "オンライン時間",
			},
			chi83: {
				zh: "可用率",
				en: "Availability",
				vi: "Khả dụng",
				ru: "Доступность",
				tr: "Kullanılabilirlik",
				ja: "可用率",
			},
			chi82: {
				zh: "在线可用率",
				en: "Availability",
				vi: "Tỷ lệ khả dụng",
				ru: "Доступность",
				tr: "Kullanılabilirlik",
				ja: "稼働率",
			},
			chi81: {
				zh: "峰值",
				en: "Peak",
				vi: "Đỉnh",
				ru: "Пик",
				tr: "Zirve",
				ja: "ピーク",
			},
			chi80: {
				zh: "单位：小时",
				en: "Unit: hours",
				vi: "Đơn vị: giờ",
				ru: "Ед.: часы",
				tr: "Birim: saat",
				ja: "単位：時間",
			},
			chi79: {
				zh: "每日运行时长趋势",
				en: "Daily Runtime Trend",
				vi: "Xu hướng thời gian chạy hàng ngày",
				ru: "Динамика времени работы",
				tr: "Günlük Çalışma Trendi",
				ja: "日次稼働時間推移",
			},



			chi75: {
				zh: "每台选中设备 / 天",
				en: "per selected device / day",
				vi: "mỗi thiết bị đã chọn / ngày",
				ru: "на устройство / день",
				tr: "cihaz başına / gün",
				ja: "選択デバイスごと / 日",
			},
			chi74: {
				zh: "日均运行时长",
				en: "Avg Daily Runtime",
				vi: "Thời gian chạy TB ngày",
				ru: "Ср. время в сутки",
				tr: "Günlük Ort. Süre",
				ja: "日平均稼働時間",
			},
			chi73: {
				zh: "区间运行时长",
				en: "Total Runtime",
				vi: "Thời gian chạy trong khoảng",
				ru: "Время работы за период",
				tr: "Aralık Çalışma Süresi",
				ja: "区間稼働時間",
			},
			chi72: {
				zh: "离线",
				en: "Offline",
				vi: "Ngoại tuyến",
				ru: "Офлайн",
				tr: "Çevrimdışı",
				ja: "オフライン",
			},
			chi71: {
				zh: "在线",
				en: "Online",
				vi: "Trực tuyến",
				ru: "Онлайн",
				tr: "Çevrimiçi",
				ja: "オンライン",
			},
			chi70: {
				zh: "已选",
				en: "selected",
				vi: "đã chọn",
				ru: "выбрано",
				tr: "seçili",
				ja: "選択中",
			},
			chi69: {
				zh: "管理设备",
				en: "Devices",
				vi: "Thiết bị quản lý",
				ru: "Устройства",
				tr: "Yönetilen cihaz",
				ja: "管理デバイス",
			},
			chi68: {
				zh: "搜索名称 / SN",
				en: "Search name / SN",
				vi: "Tìm tên / SN",
				ru: "Поиск по имени / SN",
				tr: "İsim / SN ara",
				ja: "名前 / SN検索",
			},
			chi67: {
				zh: "完成",
				en: "Done",
				vi: "Xong",
				ru: "Готово",
				tr: "Tamam",
				ja: "完了",
			},
			chi66: {
				zh: "清空",
				en: "Clear",
				vi: "Xóa chọn",
				ru: "Очистить",
				tr: "Temizle",
				ja: "クリア",
			},
			chi65: {
				zh: "全选",
				en: "Select all",
				vi: "Chọn tất cả",
				ru: "Выбрать все",
				tr: "Tümünü seç",
				ja: "すべて選択",
			},
			chi64: {
				zh: "已选 {n} 台",
				en: "{n} selected",
				vi: "Đã chọn {n}",
				ru: "Выбрано: {n}",
				tr: "{n} seçildi",
				ja: "{n}台選択中",
			},

			chi62: {
				zh: "导出 Excel",
				en: "Export Excel",
				vi: "Xuất Excel",
				ru: "Экспорт Excel",
				tr: "Excel Dışa Aktar",
				ja: "Excelエクスポート",
			},
			chi61: {
				zh: "查询",
				en: "Query",
				vi: "Truy vấn",
				ru: "Запрос",
				tr: "Sorgula",
				ja: "検索",
			},
			chi60: {
				zh: "设备",
				en: "Devices",
				vi: "Thiết bị",
				ru: "Устройства",
				tr: "Cihazlar",
				ja: "デバイス",
			},
			chi59: {
				zh: "至",
				en: "to",
				vi: "đến",
				ru: "до",
				tr: "-",
				ja: "〜",
			},
			chi58: {
				zh: "范围查询",
				en: "Range",
				vi: "Khoảng truy vấn",
				ru: "Диапазон",
				tr: "Aralık",
				ja: "期間検索",
			},
			chi57: {
				zh: "节目",
				en: "Programs",
				vi: "Chương trình",
				ru: "Программы",
				tr: "Programlar",
				ja: "番組",
			},
			chi56: {
				zh: "设备",
				en: "Overview",
				vi: "Tổng quan",
				ru: "Обзор",
				tr: "Genel Bakış",
				ja: "设备",
			},
			chi55: {
				zh: "设备使用、运行时长与节目播放统计",
				en: "Device usage, runtime and program playback statistics",
				vi: "Thống kê sử dụng thiết bị, thời gian chạy và phát chương trình",
				ru: "Использование устройств, время работы и статистика воспроизведения",
				tr: "Cihaz kullanımı, çalışma süresi ve program oynatma istatistikleri",
				ja: "デバイス使用状況・稼働時間・番組再生の統計",
			},
			chi54: {
				zh: "统计",
				en: "Statistics",
				vi: "Thống kê",
				ru: "Статистика",
				tr: "İstatistik",
				ja: "統計",
			},



			chi156: {
				zh: "天",
				en: "days",
				vi: "ngày",
				ru: "дн.",
				tr: "gün",
				ja: "日",
			},
			chi157: {
				zh: "全部设备",
				en: "All devices",
				vi: "Tất cả thiết bị",
				ru: "Все устройства",
				tr: "Tüm cihazlar",
				ja: "全デバイス",
			},
			chi158: {
				zh: "未分组",
				en: "Ungrouped",
				vi: "Chưa phân nhóm",
				ru: "Не сгруппировано",
				tr: "Gruplanmamış",
				ja: "未分類",
			},
			chi159: {
				zh: "设备筛选",
				en: "Device Filter",
				vi: "Lọc thiết bị",
				ru: "Фильтр устройств",
				tr: "Cihaz Filtresi",
				ja: "デバイスフィルター",
			},
			chi160: {
				zh: "清除",
				en: "Clear",
				vi: "Xoá",
				ru: "Очистить",
				tr: "Temizle",
				ja: "クリア",
			},
		}
	},
	log: {
		children: {
			DeviceList: {
				clcd1: {
					zh: "请选择",
					en: "please choose",
					vi: "xin vui lòng chọn",
					ru: "Пожалуйста выберите",
					tr: "lütfen seç",
					ja: "選択してください",
				}
			},
			ExportDialog: {
				clce1: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Имя устройства",
					tr: "Cihaz Adı",
					ja: "デバイス名",
				},
				clce2: {
					zh: "设备SN",
					en: "Equipment SN",
					vi: "Thiết bị SN",
					ru: "Оборудование SN",
					tr: "Ekipman SN'si",
					ja: "デバイスSN",
				},
				clce3: {
					zh: "组织结构",
					en: "Groups",
					vi: "Cơ cấu tổ chức",
					ru: "структура",
					tr: "Organizasyon Yapısı",
					ja: "組織構造",
				},
				clce4: {
					zh: "类型",
					en: "type",
					vi: "Loại",
					ru: "тип",
					tr: "tip",
					ja: "を選択してオプションを設定します。",
				},
				clce5: {
					zh: "操作时间",
					en: "Operation time",
					vi: "Thời gian hoạt động",
					ru: "Время работы",
					tr: "Operasyon süresi",
					ja: "そうさじかん",
				},
				clce6: {
					zh: "操作用户",
					en: "Operation User",
					vi: "Người dùng thao tác",
					ru: "Действующий пользователь",
					tr: "Operasyon Kullanıcısı",
					ja: "操作ユーザー",
				},
				clce7: {
					zh: "功能",
					en: "Function",
					vi: "Chức năng",
					ru: "функция",
					tr: "İşlev",
					ja: "機能",
				},
				clce8: {
					zh: "描述",
					en: "describe",
					vi: "mô tả",
					ru: "описание",
					tr: "betimlemek",
					ja: "説明",
				},
				clce9: {
					zh: "编号",
					en: "serial number",
					vi: "số seri",
					ru: "серийный номер",
					tr: "seri numarası",
					ja: "番号付け",
				},
				clce10: {
					zh: "内容",
					en: "content",
					vi: "nội dung",
					ru: "содержание",
					tr: "içerik",
					ja: "内容",
				},
				clce11: {
					zh: "操作对象",
					en: "Operation Object",
					vi: "Đối tượng hoạt động",
					ru: "Объект операции",
					tr: "Operasyon Nesnesi",
					ja: "オペランド",
				},
				clce12: {
					zh: "操作信息",
					en: "Operational Information",
					vi: "Thông tin hoạt động",
					ru: "Информация о работе",
					tr: "Operasyonel Bilgiler",
					ja: "オペレーション情報",
				},
				clce13: {
					zh: "操作日志_",
					en: "Operation Log_",
					vi: "Nhật ký hoạt động_",
					ru: "Журнал операций_",
					tr: "Operasyon Günlüğü_",
					ja: "操作ログ_",
				},
				clce14: {
					zh: "终端日志_",
					en: "Terminal Log_",
					vi: "Nhật ký thiết bị đầu cuối_",
					ru: "Журнал регистрации терминала_",
					tr: "Terminal Günlüğü_",
					ja: "ターミナルログ_",
				}
			}
		},
		LoginLog: {
			cll1: {
				zh: "范围查询",
				en: "Range Query",
				vi: "Truy vấn phạm vi",
				ru: "Запрос области действия",
				tr: "Aralık Sorgusu",
				ja: "スコープクエリー",
			},
			cll2: {
				zh: "至",
				en: "to",
				vi: "ĐẾN",
				ru: "до",
				tr: "ile",
				ja: "終了",
			},
			cll3: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала",
				tr: "başlangıç ​​tarihi",
				ja: "開始日",
			},
			cll4: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания",
				tr: "Bitiş Tarihi",
				ja: "終了日",
			},
			cll5: {
				zh: "最近一周",
				en: "Last week",
				vi: "Tuần trước",
				ru: "Прошлая неделя",
				tr: "Geçen hafta",
				ja: "最近の週",
			},
			cll6: {
				zh: "最近一个月",
				en: "Last month",
				vi: "Tháng trước",
				ru: "Прошлый месяц",
				tr: "Geçen ay",
				ja: "最近1か月",
			},
			cll7: {
				zh: "最近三个月",
				en: "Last three months",
				vi: "Ba tháng qua",
				ru: "Последние три месяца",
				tr: "Son üç ay",
				ja: "最近3か月",
			},
			cll8: {
				zh: "确定...",
				en: "Sure...",
				vi: "Chắc chắn...",
				ru: "уверенный...",
				tr: "Elbette...",
				ja: "確定...",
			},
			cll9: {
				zh: "导出.....",
				en: "Export...",
				vi: "Xuất",
				ru: "экспорт.....",
				tr: "İhracat...",
				ja: "エクスポート....",
			}
		},
		OperationLog: {
			clo1: {
				zh: "范围查询",
				en: "Range Query",
				vi: "Truy vấn phạm vi",
				ru: "Запрос области действия",
				tr: "Aralık Sorgusu",
				ja: "スコープクエリー",
			},
			clo2: {
				zh: "至",
				en: "to",
				vi: "ĐẾN",
				ru: "до",
				tr: "ile",
				ja: "終了",
			},
			clo3: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала",
				tr: "başlangıç ​​tarihi",
				ja: "開始日",
			},
			clo4: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания",
				tr: "Bitiş Tarihi",
				ja: "終了日",
			},
			clo5: {
				zh: "最近一周",
				en: "Last week",
				vi: "Tuần trước",
				ru: "Прошлая неделя",
				tr: "Geçen hafta",
				ja: "最近の週",
			},
			clo6: {
				zh: "最近一个月",
				en: "Last month",
				vi: "Tháng trước",
				ru: "Прошлый месяц",
				tr: "Geçen ay",
				ja: "最近1か月",
			},
			clo7: {
				zh: "最近三个月",
				en: "Last three months",
				vi: "Ba tháng qua",
				ru: "Последние три месяца",
				tr: "Son üç ay",
				ja: "最近3か月",
			},
			adminLog01: {
				zh: "审核设置成功",
				en: "Audit settings successfully",
				vi: "Cài đặt kiểm tra thành công",
				ru: "Настройка проверки успешно",
				tr: "Denetim ayarları başarıyla yapıldı",
				ja: "監査設定が成功しました"
			},
			adminLog02: {
				zh: "审核权限清空成功",
				en: "Audit permissions cleared successfully",
				vi: "Quyền kiểm tra đã được xóa thành công",
				ru: "Права проверки успешно очищены",
				tr: "Denetim izinleri başarıyla temizlendi",
				ja: "監査権限が正常にクリアされました"
			},
			adminLog03: {
				zh: "添加设备成功",
				en: "Device added successfully",
				vi: "Thêm thiết bị thành công",
				ru: "Устройство успешно добавлено",
				tr: "Cihaz başarıyla eklendi",
				ja: "デバイスが正常に追加されました"
			},
			adminLog04: {
				zh: "添加素材成功",
				en: "Material added successfully",
				vi: "Thêm tài liệu thành công",
				ru: "Материал успешно добавлен",
				tr: "Malzeme başarıyla eklendi",
				ja: "素材が正常に追加されました"
			},
			adminLog05: {
				zh: "上传素材文件成功",
				en: "Material file uploaded successfully",
				vi: "Tải tệp tài liệu lên thành công",
				ru: "Файл материала успешно загружен",
				tr: "Malzeme dosyası başarıyla yüklendi",
				ja: "素材ファイルが正常にアップロードされました"
			},
			adminLog06: {
				zh: "删除设备成功",
				en: "Device deleted successfully",
				vi: "Xóa thiết bị thành công",
				ru: "Устройство успешно удалено",
				tr: "Cihaz başarıyla silindi",
				ja: "デバイスが正常に削除されました"
			},
			adminLog07: {
				zh: "添加节目成功",
				en: "Program added successfully",
				vi: "Thêm chương trình thành công",
				ru: "Программа успешно добавлена",
				tr: "Program başarıyla eklendi",
				ja: "番組が正常に追加されました"
			},
			adminLog08: {
				zh: "添加发布成功",
				en: "Publication added successfully",
				vi: "Thêm bản phát hành thành công",
				ru: "Публикация успешно добавлена",
				tr: "Yayın başarıyla eklendi",
				ja: "公開が正常に追加されました"
			},
			adminLog09: {
				zh: "添加用户成功",
				en: "User added successfully",
				vi: "Thêm người dùng thành công",
				ru: "Пользователь успешно добавлен",
				tr: "Kullanıcı başarıyla eklendi",
				ja: "ユーザーが正常に追加されました"
			},
			adminLog10: {
				zh: "编辑用户成功",
				en: "User edited successfully",
				vi: "Chỉnh sửa người dùng thành công",
				ru: "Пользователь успешно отредактирован",
				tr: "Kullanıcı başarıyla düzenlendi",
				ja: "ユーザーが正常に編集されました"
			},
			adminLog11: {
				zh: "删除素材成功",
				en: "Material deleted successfully",
				vi: "Xóa tài liệu thành công",
				ru: "Материал успешно удален",
				tr: "Malzeme başarıyla silindi",
				ja: "素材が正常に削除されました"
			},
			adminLog12: {
				zh: "编辑设备成功",
				en: "Device edited successfully",
				vi: "Chỉnh sửa thiết bị thành công",
				ru: "Устройство успешно отредактировано",
				tr: "Cihaz başarıyla düzenlendi",
				ja: "デバイスが正常に編集されました"
			},
			adminLog13: {
				zh: "删除节目成功",
				en: "Program deleted successfully",
				vi: "Xóa chương trình thành công",
				ru: "Программа успешно удалена",
				tr: "Program başarıyla silindi",
				ja: "番組が正常に削除されました"
			},
			adminLog14: {
				zh: "编辑节目成功",
				en: "Program edited successfully",
				vi: "Chỉnh sửa chương trình thành công",
				ru: "Программа успешно отредактирована",
				tr: "Program başarıyla düzenlendi",
				ja: "番組が正常に編集されました"
			},
			adminLog15: {
				zh: "修改自身信息成功",
				en: "Self-information modified successfully",
				vi: "Thông tin bản thân đã được chỉnh sửa thành công",
				ru: "Информация о себе успешно изменена",
				tr: "Kendi bilgileriniz başarıyla değiştirildi",
				ja: "自身の情報が正常に変更されました"
			},
			adminLog16: {
				zh: "审核设置成功",
				en: "Audit settings successfully",
				vi: "Cài đặt kiểm tra thành công",
				ru: "Настройка проверки успешно",
				tr: "Denetim ayarları başarıyla yapıldı",
				ja: "監査設定が成功しました"
			},
			adminLog17: {
				zh: "添加目录成功",
				en: "Directory added successfully",
				vi: "Thêm thư mục thành công",
				ru: "Каталог успешно добавлен",
				tr: "Dizin başarıyla eklendi",
				ja: "ディレクトリが正常に追加されました"
			},
			adminLog18: {
				zh: "删除用户成功",
				en: "User deleted successfully",
				vi: "Xóa người dùng thành công",
				ru: "Пользователь успешно удален",
				tr: "Kullanıcı başarıyla silindi",
				ja: "ユーザーが正常に削除されました"
			},
			adminLog19: {
				zh: "编辑目录成功",
				en: "Directory edited successfully",
				vi: "Chỉnh sửa thư mục thành công",
				ru: "Каталог успешно отредактирован",
				tr: "Dizin başarıyla düzenlendi",
				ja: "ディレクトリが正常に編集されました"
			},
			adminLog20: {
				zh: "移动目录成功",
				en: "Directory moved successfully",
				vi: "Di chuyển thư mục thành công",
				ru: "Каталог успешно перемещен",
				tr: "Dizin başarıyla taşındı",
				ja: "ディレクトリが正常に移動されました"
			},
			adminLog21: {
				zh: "删除目录成功",
				en: "Directory deleted successfully",
				vi: "Xóa thư mục thành công",
				ru: "Каталог успешно удален",
				tr: "Dizin başarıyla silindi",
				ja: "ディレクトリが正常に削除されました"
			},
			adminLog22: {
				zh: "删除发布成功",
				en: "Publication deleted successfully",
				vi: "Xóa bản phát hành thành công",
				ru: "Публикация успешно удалена",
				tr: "Yayın başarıyla silindi",
				ja: "公開が正常に削除されました"
			},
			adminLog23: {
				zh: "添加素材成功",
				en: "Material added successfully",
				vi: "Thêm tài liệu thành công",
				ru: "Материал успешно добавлен",
				tr: "Malzeme başarıyla eklendi",
				ja: "素材が正常に追加されました"
			},
			adminLog24: {
				zh: "重新发布成功",
				en: "Re-published successfully",
				vi: "Phát hành lại thành công",
				ru: "Успешно переопубликовано",
				tr: "Başarıyla yeniden yayımlandı",
				ja: "再公開が正常に行われました"
			},
			adminLog25: {
				zh: "发布审核执行成功",
				en: "Release review executed successfully",
				vi: "Thực hiện kiểm tra phát hành thành công",
				ru: "Проверка публикации выполнена успешно",
				tr: "Yayın incelemesi başarıyla gerçekleştirildi",
				ja: "公開審査が正常に実行されました"
			},
			adminLog26: {
				zh: "节目审核执行成功",
				en: "Program review executed successfully",
				vi: "Thực hiện kiểm tra chương trình thành công",
				ru: "Проверка программы выполнена успешно",
				tr: "Program incelemesi başarıyla gerçekleştirildi",
				ja: "番組審査が正常に実行されました"
			},
			adminLog27: {
				zh: "素材审核执行成功",
				en: "Material review executed successfully",
				vi: "Thực hiện kiểm tra tài liệu thành công",
				ru: "Проверка материала выполнена успешно",
				tr: "Malzeme incelemesi başarıyla gerçekleştirildi",
				ja: "素材審査が正常に実行されました"
			},
			adminLog28: {
				zh: "登录地址",
				en: "Login address",
				vi: "Địa chỉ đăng nhập",
				ru: "Адрес входа",
				tr: "Giriş adresi",
				ja: "ログインアドレス"
			},
			adminLog29: {
				zh: "关屏",
				en: "Turn off screen",
				vi: "Tắt màn hình",
				ru: "Выключить экран",
				tr: "Ekranı kapat",
				ja: "画面をオフにする"
			},
			adminLog30: {
				zh: "开屏",
				en: "Turn on screen",
				vi: "Bật màn hình",
				ru: "Включить экран",
				tr: "Ekranı aç",
				ja: "画面をオンにする"
			},
			adminLog31: {
				zh: "信号切换",
				en: "Signal switch",
				vi: "Chuyển đổi tín hiệu",
				ru: "Переключение сигнала",
				tr: "Sinyal değişimi",
				ja: "信号切替"
			},
			adminLog32: {
				zh: "定时指令",
				en: "Scheduled command",
				vi: "Lệnh theo lịch",
				ru: "Запланированная команда",
				tr: "Zamanlanmış komut",
				ja: "定時コマンド"
			},
			adminLog33: {
				zh: "重启",
				en: "Reboot",
				vi: "Khởi động lại",
				ru: "Перезагрузка",
				tr: "Yeniden başlat",
				ja: "再起動"
			},
			adminLog34: {
				zh: "亮度调节",
				en: "Brightness adjustment",
				vi: "Điều chỉnh độ sáng",
				ru: "Регулировка яркости",
				tr: "Parlaklık ayarı",
				ja: "明るさ調整"
			},
			adminLog35: {
				zh: "定时播放开关",
				en: "Scheduled playback switch",
				vi: "Chuyển đổi phát lại theo lịch",
				ru: "Переключатель запланированного воспроизведения",
				tr: "Zamanlanmış oynatma anahtarı",
				ja: "定時再生スイッチ"
			},
			adminLog36: {
				zh: "音量调节",
				en: "Volume adjustment",
				vi: "Điều chỉnh âm lượng",
				ru: "Регулировка громкости",
				tr: "Ses ayarı",
				ja: "音量調整"
			},
			adminLog37: {
				zh: "继电器开关",
				en: "Relay switch",
				vi: "Công tắc rơ le",
				ru: "Переключатель реле",
				tr: "Röle anahtarı",
				ja: "リレー切替"
			},
			adminLog38: {
				zh: "时区校准",
				en: "Timezone calibration",
				vi: "Hiệu chỉnh múi giờ",
				ru: "Калибровка часового пояса",
				tr: "Zaman dilimi kalibrasyonu",
				ja: "タイムゾーン校正"
			},
			adminLog39: {
				zh: "定时开机",
				en: "Scheduled power on",
				vi: "Mở máy theo lịch",
				ru: "Запланированное включение",
				tr: "Zamanlanmış açılış",
				ja: "定時起動"
			},
			adminLog40: {
				zh: "系统升级",
				en: "System upgrade",
				vi: "Cập nhật hệ thống",
				ru: "Обновление системы",
				tr: "Sistem yükseltmesi",
				ja: "システムアップグレード"
			},
			adminLog41: {
				zh: "多屏同步",
				en: "Multi-screen synchronization",
				vi: "Đồng bộ đa màn hình",
				ru: "Синхронизация многоканальных экранов",
				tr: "Çoklu ekran senkronizasyonu",
				ja: "マルチスクリーン同期"
			},
			adminLog42: {
				zh: "云看护开关",
				en: "Cloud care switch",
				vi: "Công tắc chăm sóc đám mây",
				ru: "Переключатель облачной заботы",
				tr: "Bulut bakımı anahtarı",
				ja: "クラウドケアスイッチ"
			},
			adminLog43: {
				zh: "Apk升级",
				en: "APK upgrade",
				vi: "Cập nhật APK",
				ru: "Обновление APK",
				tr: "APK yükseltmesi",
				ja: "APKアップグレード"
			},
			adminLog44: {
				zh: "截屏",
				en: "Screenshot",
				vi: "Chụp màn hình",
				ru: "Скриншот",
				tr: "Ekran görüntüsü",
				ja: "スクリーンショット"
			},
			adminLog45: {
				zh: "终端指令",
				en: "Terminal command",
				vi: "Lệnh terminal",
				ru: "Команда терминала",
				tr: "Terminal komutu",
				ja: "ターミナルコマンド"
			}
		},
		TerminalLog: {
			clt1: {
				zh: "编号查询",
				en: "Number query",
				vi: "Truy vấn số",
				ru: "Числовой запрос",
				tr: "Numara sorgusu",
				ja: "番号付けクエリー",
			},
			clt2: {
				zh: "未查询到",
				en: "Not found",
				vi: "Không tìm thấy",
				ru: "Не запрашивался",
				tr: "Bulunamadı",
				ja: "クエリされていません",
			}
		}
	},
	login: {
		indexLogin: {
			lil1: {
				zh: "国家/地区",
				en: "Country/Region",
				vi: "Quốc gia/Khu vực",
				ru: "Страна/Регион",
				tr: "Ülke/Bölge",
				ja: "国/地域"
			},
			lil2: {
				zh: "中国",
				en: "China",
				vi: "Trung Quốc",
				ru: "Китай",
				tr: "Çin",
				ja: "中国"
			},
			lil3: {
				zh: "国际",
				en: "International",
				vi: "Quốc tế",
				ru: "Международный",
				tr: "Uluslararası",
				ja: "国際"
			}
		},
		Register: {
			clr1: {
				zh: "用户注册",
				en: "User Registration",
				vi: "Đăng ký người dùng",
				ru: "Регистрация пользователя",
				tr: "Kullanıcı Kaydı",
				ja: "ユーザー登録",
			},
			clr2: {
				zh: "账号",
				en: "Account",
				vi: "tài khoản",
				ru: "счет",
				tr: "hesap",
				ja: "アカウント",
			},
			clr3: {
				zh: "推荐码",
				en: "Referral Code",
				vi: "Mã giới thiệu",
				ru: "Рекомендательный код",
				tr: "Yönlendirme Kodu",
				ja: "推奨コード",
			},
			clr4: {
				zh: "获取推荐码请联系销售人员！",
				en: "Please contact sales to get the referral code!",
				vi: "Vui lòng liên hệ bộ phận bán hàng để nhận mã giới thiệu!",
				ru: "Пожалуйста, свяжитесь с отделом продаж, чтобы получить рекомендательный код!",
				tr: "Referans kodunu almak için lütfen satış ekibiyle iletişime geçin!",
				ja: "推奨コードを入手するには販売員に連絡してください！",
			},
			clr5: {
				zh: "邮箱",
				en: "Mail",
				vi: "Thư",
				ru: "электронная почта",
				tr: "Posta",
				ja: "メールボックス",
			},
			clr6: {
				zh: "验证码",
				en: "Verification Code",
				vi: "Mã xác nhận",
				ru: "Код подтверждения",
				tr: "Doğrulama Kodu",
				ja: "認証コード",
			},
			clr7: {
				zh: "获取验证码",
				en: "get verification code",
				vi: "lấy mã xác minh",
				ru: "Получить проверочный код",
				tr: "doğrulama kodunu al",
				ja: "認証コードの取得",
			},
			clr8: {
				zh: "秒重新获取",
				en: "Re-acquire in seconds",
				vi: "Lấy lại sau vài giây",
				ru: "Восстановиться за считанные секунды",
				tr: "Saniyeler içinde yeniden edinin",
				ja: "秒再取得",
			},
			clr9: {
				zh: "密码",
				en: "Password",
				vi: "mật khẩu",
				ru: "код",
				tr: "şifre",
				ja: "パスワード",
			},
			clr10: {
				zh: "确认密码",
				en: "Confirm Pass",
				vi: "Xác nhận mật khẩu",
				ru: "Подтвердите пароль",
				tr: "Şifreyi Onayla",
				ja: "パスワードの確認",
			},
			clr11: {
				zh: "企业名称",
				en: "Grouping",
				vi: "Nhóm",
				ru: "разделиться на группы",
				tr: "Gruplama",
				ja: "グループ化",
			},
			clr12: {
				zh: "立即注册",
				en: "Sign up now",
				vi: "Đăng ký ngay",
				ru: "Зарегистрируйтесь прямо сейчас",
				tr: "Şimdi kaydolun",
				ja: "今すぐ登録",
			},
			clr13: {
				zh: "已有帐号",
				en: "Already have an account",
				vi: "Bạn đã có tài khoản",
				ru: "У вас уже есть учетная запись",
				tr: "Zaten bir hesabınız var",
				ja: "既存のアカウント",
			},
			clr14: {
				zh: "立即登录",
				en: "log in immediately",
				vi: "đăng nhập ngay lập tức",
				ru: "Войдите в систему прямо сейчас",
				tr: "hemen giriş yapın",
				ja: "今すぐログイン",
			},
			clr15: {
				zh: "请再次输入密码",
				en: "Please enter your password again",
				vi: "Vui lòng nhập lại mật khẩu của bạn",
				ru: "Пожалуйста, введите пароль еще раз",
				tr: "Lütfen şifrenizi tekrar girin",
				ja: "パスワードを再入力してください",
			},
			clr16: {
				zh: "两次输入密码不一致!",
				en: "The passwords you entered twice do not match!",
				vi: "Mật khẩu bạn nhập hai lần không khớp!",
				ru: "Введенный дважды пароль является несогласованным!",
				tr: "İki kez girdiğiniz şifreler eşleşmiyor!",
				ja: "2回の入力パスワードが一致しません！",
			},
			clr17: {
				zh: "请输入用户名！",
				en: "please enter user name!",
				vi: "Vui lòng nhập tên người dùng!",
				ru: "Пожалуйста, введите имя пользователя!",
				tr: "lütfen kullanıcı adını giriniz!",
				ja: "ユーザー名を入力してください！",
			},
			clr18: {
				zh: "请填写推荐码",
				en: "Please fill in the referral code",
				vi: "Vui lòng điền mã giới thiệu",
				ru: "Пожалуйста, введите рекомендательный код",
				tr: "Lütfen yönlendirme kodunu doldurunuz",
				ja: "推奨コードを記入してください",
			},
			clr19: {
				zh: "请填写验证码",
				en: "Please fill in the verification code",
				vi: "Vui lòng điền mã xác minh",
				ru: "Пожалуйста, введите проверочный код",
				tr: "Lütfen doğrulama kodunu doldurun",
				ja: "認証コードを入力してください",
			},
			clr20: {
				zh: "请填写邮箱",
				en: "please enter your email",
				vi: "Vui lòng nhập email",
				ru: "Пожалуйста, введите адрес электронной почты",
				tr: "lütfen e-postanızı girin",
				ja: "メールアドレスを入力してください",
			},
			clr21: {
				zh: "请填写密码",
				en: "Please fill in the password",
				vi: "Vui lòng điền mật khẩu",
				ru: "Пожалуйста, введите пароль",
				tr: "Lütfen şifreyi girin",
				ja: "パスワードを入力してください",
			},
			clr22: {
				zh: "请填写用户分组",
				en: "Please fill in the user group",
				vi: "Vui lòng điền vào nhóm người dùng",
				ru: "Пожалуйста, заполните группу пользователей",
				tr: "Lütfen kullanıcı grubunu doldurun",
				ja: "ユーザーグループに入力してください",
			},
			clr23: {
				zh: "验证码已发送，请注意查收!",
				en: "The verification code has been sent, please check it!",
				vi: "Mã xác minh đã được gửi, vui lòng kiểm tra!",
				ru: "Проверочный код был отправлен, пожалуйста, обратите внимание на его проверку!",
				tr: "Doğrulama kodu gönderildi, lütfen kontrol edin!",
				ja: "認証コードが送信されました。ご確認ください。",
			},
			clr24: {
				zh: "请同意服务协议和隐私协议",
				en: "Please agree to the service agreement and privacy policy",
				vi: "Vui lòng đồng ý với điều khoản dịch vụ và chính sách quyền riêng tư",
				ru: "Пожалуйста, согласитесь с условиями обслуживания и политикой конфиденциальности",
				tr: "Lütfen hizmet sözleşmesine ve gizlilik politikasına katılın",
				ja: "サービス契約とプライバシーポリシーに同意してください",
			},
			clr25: {
				zh: "请输入正确的手机号",
				en: "Please enter a valid phone number",
				vi: "Vui lòng nhập số điện thoại hợp lệ",
				ru: "Пожалуйста, введите правильный номер телефона",
				tr: "Lütfen geçerli bir telefon numarası girin",
				ja: "正しい電話番号を入力してください",
			},
			clr26: {
				zh: "请选择企业地址",
				en: "Please select the company address",
				vi: "Vui lòng chọn địa chỉ công ty",
				ru: "Пожалуйста, выберите адрес компании",
				tr: "Lütfen şirket adresini seçin",
				ja: "企業住所を選択してください",
			},
			clr27: {
				zh: "请输入详细地址",
				en: "Please enter the detailed address",
				vi: "Vui lòng nhập địa chỉ chi tiết",
				ru: "Пожалуйста, введите подробный адрес",
				tr: "Lütfen detaylı adresi girin",
				ja: "詳細な住所を入力してください",
			}
		},
		ResetPd: {
			clrp1: {
				zh: "重置密码",
				en: "reset Password",
				vi: "đặt lại mật khẩu",
				ru: "Сброс пароля",
				tr: "Şifreyi sıfırla",
				ja: "パスワードをリセット",
			},
			clrp2: {
				zh: "身份验证",
				en: "Authentication",
				vi: "Xác thực",
				ru: "Идентификация",
				tr: "Kimlik doğrulama",
				ja: "認証",
			},
			clrp3: {
				zh: "重置密码",
				en: "reset Password",
				vi: "đặt lại mật khẩu",
				ru: "Сброс пароля",
				tr: "Şifreyi sıfırla",
				ja: "パスワードをリセット",
			},
			clrp4: {
				zh: "账号",
				en: "Account",
				vi: "tài khoản",
				ru: "счет",
				tr: "hesap",
				ja: "アカウント",
			},
			clrp5: {
				zh: "邮箱",
				en: "Mail",
				vi: "Thư",
				ru: "электронная почта",
				tr: "Posta",
				ja: "メールボックス",
			},
			clrp6: {
				zh: "验证码",
				en: "Verification Code",
				vi: "Mã xác nhận",
				ru: "Код подтверждения",
				tr: "Doğrulama Kodu",
				ja: "認証コード",
			},
			clrp7: {
				zh: "获取验证码",
				en: "get verification code",
				vi: "lấy mã xác minh",
				ru: "Получить проверочный код",
				tr: "doğrulama kodunu al",
				ja: "認証コードの取得",
			},
			clrp8: {
				zh: "秒重新获取",
				en: "Re-acquire in seconds",
				vi: "Lấy lại sau vài giây",
				ru: "Восстановиться за считанные секунды",
				tr: "Saniyeler içinde yeniden edinin",
				ja: "秒再取得",
			},
			clrp9: {
				zh: "新密码",
				en: "New Password",
				vi: "mật khẩu mới",
				ru: "Новый пароль",
				tr: "Yeni Şifre",
				ja: "新しいパスワード",
			},
			clrp10: {
				zh: "确认密码",
				en: "Confirm Pass",
				vi: "Xác nhận mật khẩu",
				ru: "Подтвердите пароль",
				tr: "Şifreyi Onayla",
				ja: "パスワードの確認",
			},
			clrp11: {
				zh: "立即验证",
				en: "confirm at once",
				vi: "xác nhận ngay lập tức",
				ru: "Проверить сейчас",
				tr: "hemen onayla",
				ja: "今すぐ検証",
			},
			clrp12: {
				zh: "已有帐号",
				en: "Already have an account",
				vi: "Bạn co săn san để tạo một tai khoản",
				ru: "У вас уже есть учетная запись",
				tr: "Zaten bir hesabınız var",
				ja: "既存のアカウント",
			},
			clrp13: {
				zh: "立即登录",
				en: "log in immediately",
				vi: "đăng nhập ngay lập tức",
				ru: "Войдите в систему прямо сейчас",
				tr: "hemen giriş yapın",
				ja: "今すぐログイン",
			},
			clrp14: {
				zh: "请再次输入密码",
				en: "Please enter your password again",
				vi: "Vui lòng nhập lại mật khẩu của bạn",
				ru: "Пожалуйста, введите пароль еще раз",
				tr: "Lütfen şifrenizi tekrar girin",
				ja: "パスワードを再入力してください",
			},
			clrp15: {
				zh: "两次输入密码不一致!",
				en: "The passwords you entered twice do not match!",
				vi: "Mật khẩu bạn nhập hai lần không khớp!",
				ru: "Введенный дважды пароль является несогласованным!",
				tr: "İki kez girdiğiniz şifreler eşleşmiyor!",
				ja: "2回の入力パスワードが一致しません！",
			},
			clrp16: {
				zh: "请输入用户名！",
				en: "please enter user name!",
				vi: "Vui lòng nhập tên người dùng!",
				ru: "Пожалуйста, введите имя пользователя!",
				tr: "lütfen kullanıcı adını giriniz!",
				ja: "ユーザー名を入力してください！",
			},
			clrp17: {
				zh: "请填写邮箱",
				en: "please enter your email",
				vi: "Vui lòng nhập email",
				ru: "Пожалуйста, введите адрес электронной почты",
				tr: "lütfen e-postanızı girin",
				ja: "メールアドレスを入力してください",
			},
			clrp18: {
				zh: "请填写验证码",
				en: "Please fill in the verification code",
				vi: "Vui lòng điền mã xác minh",
				ru: "Пожалуйста, введите проверочный код",
				tr: "Lütfen doğrulama kodunu doldurun",
				ja: "認証コードを入力してください",
			},
			clrp19: {
				zh: "请填写密码",
				en: "Please fill in the password",
				vi: "Vui lòng điền mật khẩu",
				ru: "Пожалуйста, введите пароль",
				tr: "Lütfen şifreyi girin",
				ja: "パスワードを入力してください",
			},
			clrp20: {
				zh: "验证码已发送，请注意查收!",
				en: "The verification code has been sent, please check it!",
				vi: "Mã xác minh đã được gửi, vui lòng kiểm tra!",
				ru: "Проверочный код был отправлен, пожалуйста, обратите внимание на его проверку!",
				tr: "Doğrulama kodu gönderildi, lütfen kontrol edin!",
				ja: "認証コードが送信されました。ご確認ください。",
			}
		}
	},
	manage: {
		ReviewSetting: {
			cmr1: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			cmr2: {
				zh: "素材审核",
				en: "Material review",
				vi: "Đánh giá tài liệu",
				ru: "Обзор материалов",
				tr: "Malzeme incelemesi",
				ja: "素材審査",
			},
			cmr3: {
				zh: "清空",
				en: "Clear",
				vi: "Trống",
				ru: "очищать",
				tr: "Temizlemek",
				ja: "クリアランス",
			},
			cmr4: {
				zh: "节目审核",
				en: "Program Review",
				vi: "Đánh giá chương trình",
				ru: "Обзор программы",
				tr: "Program İncelemesi",
				ja: "番組審査",
			},
			cmr5: {
				zh: "发布审核",
				en: "Release Review",
				vi: "Đánh giá phát hành",
				ru: "Обзор выпуска",
				tr: "Sürüm İncelemesi",
				ja: "レビューの発行",
			},
			cmr6: {
				zh: "允许插播审核",
				en: "Allow interstitial review",
				vi: "Cho phép xem xét xen kẽ",
				ru: "Разрешить промежуточный обзор",
				tr: "Geçiş reklamı incelemesine izin ver",
				ja: "補間監査の許可",
			},
			cmr7: {
				zh: "张三,李四,王五",
				en: "Zhang San, Li Si, Wang Wu",
				vi: "Trương Tam, Lý Tư, Vương Ngũ",
				ru: "Чжан Сань, Ли Си, Ван Ву",
				tr: "Zhang San, Li Si, Wang Wu",
				ja: "張三、李四、王五",
			},
			cmr8: {
				zh: "是否清空当前所有审核人员?",
				en: "Do you want to clear all current reviewers?",
				vi: "Bạn có muốn xóa tất cả những người đánh giá hiện tại không?",
				ru: "Вы удаляете всех текущих аудиторов?",
				tr: "Mevcut incelemecilerin tümünü temizlemek istiyor musunuz?",
				ja: "現在のレビュー担当者をすべてクリアしますか？",
			},
			cmr9: {
				zh: "是否清空当前审核人员?",
				en: "Do you want to clear the current reviewer?",
				vi: "Bạn có muốn xóa người đánh giá hiện tại không?",
				ru: "Допущен ли нынешний аудитор к работе?",
				tr: "Mevcut incelemeciyi temizlemek istiyor musunuz?",
				ja: "現在のレビュー担当者を空にしますか？",
			},
			cmr10: {
				zh: "无相关审核权限的人员,请先创建审核账号",
				en: "If you do not have the relevant audit authority, please create an audit account first.",
				vi: "Nếu bạn không có cơ quan kiểm toán liên quan, trước tiên hãy tạo một tài khoản kiểm toán.",
				ru: "Для тех, у кого нет соответствующих аудиторских полномочий, пожалуйста, сначала создайте учетную запись аудитора",
				tr: "İlgili denetim otoriteniz yoksa lütfen önce bir denetim hesabı oluşturun.",
				ja: "レビュー権限がない人は、まずレビューアカウントを作成してください",
			},
			cmr11: {
				zh: "下一机构共用同一审核人员",
				en: "Share the same reviewer with the next institution",
				vi: "Chia sẻ cùng một người đánh giá với tổ chức tiếp theo",
				ru: "В следующей организации используется тот же самый аудитор",
				tr: "Aynı incelemeciyi bir sonraki kurumla paylaşın",
				ja: "次の機関は同じレビュー担当者を共有",
			},
			cmr12: {
				zh: "取消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять",
				tr: "İptal etmek",
				ja: "キャンセル",
			},
			cmr13: {
				zh: "确定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "уверенный",
				tr: "Elbette",
				ja: "を選択して、",
			}
		}
	},
	review: {
		children: {
			ProgramMaterial: {
				crcp1: {
					zh: "视频",
					en: "video",
					vi: "băng hình",
					ru: "видео",
					tr: "video",
					ja: "ビデオ",
				},
				crcp2: {
					zh: "图片",
					en: "picture",
					vi: "hình ảnh",
					ru: "картинка",
					tr: "resim",
					ja: "画像",
				}
			},
			PublichCheck: {
				crcpc1: {
					zh: "播放时间轴",
					en: "Playback timeline",
					vi: "Dòng thời gian phát lại",
					ru: "Временная шкала воспроизведения",
					tr: "Oynatma zaman çizelgesi",
					ja: "時間軸の再生",
				},
				crcpc2: {
					zh: "节目预览",
					en: "Program Preview",
					vi: "Xem trước chương trình",
					ru: "Предварительный просмотр программы",
					tr: "Program Önizlemesi",
					ja: "プログラムのプレビュー",
				},
				crcpc3: {
					zh: "发布审核",
					en: "Release Review",
					vi: "Đánh giá phát hành",
					ru: "Обзор выпуска",
					tr: "Sürüm İncelemesi",
					ja: "レビューの発行",
				},
				crcpc4: {
					zh: "原因",
					en: "reason",
					vi: "lý do",
					ru: "соображение",
					tr: "sebep",
					ja: "理由",
				}
			}
		},
		CheckManage: {
			crc1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			}
		},
		IssueCheck: {
			crl1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			},
			crl2: {
				zh: "删除",
				en: "delete",
				vi: "xóa bỏ",
				ru: "стирать",
				tr: "silmek",
				ja: "削除＃サクジョ＃",
			},
			crl3: {
				zh: "确定删除当前选中审核条目",
				en: "Confirm to delete the currently selected audit entry",
				vi: "Xác nhận xóa mục kiểm tra hiện được chọn",
				ru: "Убедитесь в том, что вы удалили текущую выбранную запись аудита",
				tr: "Şu anda seçili denetim girişini silmeyi onaylayın",
				ja: "OK：現在選択されているレビューエントリを削除します",
			},
			crl4: {
				zh: "未审核不能删除",
				en: "Unreviewed and cannot be deleted",
				vi: "Chưa được xem xét và không thể xóa được",
				ru: "Неаудированные данные не могут быть удалены",
				tr: "İncelenmedi ve silinemez",
				ja: "未レビューは削除できません",
			},
			crl5: {
				zh: "删除成功",
				en: "successfully deleted",
				vi: "đã xóa thành công",
				ru: "Успешно удален",
				tr: "başarıyla silindi",
				ja: "削除に成功しました",
			},
			crl6: {
				zh: "请至少选择一条记录",
				en: "Please select at least one record",
				vi: "Vui lòng chọn ít nhất một bản ghi",
				ru: "Пожалуйста, выберите хотя бы одну запись",
				tr: "Lütfen en az bir kayıt seçin",
				ja: "少なくとも1つのレコードを選択してください",
			},
			crl7: {
				zh: "刷新",
				en: "refresh",
				vi: "Làm mới",
				ru: "обновлять",
				tr: "yenileme",
				ja: "リフレッシュ",
			},
			crl8: {
				zh: "原因",
				en: "reason",
				vi: "lý do",
				ru: "соображение",
				tr: "sebep",
				ja: "理由",
			}
		},
		MaterialCheck: {
			crm1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			},
			crm2: {
				zh: "删除",
				en: "delete",
				vi: "xóa bỏ",
				ru: "стирать",
				tr: "silmek",
				ja: "削除＃サクジョ＃",
			},
			crm3: {
				zh: "确定删除当前选中审核条目",
				en: "Confirm to delete the currently selected audit entry",
				vi: "Xác nhận xóa mục kiểm tra hiện được chọn",
				ru: "Убедитесь в том, что вы удалили текущую выбранную запись аудита",
				tr: "Şu anda seçili denetim girişini silmeyi onaylayın",
				ja: "OK：現在選択されているレビューエントリを削除します",
			},
			crm4: {
				zh: "未审核不能删除",
				en: "Unreviewed and cannot be deleted",
				vi: "Chưa được xem xét và không thể xóa được",
				ru: "Неаудированные данные не могут быть удалены",
				tr: "İncelenmedi ve silinemez",
				ja: "未レビューは削除できません",
			},
			crm5: {
				zh: "删除成功",
				en: "successfully deleted",
				vi: "đã xóa thành công",
				ru: "Успешно удален",
				tr: "başarıyla silindi",
				ja: "削除に成功しました",
			},
			crm6: {
				zh: "选择的数据",
				en: "Selected Data",
				vi: "Dữ liệu đã chọn",
				ru: "Выбранные данные",
				tr: "Seçilen Veriler",
				ja: "選択したデータ",
			}
		},
		ProgramCheck: {
			crp1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			},
			crp2: {
				zh: "批量审核选中节目",
				en: "Batch review of selected programs",
				vi: "Đánh giá hàng loạt các chương trình đã chọn",
				ru: "Пакетный просмотр выбранных программ",
				tr: "Seçilen programların toplu incelemesi",
				ja: "選択した番組の一括レビュー",
			},
			crp3: {
				zh: "确定删除当前选中审核条目",
				en: "Confirm to delete the currently selected audit entry",
				vi: "Xác nhận xóa mục kiểm tra hiện được chọn",
				ru: "Убедитесь в том, что вы удалили текущую выбранную запись аудита",
				tr: "Şu anda seçili denetim girişini silmeyi onaylayın",
				ja: "OK：現在選択されているレビューエントリを削除します",
			},
			crp4: {
				zh: "未选择节目",
				en: "No program selected",
				vi: "Không có chương trình nào được chọn",
				ru: "Невыбранная программа",
				tr: "Hiçbir program seçilmedi",
				ja: "プログラムが選択されていません",
			},
			crp5: {
				zh: "未审核不能删除",
				en: "Unreviewed and cannot be deleted",
				vi: "Chưa được xem xét và không thể xóa được",
				ru: "Неаудированные данные не могут быть удалены",
				tr: "İncelenmedi ve silinemez",
				ja: "未レビューは削除できません",
			},
			crp6: {
				zh: "删除成功",
				en: "successfully deleted",
				vi: "đã xóa thành công",
				ru: "Успешно удален",
				tr: "başarıyla silindi",
				ja: "削除に成功しました",
			}
		}
	},
	schedule: {
		children: {
			items: {
				TimePlanItems: {
					cscit1: {
						zh: "总播放次数",
						en: "Total plays",
						vi: "Tổng số lần phát lại",
						ru: "Общее количество воспроизведений",
						tr: "Toplam oynatma süreleri",
						ja: "総再生回数",
					},
					cscit2: {
						zh: "开始日期是",
						en: "Start date is",
						vi: "Ngày bắt đầu là",
						ru: "Датой начала является",
						tr: "Başlangıç ​​tarihi:",
						ja: "開始日Yes",
					},
					cscit3: {
						zh: "选择的开始日期不能早于今天",
						en: "Select a start date that cannot be earlier than today",
						vi: "Chọn ngày bắt đầu không thể sớm hơn ngày hôm nay",
						ru: "Выбранная дата начала не может быть ранее сегодняшнего дня",
						tr: "Bugünden daha erken olamayacak bir başlangıç ​​tarihi seçin",
						ja: "選択した開始日に今日より前の日付は指定できません",
					},
					cscit4: {
						zh: "触发",
						en: "trigger",
						vi: "Kích hoạt",
						ru: "инициировать",
						tr: "tetiklemek",
						ja: "トリガ",
					}
				},
				TimerShaft: {
					cscits1: {
						zh: "排程时间",
						en: "Schedule time",
						vi: "Thời gian biểu",
						ru: "Запланируйте время",
						tr: "Zamanı planla",
						ja: "排程時間",
					},
					cscits2: {
						zh: "选择日期",
						en: "Select Date",
						vi: "Chọn ngày",
						ru: "Выберите дату",
						tr: "Tarih Seçin",
						ja: "日付の選択",
					}
				}
			},
			AddSchedule: {
				csca1: {
					zh: "点击或向上滑动继续加载",
					en: "Click or swipe up to continue loading",
					vi: "Nhấp hoặc vuốt lên để tiếp tục tải",
					ru: "Нажмите или проведите пальцем вверх, чтобы продолжить загрузку",
					tr: "Yüklemeye devam etmek için tıklayın veya yukarı kaydırın",
					ja: "クリックまたは上にスライドしてロードを続行",
				},
				csca2: {
					zh: "向下滑动继续加载",
					en: "Swipe down to continue loading",
					vi: "Vuốt xuống để tiếp tục tải",
					ru: "Проведите пальцем вниз, чтобы продолжить загрузку",
					tr: "Yüklemeye devam etmek için aşağı kaydırın",
					ja: "下にスライドしてロードを続行",
				},
				csca3: {
					zh: "已加载全部资源",
					en: "All resources loaded",
					vi: "Đã tải tất cả tài nguyên",
					ru: "Все ресурсы были загружены",
					tr: "Tüm kaynaklar yüklendi",
					ja: "すべてのリソースがロードされました",
				},
				csca4: {
					zh: "关联设备",
					en: "Related equipment",
					vi: "Thiết bị liên quan",
					ru: "Сопутствующее оборудование",
					tr: "İlgili ekipman",
					ja: "関連デバイス",
				},
				csca5: {
					zh: "请选择关联设备",
					en: "Please select the associated device",
					vi: "Vui lòng chọn thiết bị được liên kết",
					ru: "Пожалуйста, выберите соответствующее устройство",
					tr: "Lütfen ilgili cihazı seçin",
					ja: "関連デバイスを選択してください",
				},
				csca6: {
					zh: "添加关联设备",
					en: "Add associated device",
					vi: "Thêm thiết bị liên quan",
					ru: "Добавление связанных устройств",
					tr: "İlişkili cihazı ekle",
					ja: "関連デバイスの追加",
				},
				csca7: {
					zh: "请选择播放模式",
					en: "Please select the playback mode",
					vi: "Vui lòng chọn chế độ phát lại",
					ru: "Пожалуйста, выберите режим воспроизведения",
					tr: "Lütfen oynatma modunu seçin",
					ja: "再生モードを選択してください",
				},
				csca8: {
					zh: "新增排程",
					en: "Add Schedule",
					vi: "Thêm lịch trình",
					ru: "Новое расписание",
					tr: "Program Ekle",
					ja: "新規スケジュール",
				},
				csca9: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "отменять",
					tr: "İptal etmek",
					ja: "キャンセル",
				},
				csca10: {
					zh: "保存",
					en: "save",
					vi: "cứu",
					ru: "сохранить",
					tr: "kaydetmek",
					ja: "保存＃ホゾン＃",
				},
				csca11: {
					zh: "提交",
					en: "submit",
					vi: "nộp",
					ru: "передавать",
					tr: "göndermek",
					ja: "送信",
				},
				csca12: {
					zh: "选择发布终端",
					en: "Select the publishing terminal",
					vi: "Chọn thiết bị đầu cuối đã phát hành",
					ru: "Выберите терминал публикации",
					tr: "Yayınlama terminalini seçin",
					ja: "リリース端末の選択",
				},
				csca13: {
					zh: "请输入查询终端",
					en: "Please enter the query terminal",
					vi: "Vui lòng nhập thiết bị đầu cuối truy vấn",
					ru: "Пожалуйста, войдите в терминал запроса",
					tr: "Lütfen sorgu terminalini girin",
					ja: "問い合わせ端末を入力してください",
				},
				csca14: {
					zh: "终端名称",
					en: "Terminal Name",
					vi: "Tên thiết bị đầu cuối",
					ru: "Название терминала",
					tr: "Terminal Adı",
					ja: "ターミナル名",
				},
				csca15: {
					zh: "组织结构",
					en: "Groups",
					vi: "Cơ cấu tổ chức",
					ru: "структура",
					tr: "Organizasyon Yapısı",
					ja: "組織構造",
				},
				csca16: {
					zh: "设备类型",
					en: "Equipment type",
					vi: "Loại thiết bị",
					ru: "Тип устройства",
					tr: "Ekipman türü",
					ja: "デバイスタイプ",
				},
				csca17: {
					zh: "设备状态",
					en: "device status",
					vi: "trạng thái thiết bị",
					ru: "Состояние устройства",
					tr: "cihaz durumu",
					ja: "デバイスの状態",
				},
				csca18: {
					zh: "离线",
					en: "Offline",
					vi: "Ngoại tuyến",
					ru: "не в сети",
					tr: "Çevrimdışı",
					ja: "オフライン",
				},
				csca19: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giiải",
					ru: "разрешение",
					tr: "Çözünürlük",
					ja: "解像度",
				},
				csca20: {
					zh: "文件筛选",
					en: "File Filtering",
					vi: "Lọc tệp",
					ru: "Фильтрация файлов",
					tr: "Dosya Filtreleme",
					ja: "ファイルフィルタ",
				},
				csca21: {
					zh: "循环播放",
					en: "Loop",
					vi: "Vòng lặp",
					ru: "Воспроизведение в цикле",
					tr: "Döngü",
					ja: "ループ再生",
				},
				csca22: {
					zh: "视频",
					en: "video",
					vi: "băng hình",
					ru: "видео",
					tr: "video",
					ja: "ビデオ",
				},
				csca23: {
					zh: "图片",
					en: "picture",
					vi: "hình ảnh",
					ru: "картинка",
					tr: "resim",
					ja: "画像",
				},
				csca24: {
					zh: "音乐",
					en: "music",
					vi: "âm nhạc",
					ru: "музыка",
					tr: "müzik",
					ja: "音楽",
				},
				csca25: {
					zh: "文本",
					en: "text",
					vi: "chữ",
					ru: "текст",
					tr: "metin",
					ja: "テキスト",
				},
				csca26: {
					zh: "文件类型",
					en: "file type",
					vi: "loại tệp",
					ru: "Тип файла",
					tr: "dosya türü",
					ja: "ファイルの種類",
				},
				csca27: {
					zh: "文件尺寸",
					en: "File size",
					vi: "Kích thước tập tin",
					ru: "Размер файла",
					tr: "Dosya boyutu",
					ja: "ファイルサイズ",
				},
				csca28: {
					zh: "文件大小",
					en: "File size",
					vi: "Kích thước tập tin",
					ru: "Размер файла",
					tr: "Dosya boyutu",
					ja: "ファイルサイズ",
				},
				csca29: {
					zh: "未选择任何关联设备!",
					en: "No associated device selected!",
					vi: "Không có thiết bị liên quan nào được chọn!",
					ru: "Ни одно связанное устройство не выбрано!",
					tr: "İlgili cihaz seçilmedi!",
					ja: "関連デバイスが選択されていません！",
				},
				csca30: {
					zh: "未选择任何节目!",
					en: "No show selected!",
					vi: "Không có chương trình nào được chọn!",
					ru: "Программа не выбрана!",
					tr: "Gösteri seçilmedi!",
					ja: "番組は選択されていません！",
				},
				csca31: {
					zh: "未添加任何排程!",
					en: "No schedule added!",
					vi: "Không có lịch trình được thêm vào!",
					ru: "Расписание не было добавлено!",
					tr: "Program eklenmedi!",
					ja: "スケジュールが追加されていません！",
				},
				csca32: {
					zh: "第条排程设置结束时间为历史时间,不可播放!",
					en: "The end time of the schedule is set to historical time and cannot be played!",
					vi: "Thời gian kết thúc lịch thi đấu được thiết lập theo thời gian lịch sử và không thể chơi được!",
					ru: "Статья 1 Время окончания настройки расписания является историческим и не может быть воспроизведено!",
					tr: "Programın bitiş zamanı geçmiş zamana ayarlanmıştır ve oynatılamaz!",
					ja: "第条スケジュール設定終了時間は履歴時間で、再生不可！",
				},
				csca33: {
					zh: "第条排程设置开始时间大于结束时间!",
					en: "The start time of scheduling is greater than the end time!",
					vi: "Lịch trình đầu tiên đặt thời gian bắt đầu lớn hơn thời gian kết thúc!",
					ru: "Статья 1 Время начала настройки расписания больше, чем время окончания!",
					tr: "Program ayarının başlangıç saati bitiş saatinden daha büyüktür!",
					ja: "第条スケジュール設定開始時間は終了時間より大きい！",
				},
				csca34: {
					zh: "排程添加成功后自动跳转到播放日程列表",
					en: "After the schedule is added successfully, it will automatically jump to the play schedule list",
					vi: "Sau khi lịch trình được thêm thành công, nó sẽ tự động chuyển sang danh sách lịch phát",
					ru: "Автоматический переход к списку расписаний воспроизведения после успешного добавления расписания",
					tr: "Program başarıyla eklendikten sonra otomatik olarak oynatma programı listesine atlayacaktır.",
					ja: "スケジュール追加に成功すると自動的にプレイスケジュールリストにジャンプ",
				}
			},
			DelDialog: {
				cscd1: {
					zh: "标 题",
					en: "Title",
					vi: "Tiêu đề",
					ru: "Заглавие",
					tr: "Başlık",
					ja: "タイトル",
				}
			},
			EditPlan: {
				csce1: {
					zh: "选择模板",
					en: "Select a template",
					vi: "Chọn một mẫu",
					ru: "Выберите шаблон",
					tr: "Bir şablon seçin",
					ja: "テンプレートの選択",
				},
				csce2: {
					zh: "存为模板",
					en: "Save as Template",
					vi: "Lưu dưới dạng mẫu",
					ru: "Сохранить как шаблон",
					tr: "Şablon olarak kaydet",
					ja: "テンプレートとして保存",
				},
				csce3: {
					zh: "导入模板",
					en: "Importing a template",
					vi: "Nhập mẫu",
					ru: "Импорт шаблона",
					tr: "Bir şablonu içe aktarma",
					ja: "テンプレートのインポート",
				},
				csce4: {
					zh: "导出模板",
					en: "Export Template",
					vi: "Xuất mẫu",
					ru: "Шаблон для экспорта",
					tr: "Şablonu Dışa Aktar",
					ja: "テンプレートのエクスポート",
				},
				csce5: {
					zh: "请输入模板名称",
					en: "Please enter a template name",
					vi: "Vui lòng nhập tên mẫu",
					ru: "Пожалуйста, введите название шаблона",
					tr: "Lütfen bir şablon adı girin",
					ja: "テンプレート名を入力してください",
				},
				csce6: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "отменять",
					tr: "İptal etmek",
					ja: "キャンセル",
				},
				csce7: {
					zh: "确定",
					en: "Sure",
					vi: "Chắc chắn",
					ru: "уверенный",
					tr: "Elbette",
					ja: "を選択して、",
				},
				csce8: {
					zh: "节目id",
					en: "Program ID",
					vi: "Mã chương trình",
					ru: "Идентификатор программы",
					tr: "Program Kimliği",
					ja: "番組id",
				},
				csce9: {
					zh: "节目名称",
					en: "Name of programme",
					vi: "Tên chương trình",
					ru: "Название программы",
					tr: "Programın adı",
					ja: "番組名",
				},
				csce10: {
					zh: "开始时间",
					en: "Starting time",
					vi: "Thời gian bắt đầu",
					ru: "Время начала",
					tr: "Başlangıç ​​zamanı",
					ja: "開始時間",
				},
				csce11: {
					zh: "结束时间",
					en: "End Time",
					vi: "Thời gian kết thúc",
					ru: "Время окончания",
					tr: "Bitiş Zamanı",
					ja: "終了時間",
				},
				csce12: {
					zh: "有效日期",
					en: "Effective Date",
					vi: "Ngày có hiệu lực",
					ru: "Дата вступления в силу",
					tr: "Yürürlük Tarihi",
					ja: "有効日",
				},
				csce13: {
					zh: "开始日期",
					en: "start date",
					vi: "ngày bắt đầu",
					ru: "Дата начала",
					tr: "başlangıç ​​tarihi",
					ja: "開始日",
				},
				csce14: {
					zh: "结束日期",
					en: "End Date",
					vi: "Ngày cuối",
					ru: "Дата окончания",
					tr: "Bitiş Tarihi",
					ja: "終了日",
				},
				csce15: {
					zh: "有效星期",
					en: "Valid week",
					vi: "Tuần hợp lệ",
					ru: "Эффективная неделя",
					tr: "Geçerli hafta",
					ja: "有効週",
				},
				csce16: {
					zh: "星期",
					en: "Week",
					vi: "Tuần",
					ru: "неделя",
					tr: "Hafta",
					ja: "曜日",
				},
				csce17: {
					zh: "连续循环次数",
					en: "Continuous cycles",
					vi: "Chu kỳ liên tục",
					ru: "Количество последовательных циклов",
					tr: "Sürekli döngüler",
					ja: "連続サイクル数",
				},
				csce18: {
					zh: "总播放次数",
					en: "Total plays",
					vi: "Tổng số lần phát lại",
					ru: "Общее количество воспроизведений",
					tr: "Toplam oynatma süreleri",
					ja: "総再生回数",
				},
				csce19: {
					zh: "删除成功",
					en: "successfully deleted",
					vi: "đã xóa thành công",
					ru: "Успешно удален",
					tr: "başarıyla silindi",
					ja: "削除に成功しました",
				},
				csce20: {
					zh: "删除失败",
					en: "failed to delete",
					vi: "không thể xóa",
					ru: "Не удалось удалить файл",
					tr: "silinemedi",
					ja: "削除に失敗しました",
				},
				csce21: {
					zh: "有效",
					en: "efficient",
					vi: "có hiệu quả",
					ru: "эффективный",
					tr: "verimli",
					ja: "有効",
				},
				csce22: {
					zh: "排程不能为空！",
					en: "Schedule cannot be empty!",
					vi: "Lịch trình không thể trống!",
					ru: "Расписание не может быть пустым!",
					tr: "Program boş olamaz!",
					ja: "スケジュールを空にすることはできません！",
				},
				csce23: {
					zh: "无效",
					en: "invalid",
					vi: "không hợp lệ",
					ru: "недействительный",
					tr: "geçersiz",
					ja: "無効です",
				},
				csce24: {
					zh: "定时播放_",
					en: "Timed playback_",
					vi: "Hẹn giờ phát lại",
					ru: "Синхронизированное воспроизведение_",
					tr: "Zamanlanmış oynatma_",
					ja: "タイミング再生_",
				},
				csce25: {
					zh: "定时播放模板导出成功！",
					en: "The timed playback template was exported successfully!",
					vi: "Mẫu phát lại hẹn giờ đã được xuất thành công!",
					ru: "Шаблон синхронизированного воспроизведения был успешно экспортирован!",
					tr: "Zamanlanmış oynatma şablonu başarıyla dışa aktarıldı!",
					ja: "タイミング再生テンプレートのエクスポートに成功しました！",
				},
				csce26: {
					zh: "保存成功",
					en: "Saved successfully",
					vi: "đã lưu thành công",
					ru: "Успешно сохранен",
					tr: "Başarıyla kaydedildi",
					ja: "保存に成功しました",
				}
			},
			GetDeviceDialog: {
				cscg1: {
					zh: "发布—选择终端",
					en: "Publish—Select Target",
					vi: "Xuất bản—Chọn mục tiêu",
					ru: "Терминал для выбора публикации",
					tr: "Yayınla Hedef Seç",
					ja: "パブリッシュ-ターミナルの選択",
				},
				cscg2: {
					zh: "组织结构分组",
					en: "Organizational Structure Grouping",
					vi: "Nhóm cơ cấu tổ chức",
					ru: "Группировка организационной структуры",
					tr: "Organizasyon Yapısı Gruplaması",
					ja: "組織構造のグループ化",
				},
				cscg3: {
					zh: "请输入设备名",
					en: "Please enter the device name",
					vi: "Vui lòng nhập tên thiết bị",
					ru: "Пожалуйста, введите название устройства",
					tr: "Lütfen cihaz adını girin",
					ja: "デバイス名を入力してください",
				},
				cscg4: {
					zh: "确定",
					en: "Sure",
					vi: "Chắc chắn",
					ru: "уверенный",
					tr: "Elbette",
					ja: "を選択して、",
				},
				cscg5: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "отменять",
					tr: "İptal etmek",
					ja: "キャンセル",
				},
				cscg6: {
					zh: "自动适配屏幕大小播放",
					en: "Automatically adapt to screen size for playback",
					vi: "Tự động thích ứng với kích thước màn hình để phát lại",
					ru: "Автоматическая адаптация к размеру экрана для воспроизведения",
					tr: "Oynatma için ekran boyutuna otomatik olarak uyum sağlayın",
					ja: "画面サイズの自動再生",
				},
				cscg7: {
					zh: "发布类型",
					en: "Release Type",
					vi: "Loại phát hành",
					ru: "Тип выпуска",
					tr: "Sürüm Türü",
					ja: "パブリッシュタイプ",
				},
				cscg8: {
					zh: "终端名称",
					en: "Terminal Name",
					vi: "Tên thiết bị đầu cuối",
					ru: "Название терминала",
					tr: "Terminal Adı",
					ja: "ターミナル名",
				},
				cscg9: {
					zh: "组织结构",
					en: "Groups",
					vi: "Cơ cấu tổ chức",
					ru: "структура",
					tr: "Organizasyon Yapısı",
					ja: "組織構造",
				},
				cscg10: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "разрешение",
					tr: "Çözünürlük",
					ja: "解像度",
				},
				cscg11: {
					zh: "设备类型",
					en: "Equipment type",
					vi: "Loại thiết bị",
					ru: "Тип устройства",
					tr: "Ekipman türü",
					ja: "デバイスタイプ",
				},
				cscg12: {
					zh: "设备状态",
					en: "device status",
					vi: "trạng thái thiết bị",
					ru: "Состояние устройства",
					tr: "cihaz durumu",
					ja: "デバイスの状態",
				},
				cscg13: {
					zh: "业务属性",
					en: "Business attributes",
					vi: "Thuộc tính nghiệp vụ",
					ru: "Бизнес-атрибуты",
					tr: "İşletme özellikleri",
					ja: "ビジネス・プロパティ",
				},
				cscg14: {
					zh: "覆盖发布",
					en: "Coverage Release",
					vi: "Ghi đè lên bản phát hành",
					ru: "Выпуск страхового покрытия",
					tr: "Kapsam Yayını",
					ja: "パブリケーションの上書き",
				},
				cscg15: {
					zh: "追加发布",
					en: "Additional Release",
					vi: "Bản phát hành bổ sung",
					ru: "Дополнительный выпуск",
					tr: "Ek Sürüm",
					ja: "追加リリース",
				},
				cscg16: {
					zh: "ids格式是....",
					en: "The format of ids is...",
					vi: "Định dạng của id là...",
					ru: "Формат идентификаторов таков....",
					tr: "Kimliklerin formatı...",
					ja: "idsフォーマットは...",
				},
				cscg17: {
					zh: "选择的设备是...",
					en: "The device selected is...",
					vi: "Thiết bị được chọn là...",
					ru: "Выбранное устройство является...",
					tr: "Seçilen cihaz...",
					ja: "選択したデバイスは…",
				},
				cscg18: {
					zh: "发布成功",
					en: "Published successfully",
					vi: "Xuất bản thành công",
					ru: "Успешно выпущенный",
					tr: "Başarıyla yayınlandı",
					ja: "公開に成功しました",
				},
				cscg19: {
					zh: "请输入关键词",
					en: "Please enter a keyword",
					vi: "Vui lòng nhập từ khóa",
					ru: "Пожалуйста, введите ключевые слова",
					tr: "Lütfen bir anahtar kelime girin",
					ja: "キーワードを入力してください",
				}
			},
			NewInterCut: {
				cscn1: {
					zh: "保存",
					en: "save",
					vi: "Lưu",
					ru: "сохранить",
					tr: "kaydetmek",
					ja: "保存＃ホゾン＃",
				},
				cscn2: {
					zh: "事件",
					en: "event",
					vi: "sự kiện",
					ru: "событие",
					tr: "etkinlik",
					ja: "イベント＃イベント＃",
				},
				cscn3: {
					zh: "请输入插播事件名称",
					en: "Please enter the name of the interstitial event",
					vi: "Vui lòng nhập tên của sự kiện xen kẽ",
					ru: "Пожалуйста, введите название промежуточного события",
					tr: "Lütfen geçiş etkinliğinin adını girin",
					ja: "補間イベント名を入力してください",
				},
				cscn4: {
					zh: "事件名称不能为空！",
					en: "Event name cannot be empty!",
					vi: "Tên sự kiện không được để trống!",
					ru: "Название события не может быть пустым!",
					tr: "Etkinlik adı boş olamaz!",
					ja: "イベント名を空白にすることはできません！",
				},
				cscn5: {
					zh: "类型",
					en: "type",
					vi: "Loại",
					ru: "тип",
					tr: "tip",
					ja: "を選択してオプションを設定します。",
				},
				cscn6: {
					zh: "请选择插播类型",
					en: "Please select the type of insert",
					vi: "Vui lòng chọn loại chèn",
					ru: "Пожалуйста, выберите тип вставки",
					tr: "Lütfen ekleme türünü seçin",
					ja: "補間タイプを選択してください",
				},
				cscn7: {
					zh: "请选择插播事件类型！",
					en: "Please select the type of interstitial event!",
					vi: "Vui lòng chọn loại sự kiện xen kẽ!",
					ru: "Пожалуйста, выберите тип промежуточного события!",
					tr: "Lütfen geçiş etkinliğinin türünü seçin!",
					ja: "補間イベントタイプを選択してください！",
				},
				cscn8: {
					zh: "播放列表",
					en: "playlist",
					vi: "danh sách phát",
					ru: "список воспроизведения",
					tr: "çalma listesi",
					ja: "プレイリスト",
				},
				cscn9: {
					zh: "片源",
					en: "Source",
					vi: "Nguồn",
					ru: "Источник пленки",
					tr: "Kaynak",
					ja: "チップソース",
				},
				cscn10: {
					zh: "片源时长",
					en: "Source duration",
					vi: "Thời lượng nguồn",
					ru: "Исходное время",
					tr: "Kaynak süresi",
					ja: "チップソース時間",
				},
				cscn11: {
					zh: "播放次数",
					en: "Views",
					vi: "Lượt xem",
					ru: "Количество воспроизведений",
					tr: "Görünümler",
					ja: "再生回数",
				},
				cscn12: {
					zh: "修改片源",
					en: "Modify the source",
					vi: "Sửa đổi nguồn",
					ru: "Измените источник пленки",
					tr: "Kaynağı değiştirin",
					ja: "パッチソースの変更",
				},
				cscn13: {
					zh: "选择片源",
					en: "Select source",
					vi: "Chọn nguồn",
					ru: "Выберите источник пленки",
					tr: "Kaynak seçin",
					ja: "チップソースの選択",
				},
				cscn14: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "разрешение",
					tr: "Çözünürlük",
					ja: "解像度",
				},
				cscn15: {
					zh: "请选择分辨率",
					en: "Please select resolution",
					vi: "Vui lòng chọn độ phân giải",
					ru: "Пожалуйста, выберите разрешение",
					tr: "Lütfen çözünürlüğü seçin",
					ja: "解像度を選択してください",
				},
				cscn16: {
					zh: "请问是否要永久删除当前片源？",
					en: "Do you want to permanently delete the current source?",
					vi: "Bạn có muốn xóa vĩnh viễn nguồn hiện tại không?",
					ru: "Вы хотите навсегда удалить текущий источник видеозаписи?",
					tr: "Geçerli kaynağı kalıcı olarak silmek istiyor musunuz?",
					ja: "すみません、現在のソースを永久に削除しますか？",
				},
				cscn17: {
					zh: "新建插播",
					en: "Create a new insert",
					vi: "Tạo một phần chèn mới",
					ru: "Новый интерстициальный",
					tr: "Yeni bir ek oluştur",
					ja: "新規補間",
				},
				cscn18: {
					zh: "新建插播事件成功!",
					en: "Created a new insert event successfully!",
					vi: "Đã tạo thành công một sự kiện chèn mới!",
					ru: "Новое промежуточное мероприятие прошло успешно!",
					tr: "Yeni bir ekleme etkinliği başarıyla oluşturuldu!",
					ja: "新規補間イベント成功！",
				},
				cscn19: {
					zh: "编辑插播",
					en: "Edit Insert",
					vi: "Chỉnh sửa chèn",
					ru: "Редактировать междурядья",
					tr: "Eklemeyi Düzenle",
					ja: "補間の編集",
				},
				cscn20: {
					zh: "编辑插播事件成功",
					en: "Edited the interstitial event successfully",
					vi: "Đã chỉnh sửa thành công sự kiện xen kẽ",
					ru: "Успешно отредактируйте промежуточное событие",
					tr: "Geçiş reklamı etkinliği başarıyla düzenlendi",
					ja: "補間イベントの編集に成功しました",
				}
			},
			PlanDetailDialog: {
				cscp1: {
					zh: "失效日期",
					en: "Expiration Date",
					vi: "Ngày hết hạn",
					ru: "Срок годности",
					tr: "Son kullanma tarihi",
					ja: "有効期限",
				}
			},
			PlayPlan: {
				cscpp1: {
					zh: "发布成功",
					en: "Published successfully",
					vi: "Xuất bản thành công",
					ru: "Успешно выпущенный",
					tr: "Başarıyla yayınlandı",
					ja: "公開に成功しました",
				}
			},
			ProgramSetting: {
				cscps1: {
					zh: "请选择组织结构",
					en: "Please select your organizational structure",
					vi: "Vui lòng chọn cơ cấu tổ chức của bạn",
					ru: "Пожалуйста, выберите организационную структуру",
					tr: "Lütfen organizasyon yapınızı seçin",
					ja: "組織構造を選択してください",
				},
				cscps2: {
					zh: "请选择设备类型",
					en: "Please select device type",
					vi: "Vui lòng chọn loại thiết bị",
					ru: "Пожалуйста, выберите тип устройства",
					tr: "Lütfen cihaz tipini seçin",
					ja: "デバイスタイプを選択してください",
				},
				cscps3: {
					zh: "请选择分辨率",
					en: "Please select resolution",
					vi: "Vui lòng chọn độ phân giải",
					ru: "Пожалуйста, выберите разрешение",
					tr: "Lütfen çözünürlüğü seçin",
					ja: "解像度を選択してください",
				},
				cscps4: {
					zh: "请选择设备",
					en: "Please select your device",
					vi: "Vui lòng chọn thiết bị của bạn",
					ru: "Пожалуйста, выберите устройство",
					tr: "Lütfen cihazınızı seçin",
					ja: "デバイスを選択してください",
				},
				cscps5: {
					zh: "请填写节目名称!",
					en: "Please fill in the program name!",
					vi: "Vui lòng điền tên chương trình!",
					ru: "Пожалуйста, введите название программы!",
					tr: "Lütfen program adını giriniz!",
					ja: "番組名を記入してください！",
				},
				cscps6: {
					zh: "请选择组织结构!",
					en: "Please select your organizational structure!",
					vi: "Vui lòng chọn cơ cấu tổ chức của bạn!",
					ru: "Пожалуйста, выберите организационную структуру!",
					tr: "Lütfen organizasyon yapınızı seçin!",
					ja: "組織構造を選択してください！",
				},
				cscps7: {
					zh: "请选择设备类型!",
					en: "Please select the device type!",
					vi: "Vui lòng chọn loại thiết bị!",
					ru: "Пожалуйста, выберите тип устройства!",
					tr: "Lütfen cihaz tipini seçin!",
					ja: "デバイスタイプを選択してください！",
				},
				cscps8: {
					zh: "请选择设备!",
					en: "Please select your device!",
					vi: "Vui lòng chọn thiết bị của bạn!",
					ru: "Пожалуйста, выберите устройство!",
					tr: "Lütfen cihazınızı seçin!",
					ja: "デバイスを選択してください！",
				},
				cscps9: {
					zh: "请选择屏幕分辨率!",
					en: "Please select your screen resolution!",
					vi: "Vui lòng chọn độ phân giải màn hình của bạn!",
					ru: "Пожалуйста, выберите разрешение экрана!",
					tr: "Lütfen ekran çözünürlüğünüzü seçin!",
					ja: "画面解像度を選択してください！",
				},
				cscps10: {
					zh: "已加载全部设备！",
					en: "All devices loaded!",
					vi: "Tất cả các thiết bị đã được tải!",
					ru: "Все устройства были загружены!",
					tr: "Tüm cihazlar yüklendi!",
					ja: "すべてのデバイスがロードされました！",
				},
				cscps11: {
					zh: "设备不在线!",
					en: "The device is offline!",
					vi: "Thiết bị đang ngoại tuyến!",
					ru: "Устройство не подключено к сети!",
					tr: "Cihaz çevrimdışı!",
					ja: "デバイスがオンラインではありません！",
				}
			},
			ScheduleItem: {
				cscs1: {
					zh: "至",
					en: "to",
					vi: "ĐẾN",
					ru: "до",
					tr: "ile",
					ja: "終了",
				},
				cscs2: {
					zh: "日期",
					en: "date",
					vi: "ngày",
					ru: "дата",
					tr: "tarih",
					ja: "日付",
				},
				cscs3: {
					zh: "选择日期",
					en: "Select Date",
					vi: "Chọn ngày",
					ru: "Выберите дату",
					tr: "Tarih Seçin",
					ja: "日付の選択",
				},
				cscs4: {
					zh: "每周",
					en: "weekly",
					vi: "hàng tuần",
					ru: "каждая неделя",
					tr: "haftalık",
					ja: "毎週",
				}
			},
			ShowPreview: {
				cscsp1: {
					zh: "节目时长",
					en: "Duration",
					vi: "Thời lượng chương trình",
					ru: "Длительность",
					tr: "Program süresi",
					ja: "番組時間",
				}
			},
			UrgencyPlan: {
				cscu1: {
					zh: "发布成功",
					en: "Published successfully",
					vi: "Xuất bản thành công",
					ru: "Успешно выпущенный",
					tr: "Başarıyla yayınlandı",
					ja: "公開に成功しました",
				}
			}
		},
		windows: {
			children: {
				AttrList: {
					AttrRss: {
						cswcaa1: {
							zh: "特效1",
							en: "Effect 1",
							vi: "Hiệu ứng 1",
							ru: "Специальный эффект 1",
							tr: "Etki 1",
							ja: "効果1",
						}
					},
					AttrTimewait: {
						cswcaat1: {
							zh: "选择日期时间",
							en: "Select date and time",
							vi: "Chọn ngày và giờ",
							ru: "Выберите дату и время",
							tr: "Tarih ve saati seçin",
							ja: "日付時刻の選択",
						}
					}
				},
				ToolsList: {
					ToolIClock: {
						cswctt1: {
							zh: "年月日",
							en: "year month day",
							vi: "năm tháng ngày",
							ru: "Год, месяц, день",
							tr: "yıl ay gün",
							ja: "年月日",
						},
						cswctt2: {
							zh: "星期",
							en: "Week",
							vi: "Tuần",
							ru: "неделя",
							tr: "Hafta",
							ja: "曜日",
						}
					},
					ToolNClock: {
						cswcttn1: {
							zh: "农历",
							en: "lunar calendar",
							vi: "âm lịch",
							ru: "Лунный календарь",
							tr: "ay takvimi",
							ja: "旧暦",
						},
						cswcttn2: {
							zh: "年月日",
							en: "year month day",
							vi: "năm tháng ngày",
							ru: "Год, месяц, день",
							tr: "yıl ay gün",
							ja: "年月日",
						}
					}
				},
				TerminalList: {
					cswctl1: {
						zh: "拼命发布中，请稍后...",
						en: "Posting urgently, please wait...",
						vi: "Đang đăng gấp, vui lòng đợi...",
						ru: "Пожалуйста, подождите с выпуском...",
						tr: "Acil olarak yayınlanıyor, lütfen bekleyin...",
						ja: "必死にリリース中ですが、しばらくお待ちください…",
					},
					cswctl2: {
						zh: "覆盖发布",
						en: "Coverage Release",
						vi: "Ghi đè lên bản phát hành",
						ru: "Выпуск страхового покрытия",
						tr: "Kapsam Yayını",
						ja: "パブリケーションの上書き",
					},
					cswctl3: {
						zh: "追加发布",
						en: "Additional Release",
						vi: "Bản phát hành bổ sung",
						ru: "Дополнительный выпуск",
						tr: "Ek Sürüm",
						ja: "追加リリース",
					},
					cswctl4: {
						zh: "请输入终端名称",
						en: "Please enter the terminal name",
						vi: "Vui lòng nhập tên thiết bị đầu cuối",
						ru: "Пожалуйста, введите название терминала",
						tr: "Lütfen terminal adını girin",
						ja: "端末名を入力してください",
					}
				},
				Vdr: {
					cswcv1: {
						zh: "铺满整个屏幕",
						en: "Spread all over the screen",
						vi: "Trải khắp màn hình",
						ru: "Растянуть на весь экран",
						tr: "Tüm ekranı yayın.",
						ja: "画面全体に敷き詰める",
					},
					cswcv2: {
						zh: "还原",
						en: "reduction",
						vi: "Khôi phục",
						ru: "восстановить",
						tr: "kesinti",
						ja: "リストア",
					},
					cswcv3: {
						zh: "关闭窗口",
						en: "close the window",
						vi: "đóng cửa sổ",
						ru: "Закройте окно",
						tr: "pencereyi kapat",
						ja: "ウィンドウを閉じる",
					}
				},
				VdrSplit: {
					cswcvs1: {
						zh: "网格布局：单屏",
						en: "Grid Layout: Single Screen",
						vi: "Bố cục lưới Màn hình đơn",
						ru: "Расположение сетки: на одном экране",
						tr: "Izgara Düzeni: Tek Ekran",
						ja: "メッシュレイアウトめっしゅれいあうと:シングルスクリーンシングルすくりーん",
					},
					cswcvs2: {
						zh: "网格布局：二等分",
						en: "Grid layout: Bisection",
						vi: "Bố cục lưới: chia đôi",
						ru: "Расположение сетки: две точки",
						tr: "Izgara düzeni: İkiye bölme",
						ja: "メッシュレイアウトめっしゅれいあうと:二等分にぶんかつ",
					},
					cswcvs3: {
						zh: "网格布局：三等分",
						en: "Grid layout: thirds",
						vi: "Bố cục lưới: chia ba",
						ru: "Расположение сетки: три равные части",
						tr: "Izgara düzeni: üçte",
						ja: "メッシュレイアウトめっしゅれいあうと:3等分3等分",
					},
					cswcvs4: {
						zh: "网格布局：四等分",
						en: "Grid layout: quarters",
						vi: "Bố cục lưới: chia bốn",
						ru: "Расположение сетки: четыре равные части",
						tr: "Izgara düzeni: çeyrekler",
						ja: "メッシュレイアウトめっしゅれいあうと:4等分4等分",
					},
					cswcvs5: {
						zh: "网格布局：自定义",
						en: "Grid Layout: Custom",
						vi: "Bố cục lưới tùy chỉnh",
						ru: "Расположение сетки: пользовательское",
						tr: "Izgara Düzeni: Özel",
						ja: "メッシュレイアウトめっしゅれいあうと:カスタマイズかすたまいず",
					},
					cswcvs6: {
						zh: "取消",
						en: "Cancel",
						vi: "Hủy bỏ",
						ru: "отменять",
						tr: "İptal etmek",
						ja: "キャンセル",
					},
					cswcvs7: {
						zh: "确定",
						en: "Sure",
						vi: "Chắc chắn",
						ru: "уверенный",
						tr: "Elbette",
						ja: "を選択して、",
					}
				},
				WindowList: {
					cswcw1: {
						zh: "图片",
						en: "picture",
						vi: "hình ảnh",
						ru: "картинка",
						tr: "resim",
						ja: "画像",
					},
					cswcw2: {
						zh: "视频",
						en: "video",
						vi: "băng hình",
						ru: "видео",
						tr: "video",
						ja: "ビデオ",
					}
				}
			},
			scripts: {
				animations: {
					cswsa1: {
						zh: "无",
						en: "none",
						vi: "không có",
						ru: "не быть",
						tr: "hiçbiri",
						ja: "なし",
					},
					cswsa2: {
						zh: "随机",
						en: "random",
						vi: "ngẫu nhiên",
						ru: "случайный",
						tr: "rastgele",
						ja: "ランダム",
					},
					cswsa3: {
						zh: "百叶窗",
						en: "Shutters",
						vi: "Cửa chớp",
						ru: "жалюзи",
						tr: "Panjurlar",
						ja: "ブラインド",
					},
					cswsa4: {
						zh: "擦除",
						en: "Erase",
						vi: "Xoá",
						ru: "стирать",
						tr: "Sil",
						ja: "消去",
					},
					cswsa5: {
						zh: "盒状",
						en: "Box",
						vi: "Hộp",
						ru: "Форма коробки",
						tr: "Kutu",
						ja: "ボックス",
					},
					cswsa6: {
						zh: "阶梯",
						en: "ladder",
						vi: "thang",
						ru: "лестница",
						tr: "merdiven",
						ja: "かいだん",
					},
					cswsa7: {
						zh: "菱形",
						en: "diamond",
						vi: "kim cương",
						ru: "Ромб",
						tr: "elmas",
						ja: "ひし形",
					},
					cswsa8: {
						zh: "轮子",
						en: "wheel",
						vi: "bánh xe",
						ru: "колесо",
						tr: "teker",
						ja: "車輪",
					},
					cswsa9: {
						zh: "劈裂",
						en: "Cleavage",
						vi: "sự phân chia",
						ru: "Расщеплять",
						tr: "göğüs dekoltesi",
						ja: "スプリット",
					},
					cswsa10: {
						zh: "切入",
						en: "Cut in",
						vi: "Cắt",
						ru: "Разрезать",
						tr: "Kes",
						ja: "リードイン",
					},
					cswsa11: {
						zh: "棋盘",
						en: "checkerboard",
						vi: "bàn cờ",
						ru: "шахматная доска",
						tr: "dama tahtası",
						ja: "碁盤",
					},
					cswsa12: {
						zh: "扇形展开",
						en: "Fanning",
						vi: "quạt",
						ru: "Веерообразное расширение",
						tr: "Fanlama",
						ja: "扇形展開",
					},
					cswsa13: {
						zh: "十字线条",
						en: "Crosshairs",
						vi: "Chữ thập",
						ru: "Поперечная линия",
						tr: "Artı işaretleri",
						ja: "十字線",
					},
					cswsa14: {
						zh: "向内溶解",
						en: "Dissolve inwards",
						vi: "Hòa tan vào trong",
						ru: "Раствориться вовнутрь",
						tr: "İçeri doğru çözün",
						ja: "ないぶようかい",
					},
					cswsa15: {
						zh: "圆形扩展",
						en: "Circular expansion",
						vi: "Mở rộng vòng tròn",
						ru: "Круговое расширение",
						tr: "Dairesel genişleme",
						ja: "円形拡張",
					}
				},
				toolsList: {
					cswst1: {
						zh: "文本",
						en: "text",
						vi: "chữ",
						ru: "текст",
						tr: "metin",
						ja: "テキスト",
					},
					cswst2: {
						zh: "数字时钟",
						en: "Digital clock",
						vi: "Đồng hồ kỹ thuật số",
						ru: "Цифровые часы",
						tr: "Dijital saat",
						ja: "ディジタルクロック",
					},
					cswst3: {
						zh: "模拟时钟",
						en: "Analog clock",
						vi: "Đồng hồ analog",
						ru: "Аналоговые часы",
						tr: "Analog saat",
						ja: "アナログクロック",
					},
					cswst4: {
						zh: "天气",
						en: "weather",
						vi: "thời tiết",
						ru: "погода",
						tr: "hava durumu",
						ja: "天気",
					},
					cswst5: {
						zh: "正计时",
						en: "Counting",
						vi: "Đếm",
						ru: "Синхронизация",
						tr: "Sayma",
						ja: "正のタイミング",
					},
					cswst6: {
						zh: "倒计时",
						en: "Countdown",
						vi: "Đếm ngược",
						ru: "обратный отсчет",
						tr: "Geri sayım",
						ja: "カウントダウン",
					},
					cswst7: {
						zh: "流媒体",
						en: "stream media",
						vi: "truyền phát phương tiện truyền thông",
						ru: "Потоковое мультимедиа",
						tr: "medya akışı",
						ja: "ストリーミング",
					},
					cswst8: {
						zh: "图片",
						en: "picture",
						vi: "hình ảnh",
						ru: "картинка",
						tr: "resim",
						ja: "画像",
					},
					cswst9: {
						zh: "视频",
						en: "video",
						vi: "băng hình",
						ru: "видео",
						tr: "video",
						ja: "ビデオ",
					},
					cswst10: {
						zh: "网页",
						en: "Web page",
						vi: "trang web",
						ru: "страница",
						tr: "web sayfası",
						ja: "Webページ",
					}
				}
			},
			index: {
				cswi1: {
					zh: "节目模板",
					en: "Program Template",
					vi: "Mẫu chương trình",
					ru: "Шаблон программы",
					tr: "Program Şablonu",
					ja: "プログラムテンプレート",
				}
			}
		},
		InterCutManage: {
			csl1: {
				zh: "事件",
				en: "event",
				vi: "sự kiện",
				ru: "событие",
				tr: "etkinlik",
				ja: "イベント＃イベント＃",
			},
			csl2: {
				zh: "片源名称",
				en: "Source Name",
				vi: "Tên nguồn",
				ru: "Имя источника",
				tr: "Kaynak Adı",
				ja: "ソース名",
			},
			csl3: {
				zh: "播放次数",
				en: "Views",
				vi: "Lượt xem",
				ru: "Количество воспроизведений",
				tr: "Görünümler",
				ja: "再生回数",
			},
			csl4: {
				zh: "播放",
				en: "Play",
				vi: "phát",
				ru: "проиграть",
				tr: "Oynamak",
				ja: "再生",
			},
			csl5: {
				zh: "创建时间",
				en: "Creation time",
				vi: "Thời gian sáng tạo",
				ru: "Время создания",
				tr: "Yaratılış zamanı",
				ja: "作成時間",
			},
			csl6: {
				zh: "创建者",
				en: "creator",
				vi: "người sáng tạo",
				ru: "основатель",
				tr: "yaratıcı",
				ja: "作成者",
			},
			csl7: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать",
				tr: "işletmek",
				ja: "操作",
			},
			csl8: {
				zh: "类型名称",
				en: "type name",
				vi: "tên loại",
				ru: "Имя типа",
				tr: "adı yazın",
				ja: "タイプ名",
			},
			csl9: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять",
				tr: "İptal etmek",
				ja: "キャンセル",
			},
			csl10: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять",
				tr: "Elbette",
				ja: "を選択して、",
			},
			csl11: {
				zh: "删除类型",
				en: "Deletion Type",
				vi: "Loại xóa",
				ru: "Тип удаления",
				tr: "Silme Türü",
				ja: "タイプの削除",
			},
			csl12: {
				zh: "请问是否要永久删除当前类型？",
				en: "Do you want to permanently delete the current type?",
				vi: "Bạn có muốn xóa vĩnh viễn loại hiện tại không?",
				ru: "Вы хотите удалить текущий тип навсегда?",
				tr: "Geçerli türü kalıcı olarak silmek istiyor musunuz?",
				ja: "現在のタイプを永久に削除しますか？",
			},
			csl13: {
				zh: "删除事件",
				en: "Deleting an event",
				vi: "Xóa một sự kiện",
				ru: "Удалить событие",
				tr: "Bir etkinliği silme",
				ja: "イベントの削除",
			},
			csl14: {
				zh: "请问是否要永久删除当前选中事件？",
				en: "Do you want to permanently delete the currently selected event?",
				vi: "Bạn có muốn xóa vĩnh viễn sự kiện hiện được chọn không?",
				ru: "Вы хотите навсегда удалить текущее выбранное событие?",
				tr: "Şu anda seçili etkinliği kalıcı olarak silmek istiyor musunuz?",
				ja: "現在選択されているイベントを永久に削除しますか？",
			},
			csl15: {
				zh: "插播筛选",
				en: "Interlude Filter",
				vi: "Bộ lọc xen kẽ",
				ru: "Интерстициальный скрининг",
				tr: "Ara Filtre",
				ja: "補間フィルタリング",
			},
			csl16: {
				zh: "时间范围",
				en: "time limit",
				vi: "thời gian giới hạn",
				ru: "временные рамки",
				tr: "zaman sınırı",
				ja: "時間範囲",
			},
			csl17: {
				zh: "至",
				en: "to",
				vi: "ĐẾN",
				ru: "до",
				tr: "ile",
				ja: "終了",
			},
			csl18: {
				zh: "开始日期",
				en: "start date",
				vi: "ngày bắt đầu",
				ru: "Дата начала",
				tr: "başlangıç ​​tarihi",
				ja: "開始日",
			},
			csl19: {
				zh: "结束日期",
				en: "End Date",
				vi: "Ngày cuối",
				ru: "Дата окончания",
				tr: "Bitiş Tarihi",
				ja: "終了日",
			},
			csl20: {
				zh: "请输入类型名称",
				en: "Please enter a type name",
				vi: "Vui lòng nhập tên loại",
				ru: "Пожалуйста, введите название типа",
				tr: "Lütfen bir tür adı girin",
				ja: "タイプ名を入力してください",
			},
			csl21: {
				zh: "新建类型",
				en: "New Type",
				vi: "Kiểu mới",
				ru: "Новый тип",
				tr: "Yeni Tip",
				ja: "新規タイプ",
			},
			csl22: {
				zh: "类型重命名",
				en: "Type Renaming",
				vi: "Đổi tên loại",
				ru: "Введите переименование",
				tr: "Türü Yeniden Adlandırma",
				ja: "タイプ名の変更",
			},
			csl23: {
				zh: "未选择插播事件",
				en: "No interstitial event selected",
				vi: "Không có sự kiện xen kẽ nào được chọn",
				ru: "Промежуточное событие не выбрано",
				tr: "Hiçbir geçiş etkinliği seçilmedi",
				ja: "補間イベントが選択されていません",
			}
		},
		PlayListTable: {
			csp1: {
				zh: "发布详情",
				en: "Release details",
				vi: "Chi tiết phát hành",
				ru: "Подробности о выпуске",
				tr: "Sürüm ayrıntıları",
				ja: "リリースの詳細",
			},
			csp2: {
				zh: "确认删除？",
				en: "confirm deletion?",
				vi: "xác nhận xóa?",
				ru: "Подтвердить удаление?",
				tr: "silme işlemi onaylansın mı?",
				ja: "削除を確認しますか？",
			}
		},
		ProgramManage: {
			cspm1: {
				zh: "组织结构分组",
				en: "Organizational Structure Grouping",
				vi: "Nhóm cơ cấu tổ chức",
				ru: "Группировка организационной структуры",
				tr: "Organizasyon Yapısı Gruplaması",
				ja: "組織構造のグループ化",
			},
			cspm2: {
				zh: "节目时长",
				en: "Duration",
				vi: "Thời lượng chương trình",
				ru: "Длительность",
				tr: "Program süresi",
				ja: "番組時間",
			},
			cspm3: {
				zh: "发布",
				en: "release",
				vi: "giải phóng",
				ru: "сообщать",
				tr: "serbest bırakmak",
				ja: "リリース",
			},
			cspm4: {
				zh: "详情",
				en: "Details",
				vi: "Chi tiết",
				ru: "подробности",
				tr: "Detaylar",
				ja: "詳細",
			},
			cspm5: {
				zh: "编辑",
				en: "edit",
				vi: "biên tập",
				ru: "редактор",
				tr: "düzenlemek",
				ja: "編集",
			},
			cspm6: {
				zh: "复制",
				en: "copy",
				vi: "sao chép",
				ru: "копировать",
				tr: "kopyala",
				ja: "レプリケーション",
			},
			cspm7: {
				zh: "删除",
				en: "delete",
				vi: "xóa bỏ",
				ru: "стирать",
				tr: "silmek",
				ja: "削除＃サクジョ＃",
			},
			cspm8: {
				zh: "节目复制成功!",
				en: "Program copied successfully!",
				vi: "Chương trình được sao chép thành công!",
				ru: "Программа была успешно скопирована!",
				tr: "Program başarıyla kopyalandı!",
				ja: "番組コピー成功！",
			},
			cspm9: {
				zh: "请选中需要删除的节目!",
				en: "Please select the program you want to delete!",
				vi: "Vui lòng chọn chương trình bạn muốn xóa!",
				ru: "Пожалуйста, выберите программу, которую необходимо удалить!",
				tr: "Lütfen silmek istediğiniz programı seçin!",
				ja: "削除する番組を選択してください！",
			},
			cspm10: {
				zh: "发布已创建请在发布进度查看！",
				en: "The publication has been created. Please check the publication progress!",
				vi: "Bản phát hành đã được tạo. Vui lòng kiểm tra tiến độ phát hành!",
				ru: "Публикация была создана. Пожалуйста, проверьте ход публикации!",
				tr: "Yayın oluşturuldu. Lütfen yayın ilerlemesini kontrol edin!",
				ja: "公開が作成されました。公開進捗をご確認ください！"
			},
			cspm11: {
				zh: "发布已创建，请等待审核人员进行审核！",
				en: "The release has been created. Please wait for the reviewer to conduct the review!",
				vi: "Bản phát hành đã được tạo, vui lòng chờ nhân viên kiểm duyệt tiến hành kiểm duyệt!",
				ru: "Публикация создана, пожалуйста, дождитесь проверки рецензентом!",
				tr: "Yayın oluşturuldu, lütfen inceleme personelinin incelemesini bekleyin!",
				ja: "リリースが作成されました。審査員による審査をお待ちください！"
			},
			cspm12: {
				zh: "重命名",
				en: "rename",
				vi: "đổi tên",
				ru: "переименовать",
				tr: "yeniden adlandır",
				ja: "名前を変更",
			},
			cspm13: {
				zh: "复制节目并重新命名",
				en: "Copy the program and rename it",
				vi: "Sao chép chương trình và đổi tên",
				ru: "Скопировать программу и переименовать ее",
				tr: "Programı kopyala ve yeniden adlandır",
				ja: "プログラムをコピーして名前を変更"
			}
		}
	},
	system: {
		children: {
			AccessLayout: {
				cscha1: {
					zh: "测试",
					en: "test",
					vi: "Bài kiểm tra",
					ru: "проверка",
					tr: "test",
					ja: "テスト",
				}
			},
			SystemSet: {
				cscss1: {
					zh: "系统设置",
					en: "System Settings",
					vi: "Cài đặt hệ thống",
					ru: "Системные настройки",
					tr: "Sistem Ayarları",
					ja: "システム設定",
				},
				cscss2: {
					zh: "网页标题",
					en: "Page title",
					vi: "Tiêu đề trang",
					ru: "Заголовок страницы",
					tr: "Sayfa başlığı",
					ja: "Webページのタイトル",
				},
				cscss3: {
					zh: "关闭帮助",
					en: "Close Help",
					vi: "Đóng Trợ giúp",
					ru: "Близкая помощь",
					tr: "Yardımı Kapat",
					ja: "ヘルプを閉じる",
				},
				cscss4: {
					zh: "开启网页帮助",
					en: "Open web help",
					vi: "Mở trợ giúp web",
					ru: "Откройте веб-справку",
					tr: "Web yardımını aç",
					ja: "Webヘルプを開く",
				},
				cscss5: {
					zh: "关闭网页帮助",
					en: "Close web help",
					vi: "Đóng trợ giúp trên web",
					ru: "Закрыть веб-справку",
					tr: "Web yardımını kapat",
					ja: "Webヘルプを閉じる",
				},
				cscss6: {
					zh: "设置备案号",
					en: "Set the record number",
					vi: "Đặt số bản ghi",
					ru: "Установите рекордный номер",
					tr: "Kayıt numarasını ayarlayın",
					ja: "届出番号の設定",
				},
				cscss7: {
					zh: "备案号",
					en: "case number",
					vi: "số trường hợp",
					ru: "Номер записи",
					tr: "vaka numarası",
					ja: "届出番号",
				},
				cscss8: {
					zh: "应用",
					en: "application",
					vi: "ứng dụng",
					ru: "приложение",
					tr: "başvuru",
					ja: "適用＃テキヨウ＃",
				},
				cscss9: {
					zh: "日志保存时间",
					en: "Log retention period",
					vi: "Khoảng thời gian lưu giữ nhật ký",
					ru: "Время хранения журнала",
					tr: "Günlük saklama süresi",
					ja: "ログ保存時間",
				},
				cscss10: {
					zh: "描述文字",
					en: "Description text",
					vi: "văn bản mô tả",
					ru: "Текст описания",
					tr: "Açıklama metni",
					ja: "説明テキスト",
				},
				cscss11: {
					zh: "天",
					en: "sky",
					vi: "bầu trời",
					ru: "день",
					tr: "gökyüzü",
					ja: "日",
				},
				cscss12: {
					zh: "控制按钮配置(勾选折叠)",
					en: "Control button configuration (check fold)",
					vi: "Cấu hình nút điều khiển (kiểm tra Fold)",
					ru: "Настройка кнопки управления (проверьте складывание)",
					tr: "Kontrol düğmesi konfigürasyonu (katlamayı kontrol edin)",
					ja: "コントロールボタンの設定（折りたたみチェック）",
				}
			}
		},
		helpDocument: {
			csh1: {
				zh: "帮助文档",
				en: "Help Documentation",
				vi: "Tài liệu trợ giúp",
				ru: "Справочный документ",
				tr: "Yardım Belgeleri",
				ja: "ヘルプドキュメント",
			},
			csh2: {
				zh: "Kares云平台",
				en: "Kares Cloud Platform",
				vi: "Nền tảng đám mây Kares",
				ru: "Облачная платформа Kares",
				tr: "Kares Bulut Platformu",
				ja: "Karesクラウドプラットフォーム",
			},
			csh3: {
				zh: "PE软件",
				en: "PE Software",
				vi: "Phần mềm PE",
				ru: "Программное обеспечение PE",
				tr: "PE Yazılımı",
				ja: "PEソフトウェア",
			},
			csh4: {
				zh: "手机APP",
				en: "Mobile APP",
				vi: "Ứng dụng di động",
				ru: "Мобильное ПРИЛОЖЕНИЕ",
				tr: "Mobil Uygulama",
				ja: "携帯アプリ",
			}
		},
		MediaManage: {
			csm1: {
				zh: "媒体目录名称",
				en: "Media Directory Name",
				vi: "Tên thư mục phương tiện",
				ru: "Имя каталога мультимедиа",
				tr: "Medya Dizini Adı",
				ja: "メディアディレクトリ名",
			},
			csm2: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать",
				tr: "işletmek",
				ja: "操作",
			},
			csm3: {
				zh: "新增目录",
				en: "Add a new directory",
				vi: "Thêm một thư mục mới",
				ru: "Новое оглавление",
				tr: "Yeni bir dizin ekle",
				ja: "新規ディレクトリ",
			},
			csm4: {
				zh: "英文名称",
				en: "English name",
				vi: "tên tiêng Anh",
				ru: "Английское имя",
				tr: "İngilizce adı",
				ja: "英語名",
			},
			csm5: {
				zh: "中文名称",
				en: "Chinese name",
				vi: "Tên tiếng Trung",
				ru: "Китайское название",
				tr: "Çince adı",
				ja: "中国語の名前",
			},
			csm6: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять",
				tr: "İptal etmek",
				ja: "キャンセル",
			},
			csm7: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять",
				tr: "Elbette",
				ja: "を選択して、",
			},
			csm8: {
				zh: "请问是否要永久删除当前目录？",
				en: "Do you want to permanently delete the current directory?",
				vi: "Bạn có muốn xóa vĩnh viễn thư mục hiện tại không?",
				ru: "Вы хотите навсегда удалить текущий каталог?",
				tr: "Geçerli dizini kalıcı olarak silmek istiyor musunuz?",
				ja: "現在のディレクトリを永久に削除しますか？",
			},
			csm9: {
				zh: "请输入英文名称",
				en: "Please enter your English name",
				vi: "Vui lòng nhập tên tiếng Anh của bạn",
				ru: "Пожалуйста, введите английское название",
				tr: "Lütfen İngilizce adınızı girin",
				ja: "英語名を入力してください",
			},
			csm10: {
				zh: "请输入中文名称",
				en: "Please enter your Chinese name",
				vi: "Vui lòng nhập tên tiếng Trung của bạn",
				ru: "Пожалуйста, введите китайское название",
				tr: "Lütfen Çince adınızı girin",
				ja: "中国語名を入力してください",
			}
		},
		NodeManage: {
			csn1: {
				zh: "测试",
				en: "test",
				vi: "Bài kiểm tra",
				ru: "проверка",
				tr: "test",
				ja: "テスト",
			},
			csn2: {
				zh: "请输入英文名称",
				en: "Please enter your English name",
				vi: "Vui lòng nhập tên tiếng Anh của bạn",
				ru: "Пожалуйста, введите английское название",
				tr: "Lütfen İngilizce adınızı girin",
				ja: "英語名を入力してください",
			},
			csn3: {
				zh: "请输入中文名称",
				en: "Please enter your Chinese name",
				vi: "Vui lòng nhập tên tiếng Trung của bạn",
				ru: "Пожалуйста, введите китайское название",
				tr: "Lütfen Çince adınızı girin",
				ja: "中国語名を入力してください",
			}
		},
		OperationLog: {
			cso1: {
				zh: "用户名",
				en: "username",
				vi: "tên tài khoản",
				ru: "имя пользователя",
				tr: "kullanıcı adı",
				ja: "ユーザー名",
			},
			cso2: {
				zh: "功能",
				en: "Function",
				vi: "Chức năng",
				ru: "функция",
				tr: "İşlev",
				ja: "機能",
			},
			cso3: {
				zh: "描述",
				en: "describe",
				vi: "mô tả",
				ru: "описание",
				tr: "betimlemek",
				ja: "説明",
			},
			cso4: {
				zh: "操作时间",
				en: "Operation time",
				vi: "Thời gian hoạt động",
				ru: "Время работы",
				tr: "Operasyon süresi",
				ja: "そうさじかん",
			}
		},
		OrganizationManage: {
			csom1: {
				zh: "请输入组织结构名称",
				en: "Please enter the name of the organization",
				vi: "Vui lòng nhập tên tổ chức",
				ru: "Пожалуйста, введите название организационной структуры",
				tr: "Lütfen kuruluşun adını girin",
				ja: "組織構造名を入力してください",
			}
		},
		PersonalCenter: {
			cspc1: {
				zh: "未设置",
				en: "Not set",
				vi: "Không được thiết lập",
				ru: "Не установлен",
				tr: "Ayarlanmadı",
				ja: "未設定",
			},
			cspc2: {
				zh: "参数不能全部为空",
				en: "Parameters cannot all be empty",
				vi: "Tham số không thể tất cả trống",
				ru: "Параметры не могут быть все пустыми",
				tr: "Parametreler hepsi boş olamaz",
				ja: "パラメーターはすべて空にすることはできません",
			}
		},
		ReferralCode: {
			csr1: {
				zh: "推荐码申请",
				en: "Referral code application",
				vi: "Ứng dụng mã giới thiệu",
				ru: "Применение рекомендательного кода",
				tr: "Referans kodu uygulaması",
				ja: "推奨コード申請",
			},
			csr2: {
				zh: "拼命申请中",
				en: "Desperately applying",
				vi: "Đang côs hết sức để nộp",
				ru: "В настоящее время применяется",
				tr: "Umutsuzca başvuruyor",
				ja: "命がけで申し込み中",
			},
			csr3: {
				zh: "邮箱",
				en: "Mail",
				vi: "Thư",
				ru: "электронная почта",
				tr: "Posta",
				ja: "メールボックス",
			},
			csr4: {
				zh: "密码",
				en: "Password",
				vi: "mật khẩu",
				ru: "код",
				tr: "şifre",
				ja: "パスワード",
			},
			csr5: {
				zh: "立即申请",
				en: "apply immediately",
				vi: "áp dụng ngay lập tức",
				ru: "Подайте заявку прямо сейчас",
				tr: "hemen başvur",
				ja: "今すぐ応募",
			},
			csr6: {
				zh: "推荐码已发送至您的邮箱，请注意查收！",
				en: "The referral code has been sent to your email, please check it!",
				vi: "Mã giới thiệu đã được gửi vào email của bạn, bạn kiểm tra nhé!",
				ru: "Рекомендательный код был отправлен на ваш почтовый ящик, пожалуйста, обратите внимание и проверьте его!",
				tr: "Referans kodunuz e-posta adresinize gönderildi, lütfen kontrol edin!",
				ja: "推奨コードがメールアドレスに送信されました。ご確認ください。",
			},
			csr7: {
				zh: "立即修改",
				en: "Modify now",
				vi: "Sửa đổi ngay bây giờ",
				ru: "Измените сейчас",
				tr: "Şimdi değiştir",
				ja: "今すぐ変更",
			},
			csr8: {
				zh: "首次登录需修改默认密码！",
				en: "The default password needs to be changed when logging in for the first time!",
				vi: "Mật khẩu mặc định cần được thay đổi khi đăng nhập lần đầu tiên!",
				ru: "Для первого входа в систему вам необходимо изменить пароль по умолчанию!",
				tr: "İlk kez oturum açarken varsayılan şifrenin değiştirilmesi gerekiyor!",
				ja: "初回ログインにはデフォルトパスワードを変更する必要があります！",
			}
		},
		RoleManage: {
			csrm1: {
				zh: "请输入角色名称",
				en: "Please enter a role name",
				vi: "Vui lòng nhập tên vai trò",
				ru: "Пожалуйста, введите название роли",
				tr: "Lütfen bir rol adı girin",
				ja: "ロール名を入力してください",
			},
			csrm2: {
				zh: "长度在2 到 20 个字符",
				en: "Length between 2 and 20 characters",
				vi: "Độ dài từ 2 đến 20 ký tự",
				ru: "Длина - от 2 до 20 символов",
				tr: "2 ila 20 karakter arası uzunluk",
				ja: "長さは2～20文字",
			},
			csrm3: {
				zh: "至少配置一个系统权限！",
				en: "Configure at least one system permission!",
				vi: "Cấu hình ít nhất một quyền hệ thống!",
				ru: "Настройте хотя бы одно системное разрешение!",
				tr: "En az bir sistem iznini yapılandırın!",
				ja: "少なくとも1つのシステム権限を設定します！",
			},
			csrm4: {
				zh: "管理员",
				en: "Administrator",
				vi: "Quản trị viên",
				ru: "Администратор",
				tr: "Yönetici",
				ja: "管理者"
			},
			csrm5: {
				zh: "操作员",
				en: "Operator",
				vi: "Người vận hành",
				ru: "Оператор",
				tr: "Operatör",
				ja: "オペレーター"
			},
			csrm6: {
				zh: "审核员",
				en: "Auditor",
				vi: "Kiểm toán viên",
				ru: "Аудитор",
				tr: "Denetçi",
				ja: "監査員"
			},
			csrm7: {
				zh: "业务操作员",
				en: "Business Operator",
				vi: "Nhân viên vận hành kinh doanh",
				ru: "Оперативный сотрудник",
				tr: "İşletme Operatörü",
				ja: "業務オペレーター"
			},
			csrm8: {
				zh: "部分管理角色",
				en: "Partial Management Role",
				vi: "Vai trò quản lý một phần",
				ru: "Частичная роль управления",
				tr: "Kısmi Yönetim Rolü",
				ja: "部分的な管理ロール"
			}
		},
		SystemLayout: {
			css1: {
				zh: "网页图标",
				en: "Web Icons",
				vi: "Biểu tượng web",
				ru: "Веб-значок",
				tr: "Web Simgeleri",
				ja: "Webページアイコン",
			},
			css2: {
				zh: "图片格式必须为.ico",
				en: "The image format must be .ico",
				vi: "Định dạng hình ảnh phải là .ico",
				ru: "Формат изображения должен быть.ico",
				tr: "Resim formatı .ico olmalıdır",
				ja: "画像フォーマットは.icoでなければなりません",
			}
		},
		UrgentContent: {
			csu1: {
				zh: "紧急文本",
				en: "",
				vi: "văn bản khẩn cấp",
				ru: "Экстренный текст",
				tr: "Acil Durum Metni",
				ja: "緊急テキスト",
			},
			csu2: {
				zh: "紧急信息名称",
				en: "",
				vi: "Tên thông tin khẩn cấp",
				ru: "Название экстренной информации",
				tr: "Acil Durum Bilgi Adı",
				ja: "緊急情報名",
			},
			csu3: {
				zh: "请输入内容",
				en: "",
				vi: "Vui lòng nhập nội dung",
				ru: "Пожалуйста, введите содержание",
				tr: "Lütfen içeriği girin",
				ja: "内容を入力してください",
			},
			csu4: {
				zh: "紧急信息内容",
				en: "",
				vi: "Nội dung thông tin khẩn cấp",
				ru: "Содержание информации о чрезвычайных ситуациях",
				tr: "Acil durum bilgi içeriği",
				ja: "緊急情報の内容",
			},
			csu5: {
				zh: "确认保存当前修改?",
				en: "",
				vi: "Bạn có chắc chắn muốn lưu những thay đổi hiện tại không?",
				ru: "Подтвердите, чтобы сохранить текущие изменения?",
				tr: "Mevcut değişiklikleri kaydetmek istediğinizden emin misiniz?",
				ja: "現在の変更を保存することを確認しますか？",
			},
			csu6: {
				zh: "确定",
				en: "",
				vi: "Chắc chắn",
				ru: "уверенный",
				tr: "Elbette",
				ja: "を選択して、",
			},
			csu7: {
				zh: "编辑",
				en: "Edit",
				vi: "biên tập",
				ru: "редактор",
				tr: "düzenlemek",
				ja: "編集",
			},
			csu8: {
				zh: "确认删除?",
				en: "",
				vi: "xác nhận xóa?",
				ru: "Подтвердить удаление?",
				tr: "silme işlemi onaylansın mı?",
				ja: "削除を確認しますか？",
			},
			csu9: {
				zh: "删除",
				en: "Delete",
				vi: "xóa bỏ",
				ru: "стирать",
				tr: "silmek",
				ja: "削除＃サクジョ＃",
			},
			csu10: {
				zh: "新增紧急文本",
				en: "",
				vi: "Thêm văn bản khẩn cấp",
				ru: "Добавить текст экстренной помощи",
				tr: "Acil durum metni ekleyin",
				ja: "緊急テキストの追加",
			},
			csu11: {
				zh: "紧急版式",
				en: "",
				vi: "Bố trí khẩn cấp",
				ru: "Аварийная планировка",
				tr: "Acil Durum Düzeni",
				ja: "緊急レイアウト",
			},
			csu12: {
				zh: "紧急信息内容",
				en: "",
				vi: "Nội dung thông tin khẩn cấp",
				ru: "Содержание информации о чрезвычайных ситуациях",
				tr: "Acil durum bilgi içeriği",
				ja: "緊急情報の内容",
			},
			csu13: {
				zh: "(需先将紧急版式内容传到终端)",
				en: "",
				vi: "(Nội dung định dạng khẩn cấp phải được truyền đến thiết bị đầu cuối trước)",
				ru: "(Сначала вам необходимо загрузить содержимое аварийного макета в терминал)",
				tr: "(Acil durum formatı içeriği öncelikle terminale iletilmelidir)",
				ja: "（緊急版コンテンツを端末に転送する必要がある）",
			},
			csu14: {
				zh: "请输入内容",
				en: "",
				vi: "Vui lòng nhập nội dung",
				ru: "Пожалуйста, введите содержание",
				tr: "Lütfen içeriği girin",
				ja: "内容を入力してください",
			},
			csu15: {
				zh: "新增紧急版式",
				en: "",
				vi: "Bố cục khẩn cấp mới",
				ru: "Добавлена схема аварийной ситуации",
				tr: "Yeni acil durum düzeni",
				ja: "緊急レイアウトの追加",
			},
			csu16: {
				zh: "紧急信息名称",
				en: "",
				vi: "Tên thông tin khẩn cấp",
				ru: "Название экстренной информации",
				tr: "Acil Durum Bilgi Adı",
				ja: "緊急情報名",
			}
		},
		UserManage: {
			csum1: {
				zh: "账号",
				en: "Account",
				vi: "tài khoản",
				ru: "счет",
				tr: "hesap",
				ja: "アカウント",
			},
			csum2: {
				zh: "姓名",
				en: "Name",
				vi: "Tên",
				ru: "полное имя",
				tr: "İsim",
				ja: "名前",
			},
			csum3: {
				zh: "角色",
				en: "Role",
				vi: "Vai trò",
				ru: "роль",
				tr: "Rol",
				ja: "ロール＃ロール＃",
			},
			csum4: {
				zh: "等级",
				en: "grade",
				vi: "cấp",
				ru: "уровень",
				tr: "seviye",
				ja: "等級",
			},
			csum5: {
				zh: "备注",
				en: "Remark",
				vi: "Nhận xét",
				ru: "Замечания",
				tr: "Açıklama",
				ja: "コメント",
			},
			csum6: {
				zh: "操作",
				en: "operate",
				vi: "vận hành",
				ru: "работать",
				tr: "işletmek",
				ja: "操作",
			},
			csum7: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			csum8: {
				zh: "请选择组织结构",
				en: "Please select your organizational structure",
				vi: "Vui lòng chọn cơ cấu tổ chức của bạn",
				ru: "Пожалуйста, выберите организационную структуру",
				tr: "Lütfen organizasyon yapınızı seçin",
				ja: "組織構造を選択してください",
			},
			csum9: {
				zh: "角色名称",
				en: "Role Name",
				vi: "Tên vai trò",
				ru: "Имя персонажа",
				tr: "Rol Adı",
				ja: "ロール名",
			},
			csum10: {
				zh: "请选择角色名称",
				en: "Please select a role name",
				vi: "Vui lòng chọn tên vai trò",
				ru: "Пожалуйста, выберите название роли",
				tr: "Lütfen bir rol adı seçin",
				ja: "ロール名を選択してください",
			},
			csum11: {
				zh: "管理员: 有全部权限，可创建账号，制作、发布节目，管理设备，审核等。",
				en: "Administrator: Has full permissions, can create accounts, produce and publish programs, manage equipment, review, etc.",
				vi: "Quản trị viên Có đầy đủ quyền, có thể tạo tài khoản, sản xuất và xuất bản chương trình, quản lý thiết bị, đánh giá, v.v.",
				ru: "Администратор: Обладает всеми разрешениями, может создавать учетные записи, создавать и публиковать программы, управлять оборудованием, просматривать и т.д.",
				tr: "Yönetici: Tam izinlere sahiptir, hesap oluşturabilir, programlar üretebilir ve yayınlayabilir, ekipmanı yönetebilir, inceleyebilir vb.",
				ja: "管理者：アカウントの作成、番組の作成、配布、デバイスの管理、監査などのすべての権限があります。",
			},
			csum12: {
				zh: "审核员: 仅有审核权限；无法创建账号，添加设备、节目，控制设备。",
				en: "Auditor: Has only audit authority; cannot create accounts, add devices, programs, or control devices.",
				vi: "Kiểm toán viên chỉ có thẩm quyền kiểm toán; không thể tạo tài khoản, thêm thiết bị, chương trình hoặc điều khiển thiết bị.",
				ru: "Аудитор: имеет только аудиторские полномочия; не может создавать учетную запись, добавлять оборудование, программы или управлять оборудованием.",
				tr: "Denetçi: Yalnızca denetim yetkisine sahiptir; hesap oluşturamaz, cihaz, program ekleyemez veya cihazları kontrol edemez.",
				ja: "審査員：審査権限のみ、アカウントの作成、デバイス、番組の追加、デバイスの制御に失敗しました。",
			},
			csum13: {
				zh: "操作员: 有制作、发布节目，管理设备权限；无法创建账号及审核。",
				en: "Operator: Has the authority to produce and publish programs, and manage equipment; cannot create accounts or conduct audits.",
				vi: "Nhà điều hành Có quyền sản xuất và xuất bản các chương trình cũng như quản lý thiết bị; không thể tạo tài khoản hoặc tiến hành kiểm toán.",
				ru: "Оператор: Имеет право создавать, публиковать программы и управлять оборудованием; не может создавать учетные записи и просматривать их.",
				tr: "Operatör: Program üretme ve yayınlama ve ekipmanı yönetme yetkisine sahiptir; hesap oluşturamaz veya denetim gerçekleştiremez.",
				ja: "オペレータ：番組を作成、発表し、設備を管理する権限がある、アカウントとレビューを作成できませんでした。",
			},
			csum14: {
				zh: "密码",
				en: "Password",
				vi: "mật khẩu",
				ru: "код",
				tr: "şifre",
				ja: "パスワード",
			},
			csum15: {
				zh: "确认密码",
				en: "Confirm Pass",
				vi: "Xác nhận mật khẩu",
				ru: "Подтвердите пароль",
				tr: "Şifreyi Onayla",
				ja: "パスワードの確認",
			},
			csum16: {
				zh: "邮箱",
				en: "Mail",
				vi: "Thư",
				ru: "электронная почта",
				tr: "Posta",
				ja: "メールボックス",
			},
			csum17: {
				zh: "取 消",
				en: "Cancel",
				vi: "Hủy bỏ",
				ru: "отменять",
				tr: "İptal etmek",
				ja: "キャンセル",
			},
			csum18: {
				zh: "确 定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "определять",
				tr: "Elbette",
				ja: "を選択して、",
			},
			csum19: {
				zh: "删除用户",
				en: "delete users",
				vi: "xóa người dùng",
				ru: "Удалить пользователя",
				tr: "kullanıcıları sil",
				ja: "ユーザーの削除",
			},
			csum20: {
				zh: "请问是否要永久删除当前角色？",
				en: "Do you want to permanently delete the current role?",
				vi: "Bạn có muốn xóa vĩnh viễn vai trò hiện tại không?",
				ru: "Вы хотите удалить текущую роль навсегда?",
				tr: "Mevcut rolü kalıcı olarak silmek istiyor musunuz?",
				ja: "現在のロールを完全に削除しますか？",
			},
			csum21: {
				zh: "解封设备",
				en: "Unblock device",
				vi: "Bỏ chặn thiết bị",
				ru: "Разблокирующее оборудование",
				tr: "Cihazın engellemesini kaldır",
				ja: "カプセル解除装置",
			},
			csum22: {
				zh: "封禁设备",
				en: "Blocked devices",
				vi: "Thiết bị bị chặn",
				ru: "Запрещенное оборудование",
				tr: "Engellenen cihazlar",
				ja: "シール装置",
			},
			csum23: {
				zh: "请问是否要解封当前或从属设备？",
				en: "Do you want to unblock the current or slave device?",
				vi: "Bạn có muốn bỏ chặn thiết bị hiện tại hoặc thiết bị phụ?",
				ru: "Вы хотите разблокировать текущее или подчиненное устройство?",
				tr: "Geçerli veya bağımlı cihazın engellemesini kaldırmak istiyor musunuz?",
				ja: "すみません、現在またはスレーブデバイスを開封しますか？",
			},
			csum24: {
				zh: "请问是否要封禁当前或从属设备？",
				en: "Do you want to block the current or subordinate device?",
				vi: "Bạn có muốn chặn thiết bị hiện tại hoặc thiết bị cấp dưới không?",
				ru: "Вы хотите заблокировать текущие или подчиненные устройства?",
				tr: "Geçerli veya alt cihazı engellemek istiyor musunuz?",
				ja: "すみません、現在またはスレーブデバイスを封印しますか？",
			},
			csum25: {
				zh: "请输入确认密码",
				en: "Please enter the confirmation password",
				vi: "Vui lòng nhập mật khẩu xác nhận",
				ru: "Пожалуйста, введите пароль для подтверждения",
				tr: "Lütfen onay şifresini girin",
				ja: "確認パスワードを入力してください",
			},
			csum26: {
				zh: "两次输入密码不一致!",
				en: "The passwords you entered twice do not match!",
				vi: "Mật khẩu bạn nhập hai lần không khớp!",
				ru: "Введенный дважды пароль является несогласованным!",
				tr: "İki kez girdiğiniz şifreler eşleşmiyor!",
				ja: "2回の入力パスワードが一致しません！",
			},
			csum27: {
				zh: "新增用户",
				en: "New users",
				vi: "Những người dùng mới",
				ru: "Новые пользователи",
				tr: "Yeni kullanıcılar",
				ja: "新規ユーザー",
			},
			csum28: {
				zh: "请输入姓名",
				en: "Please type in your name",
				vi: "Vui lòng nhập tên của bạn",
				ru: "Пожалуйста, введите свое имя",
				tr: "Lütfen adınızı yazın",
				ja: "名前を入力してください",
			},
			csum29: {
				zh: "请输入密码",
				en: "Please enter your password",
				vi: "Vui lòng nhập mật khẩu của bạn",
				ru: "Пожалуйста, введите пароль",
				tr: "Lütfen şifrenizi girin",
				ja: "パスワードを入力してください",
			},
			csum30: {
				zh: "必须八位以上且包含字母,数字以及特殊字符",
				en: "Must be at least eight characters long and contain letters, numbers, and special characters",
				vi: "Phải dài ít nhất tám ký tự và chứa các chữ cái, số và ký tự đặc biệt",
				ru: "Должно содержать более восьми цифр и буквы, цифры и специальные символы",
				tr: "En az sekiz karakter uzunluğunda olmalı ve harf, rakam ve özel karakterler içermelidir",
				ja: "8桁以上の英字、数字、特殊文字を含む必要があります",
			},
			csum31: {
				zh: "角色名称不能为空",
				en: "Role name cannot be empty",
				vi: "Tên vai trò không được để trống",
				ru: "Имя роли не может быть пустым",
				tr: "Rol adı boş olamaz",
				ja: "ロール名を空にすることはできません",
			},
			csum32: {
				zh: "组织结构不能为空",
				en: "Organization structure cannot be empty",
				vi: "Cơ cấu tổ chức không được để trống",
				ru: "Организационная структура не может быть пустой",
				tr: "Organizasyon yapısı boş olamaz",
				ja: "組織構造を空にすることはできません",
			},
			csum33: {
				zh: "解禁当前",
				en: "Unban current",
				vi: "Bỏ cấm hiện tại",
				ru: "Отмена действующего запрета",
				tr: "Geçerli yasağı kaldır",
				ja: "現在の解禁",
			},
			csum34: {
				zh: "解禁从属",
				en: "Unban Dependents",
				vi: "Bỏ cấm người phụ thuộc",
				ru: "Отмените запрет!",
				tr: "Bağımlıların Yasağını Kaldır",
				ja: "依存の解禁",
			},
			csum35: {
				zh: "新增用户",
				en: "New users",
				vi: "Những người dùng mới",
				ru: "Новые пользователи",
				tr: "Yeni kullanıcılar",
				ja: "新規ユーザー",
			},
			csum36: {
				zh: "修改用户",
				en: "Modify User",
				vi: "Sửa đổi người dùng",
				ru: "Изменить пользователя",
				tr: "Kullanıcıyı Değiştir",
				ja: "ユーザーの変更",
			},
			csum37: {
				zh: "账号不允许为空!",
				en: "The account number cannot be empty!",
				vi: "Số tài khoản không được để trống!",
				ru: "Учетная запись не должна быть пустой!",
				tr: "Hesap numarası boş olamaz!",
				ja: "アカウントを空にすることはできません！",
			},
			csum38: {
				zh: "账号中只能包含数字、字母、下划线!",
				en: "The account number can only contain numbers, letters, and underscores!",
				vi: "Số tài khoản chỉ được chứa số, chữ cái và dấu gạch dưới!",
				ru: "В учетную запись могут быть включены только цифры, буквы и символы подчеркивания!",
				tr: "Hesap numarası yalnızca rakam, harf ve alt çizgi içerebilir!",
				ja: "アカウントに含まれるのは数字、文字、アンダースコアのみ！",
			},
			csum39: {
				zh: "请设置账号长度为3~20个字符!",
				en: "Please set the account length to 3~20 characters!",
				vi: "Vui lòng đặt độ dài tài khoản thành 3 ~ 20 ký tự!",
				ru: "Пожалуйста, укажите длину учетной записи от 3 до 20 символов!",
				tr: "",
				ja: "アカウントの長さを3 ~ 20文字に設定してください！",
			},
			csum40: {
				zh: "当前账号已注册，请重输入!",
				en: "The current account has been registered, please re-enter!",
				vi: "Tài khoản hiện tại đã được đăng ký, vui lòng nhập lại!",
				ru: "Текущая учетная запись была зарегистрирована, пожалуйста, введите ее повторно!",
				tr: "Mevcut hesap kaydedildi, lütfen tekrar girin!",
				ja: "現在のアカウントは登録されていますので、再入力してください！",
			}
		}
	},
	terminal: {
		children: {
			DeviceDetailHight: {
				DeviceControl: {
					ctcdd1: {
						zh: "亮度",
						en: "brightness",
						vi: "độ sáng",
						ru: "яркость",
						tr: "parlaklık",
						ja: "きど",
					},
					ctcdd2: {
						zh: "声音",
						en: "sound",
						vi: "âm thanh",
						ru: "голос",
						tr: "ses",
						ja: "サウンド",
					}
				},
				DeviceInfo: {
					ctcdde1: {
						zh: "设备名称",
						en: "Device Name",
						vi: "Tên thiết bị",
						ru: "Имя устройства",
						tr: "Cihaz Adı",
						ja: "デバイス名",
					},
					ctcdde2: {
						zh: "屏幕类型",
						en: "Screen type",
						vi: "Loại màn hình",
						ru: "Тип экрана",
						tr: "Ekran tipi",
						ja: "画面タイプ",
					},
					ctcdde3: {
						zh: "分辨率",
						en: "Resolution",
						vi: "Độ phân giải",
						ru: "разрешение",
						tr: "Çözünürlük",
						ja: "解像度",
					},
					ctcdde4: {
						zh: "版本号",
						en: "version number",
						vi: "số phiên bản",
						ru: "Номер версии",
						tr: "sürüm numarası",
						ja: "バージョン番号",
					},
					ctcdde5: {
						zh: "系统信息",
						en: "system message",
						vi: "tin nhăn hệ thông",
						ru: "Системная информация",
						tr: "sistem mesajı",
						ja: "システム情報",
					},
					ctcdde6: {
						zh: "备注",
						en: "Remark",
						vi: "Nhận xét",
						ru: "Замечания",
						tr: "Açıklama",
						ja: "コメント",
					},
					ctcdde7: {
						zh: "安装日期",
						en: "Installation Date",
						vi: "Ngày cài đặt",
						ru: "Дата установки",
						tr: "Kurulum Tarihi",
						ja: "インストール日",
					},
					ctcdde8: {
						zh: "运行状态",
						en: "Operating status",
						vi: "Trạng thái hoạt động",
						ru: "Рабочее состояние",
						tr: "Çalışma durumu",
						ja: "運転状態",
					},
					ctcdde9: {
						zh: "正在播放",
						en: "Now Playing",
						vi: "Đang phát",
						ru: "Играющий",
						tr: "Şimdi Oynanıyor",
						ja: "再生中",
					},
					ctcdde10: {
						zh: "盒子时钟",
						en: "Box Clock",
						vi: "Đồng hồ hộp",
						ru: "Часы-шкатулка",
						tr: "Kutu Saati",
						ja: "箱時計",
					},
					ctcdde11: {
						zh: "当前时区",
						en: "Current time zone",
						vi: "Múi giờ hiện tại",
						ru: "Текущий часовой пояс",
						tr: "Geçerli saat dilimi",
						ja: "現在のタイムゾーン",
					},
					ctcdde12: {
						zh: "运行时间",
						en: "operation hours",
						vi: "giờ hoạt động",
						ru: "Время выполнения",
						tr: "çalışma saatleri",
						ja: "実行時間",
					},
					ctcdde13: {
						zh: "定时指令",
						en: "Timing instructions",
						vi: "Hướng dẫn tính thời gian",
						ru: "Команда синхронизации",
						tr: "Zamanlama talimatları",
						ja: "タイミングめいれい",
					},
					ctcdde14: {
						zh: "定时播放",
						en: "Scheduled playback",
						vi: "Phát lại theo lịch trình",
						ru: "Синхронизированное воспроизведение",
						tr: "Zamanlanmış oynatma",
						ja: "タイミング再生",
					},
					ctcdde15: {
						zh: "同步播放",
						en: "Synchronous playback",
						vi: "Phát lại đồng bộ",
						ru: "Синхронное воспроизведение",
						tr: "Senkronize oynatma",
						ja: "同期再生",
					},
					ctcdde16: {
						zh: "信号源",
						en: "signal source",
						vi: "nguồn tín hiệu",
						ru: "источник сигнала",
						tr: "sinyal kaynağı",
						ja: "しんごうげん",
					},
					ctcdde17: {
						zh: "内存空间",
						en: "Memory space",
						vi: "Không gian bộ nhớ",
						ru: "Объем памяти",
						tr: "Bellek alanı",
						ja: "メモリ容量",
					},
					ctcdde18: {
						zh: "IP地址",
						en: "IP address",
						vi: "địa chỉ IP",
						ru: "ip-адрес",
						tr: "IP adresi",
						ja: "IPアドレス",
					},
					ctcdde19: {
						zh: "云看护",
						en: "Cloud Care",
						vi: "Chăm sóc đám mây",
						ru: "Уход за облаком",
						tr: "Bulut Bakımı",
						ja: "クラウドケア",
					},
					ctcdde20: {
						zh: "最近心跳",
						en: "Recent heartbeat",
						vi: "Nhịp tim gần đây",
						ru: "Недавнее сердцебиение",
						tr: "Son kalp atışı",
						ja: "最近のハートビート",
					},
					ctcdde21: {
						zh: "设备语言",
						en: "Device language",
						vi: "Ngôn ngữ thiết bị",
						ru: "Язык устройства",
						tr: "Cihaz dili",
						ja: "デバイス言語",
					},
					ctcdde22: {
						zh: "安装日期",
						en: "Installation Date",
						vi: "Ngày cài đặt",
						ru: "Дата установки",
						tr: "Kurulum Tarihi",
						ja: "インストール日",
					},
					ctcdde23: {
						zh: "运行状态",
						en: "Operating status",
						vi: "Trạng thái hoạt động",
						ru: "Рабочее состояние",
						tr: "Çalışma durumu",
						ja: "運転状態",
					},
					ctcdde24: {
						zh: "离线",
						en: "Offline",
						vi: "Ngoại tuyến",
						ru: "не в сети",
						tr: "Çevrimdışı",
						ja: "オフライン",
					},
					ctcdde25: {
						zh: "关屏",
						en: "Turn off the screen",
						vi: "Tắt màn hình",
						ru: "Выключите экран",
						tr: "Ekranı kapat",
						ja: "スクリーンを閉じる",
					},
					ctcdde26: {
						zh: "开屏",
						en: "Open screen",
						vi: "Mở màn hình",
						ru: "Открытый экран",
						tr: "Ekranı aç",
						ja: "の見える所に来る",
					},
					ctcdde27: {
						zh: "HDMI优先",
						en: "HDMI First",
						vi: "Ưu tiên HDMI",
						ru: "Приоритет HDMI",
						tr: "Önce HDMI",
						ja: "HDMI優先",
					},
					ctcdde28: {
						zh: "异步信号",
						en: "Asynchronous signals",
						vi: "Tín hiệu không đồng bộ",
						ru: "Асинхронный сигнал",
						tr: "Asenkron sinyaller",
						ja: "非同期信号",
					},
					ctcdde29: {
						zh: "同步信号",
						en: "Synchronous signal",
						vi: "Tín hiệu đồng bộ",
						ru: "Сигнал синхронизации",
						tr: "Senkron sinyal",
						ja: "どうきしんごう",
					},
					ctcdde30: {
						zh: "操作系统",
						en: "operating system",
						vi: "hệ điều hành",
						ru: "операционная система",
						tr: "işletim sistemi",
						ja: "オペレーティングシステム",
					},
					ctcdde31: {
						zh: "运行内存",
						en: "Running Memory",
						vi: "Bộ nhớ đang chạy",
						ru: "Работающая память",
						tr: "Hafızayı Çalıştırma",
						ja: "メモリの実行",
					},
					ctcdde32: {
						zh: "有线网络",
						en: "Wired network",
						vi: "Mạng có dây",
						ru: "Проводная сеть",
						tr: "Kablolu ağ",
						ja: "有線ネットワーク",
					},
					ctcdde33: {
						zh: "系统修复",
						en: "System Repair",
						vi: "Sửa chữa hệ thống",
						ru: "Ремонт системы",
						tr: "Sistem Onarımı",
						ja: "システム修理"
					}
				},
				index_b: {
					ctcdi1: {
						zh: "云看护：",
						en: "Cloud Care:",
						vi: "Chăm sóc đám mây",
						ru: "Уход за облаком：",
						tr: "Bulut Bakımı:",
						ja: "クラウドケア：",
					},
					ctcdi2: {
						zh: "开启",
						en: "Open",
						vi: "Mở",
						ru: "включать",
						tr: "Açık",
						ja: "オープン",
					},
					ctcdi3: {
						zh: "关闭",
						en: "closure",
						vi: "Khép kín",
						ru: "закрывать",
						tr: "kapatma",
						ja: "閉じる",
					},
					ctcdi4: {
						zh: "暂无数据",
						en: "No data",
						vi: "Không có dữ liệu",
						ru: "Нет доступных данных",
						tr: "Veri yok",
						ja: "データが一時的にありません",
					},
					ctcdi5: {
						zh: "已开启",
						en: "Turned on",
						vi: "Đã bật",
						ru: "Включенный",
						tr: "Açık",
						ja: "オープン",
					},
					ctcdi6: {
						zh: "未开启",
						en: "Unopened",
						vi: "Chưa mở",
						ru: "Не включен",
						tr: "Açılmamış",
						ja: "オープンしていません",
					},
					ctcdi7: {
						zh: "GPS同步",
						en: "GPS Sync",
						vi: "Đồng bộ hóa GPS",
						ru: "GPS-синхронизация",
						tr: "GPS Senkronizasyonu",
						ja: "GPS同期",
					},
					ctcdi8: {
						zh: "网络同步",
						en: "Network synchronization",
						vi: "Đồng bộ hóa mạng",
						ru: "Сетевая синхронизация",
						tr: "Ağ senkronizasyonu",
						ja: "ネットワーク同期",
					},
					ctcdi9: {
						zh: "定时播放",
						en: "Scheduled playback",
						vi: "Phát lại theo lịch trình",
						ru: "Синхронизированное воспроизведение",
						tr: "Zamanlanmış oynatma",
						ja: "タイミング再生",
					},
					ctcdi10: {
						zh: "WIFI网络",
						en: "WIFI network",
						vi: "Mạng wifi",
						ru: "Сеть Wi-FI",
						tr: "Wi-Fi ağı",
						ja: "WIFIネットワーク",
					},
					ctcdi11: {
						zh: "有线网络",
						en: "Wired network",
						vi: "Mạng có dây",
						ru: "Проводная сеть",
						tr: "Kablolu ağ",
						ja: "有線ネットワーク",
					},
					ctcdi12: {
						zh: "同步播放",
						en: "Synchronous playback",
						vi: "Phát lại đồng bộ",
						ru: "Синхронное воспроизведение",
						tr: "Senkronize oynatma",
						ja: "同期再生",
					}
				},
				index: {
					ctcdin1: {
						zh: "截图加载中 ...",
						en: "Loading screenshots...",
						vi: "Đang tải ảnh chụp màn hình...",
						ru: "Загружается скриншот...",
						tr: "Ekran görüntüleri yükleniyor...",
						ja: "スクリーンショットロード中...",
					},
					ctcdin2: {
						zh: "设备信息加载中 ...",
						en: "Loading device information...",
						vi: "Đang tải thông tin thiết bị...",
						ru: "Загружается информация об устройстве...",
						tr: "Cihaz bilgileri yükleniyor...",
						ja: "デバイス情報のロード中...",
					},
					ctcdin3: {
						zh: "开启",
						en: "Open",
						vi: "Mở",
						ru: "включать",
						tr: "Açık",
						ja: "オープン",
					},
					ctcdin4: {
						zh: "关闭",
						en: "closure",
						vi: "Khép kín",
						ru: "закрывать",
						tr: "kapatma",
						ja: "閉じる",
					},
					ctcdin5: {
						zh: "指令设置成功！",
						en: "The command was set successfully!",
						vi: "Lệnh đã được đặt thành công!",
						ru: "Инструкция была успешно выполнена!",
						tr: "Komut başarıyla ayarlandı!",
						ja: "コマンド設定に成功しました！",
					},
					ctcdin6: {
						zh: "正常",
						en: "Normal",
						vi: "Bình thường",
						ru: "Нормальный",
						tr: "Normal",
						ja: "正常"
					},
					ctcdin7: {
						zh: "黑屏",
						en: "Black screen",
						vi: "Màn hình đen",
						ru: "Чёрный экран",
						tr: "Siyah ekran",
						ja: "黒い画面"
					},
					ctcdin8: {
						zh: "已开启",
						en: "On",
						vi: "Bật",
						ru: "Включено",
						tr: "Açık",
						ja: "オン"
					},
					ctcdin9: {
						zh: "未开启",
						en: "Off",
						vi: "Tắt",
						ru: "Выключено",
						tr: "Kapalı",
						ja: "オフ"
					},
					ctcdin10: {
						zh: "GPS同步",
						en: "GPS synchronization",
						vi: "Đồng bộ GPS",
						ru: "GPS-синхронизация",
						tr: "GPS senkronizasyonu",
						ja: "GPS同期"
					},
					ctcdin11: {
						zh: "网络同步",
						en: "Network synchronization",
						vi: "Đồng bộ mạng",
						ru: "Сетевая синхронизация",
						tr: "Ağ senkronizasyonu",
						ja: "ネットワーク同期"
					},
					ctcdin12: {
						zh: "已连接",
						en: "Connected",
						vi: "Đã kết nối",
						ru: "Подключено",
						tr: "Bağlı",
						ja: "接続済み"
					},
					ctcdin13: {
						zh: "未连接",
						en: "Not connected",
						vi: "Chưa kết nối",
						ru: "Не подключено",
						tr: "Bağlı değil",
						ja: "未接続"
					},
					ctcdin14: {
						zh: "未接入",
						en: "Not accessed",
						vi: "Chưa truy cập",
						ru: "Не доступно",
						tr: "Erişilmedi",
						ja: "未アクセス"
					},
					ctcdin15: {
						zh: "信号弱",
						en: "Weak signal",
						vi: "Tín hiệu yếu",
						ru: "Слабый сигнал",
						tr: "Zayıf sinyal",
						ja: "信号が弱い"
					},
					ctcdin16: {
						zh: "正常",
						en: "Normal",
						vi: "Bình thường",
						ru: "Нормальный",
						tr: "Normal",
						ja: "正常"
					},
					ctcdin17: {
						zh: "信号强",
						en: "Strong signal",
						vi: "Tín hiệu mạnh",
						ru: "Сильный сигнал",
						tr: "Güçlü sinyal",
						ja: "信号が強い"
					}
				}
			},
			item: {
				Camera: {
					ctcic1: {
						zh: "选项",
						en: "Options",
						vi: "Tùy chọn",
						ru: "вариант",
						tr: "Bir seçenek ol",
						ja: "オプション",
					},
					ctcic2: {
						zh: "复制成功",
						en: "Copy Success",
						vi: "Sao chép thành công",
						ru: "Успешное копирование",
						tr: "Başarıyı Kopyala",
						ja: "コピー成功",
					}
				},
				CaptureList: {
					ctcicl1: {
						zh: "时间范围查询",
						en: "Time range query",
						vi: "Truy vấn phạm vi thời gian",
						ru: "Запрос временного диапазона",
						tr: "Zaman aralığı sorgusu",
						ja: "時間範囲クエリー",
					},
					ctcicl2: {
						zh: "至",
						en: "to",
						vi: "ĐẾN",
						ru: "до",
						tr: "ile",
						ja: "終了",
					},
					ctcicl3: {
						zh: "开始日期",
						en: "start date",
						vi: "ngày bắt đầu",
						ru: "Дата начала",
						tr: "başlangıç ​​tarihi",
						ja: "開始日",
					},
					ctcicl4: {
						zh: "结束日期",
						en: "End Date",
						vi: "Ngày cuối",
						ru: "Дата окончания",
						tr: "Bitiş Tarihi",
						ja: "終了日",
					},
					ctcicl5: {
						zh: "删除截图",
						en: "Delete screenshots",
						vi: "Xóa ảnh chụp màn hình",
						ru: "Удалить скриншот",
						tr: "Ekran görüntülerini sil",
						ja: "スクリーンショットを削除",
					},
					ctcicl6: {
						zh: "最近一周",
						en: "Last week",
						vi: "Tuần trước",
						ru: "Прошлая неделя",
						tr: "Geçen hafta",
						ja: "最近の週",
					},
					ctcicl7: {
						zh: "最近一个月",
						en: "Last month",
						vi: "Tháng trước",
						ru: "Прошлый месяц",
						tr: "Geçen ay",
						ja: "最近1か月",
					},
					ctcicl8: {
						zh: "最近三个月",
						en: "Last three months",
						vi: "Ba tháng qua",
						ru: "Последние три месяца",
						tr: "Son üç ay",
						ja: "最近3か月",
					},
					ctcicl9: {
						zh: "未选中需要删除截图！",
						en: "Uncheck the need to delete the screenshot!",
						vi: "Bỏ chọn sự cần thiết phải xóa ảnh chụp màn hình!",
						ru: "Снимок экрана необходимо удалить, если он не выбран!",
						tr: "Ekran görüntüsünü silme ihtiyacının işaretini kaldırın!",
						ja: "スクリーンショットを削除するには選択されていません！",
					},
					ctcicl10: {
						zh: "删除成功！",
						en: "successfully deleted!",
						vi: "đã xóa thành công!",
						ru: "Удалено успешно!",
						tr: "başarıyla silindi!",
						ja: "削除に成功しました！",
					}
				},
				CentralControl: {
					ctcicc1: {
						zh: "指令加载中",
						en: "Instructions loading",
						vi: "Hướng dẫn tải",
						ru: "Загрузка инструкций",
						tr: "Talimatlar yükleniyor",
						ja: "命令ロード中",
					},
					ctcicc2: {
						zh: "指令名称",
						en: "Command name",
						vi: "Tên lệnh",
						ru: "Название инструкции",
						tr: "Komut adı",
						ja: "命令名",
					},
					ctcicc3: {
						zh: "协议类型",
						en: "agreement type",
						vi: "loại thỏa thuận",
						ru: "Тип протокола",
						tr: "anlaşma türü",
						ja: "プロトコル・タイプ",
					},
					ctcicc4: {
						zh: "命令类型",
						en: "Command Type",
						vi: "Loại lệnh",
						ru: "Тип команды",
						tr: "Komut Türü",
						ja: "コマンド・タイプ",
					},
					ctcicc5: {
						zh: "指令内容",
						en: "Instruction content",
						vi: "Nội dung hướng dẫn",
						ru: "Содержание инструкции",
						tr: "Talimat içeriği",
						ja: "コマンド内容",
					},
					ctcicc6: {
						zh: "操作",
						en: "operate",
						vi: "vận hành",
						ru: "работать",
						tr: "işletmek",
						ja: "操作",
					},
					ctcicc7: {
						zh: "编辑",
						en: "edit",
						vi: "biên tập",
						ru: "редактор",
						tr: "düzenlemek",
						ja: "編集",
					},
					ctcicc8: {
						zh: "删除",
						en: "delete",
						vi: "xóa bỏ",
						ru: "стирать",
						tr: "silmek",
						ja: "削除＃サクジョ＃",
					},
					ctcicc9: {
						zh: "退出编辑",
						en: "Exit Edit",
						vi: "Thoát Chỉnh sửa",
						ru: "Завершите редактирование",
						tr: "Düzenlemeden Çık",
						ja: "編集を終了",
					},
					ctcicc10: {
						zh: "取 消",
						en: "Cancel",
						vi: "Hủy bỏ",
						ru: "отменять",
						tr: "İptal etmek",
						ja: "キャンセル",
					},
					ctcicc11: {
						zh: "确 定",
						en: "Sure",
						vi: "Chắc chắn",
						ru: "определять",
						tr: "Elbette",
						ja: "を選択して、",
					},
					ctcicc12: {
						zh: "字符串",
						en: "String",
						vi: "Chuỗi",
						ru: "строка",
						tr: "Sicim",
						ja: "文字列",
					},
					ctcicc13: {
						zh: "16进制",
						en: "Hexadecimal",
						vi: "thập lục phân",
						ru: "Шестнадцатеричный",
						tr: "Onaltılık",
						ja: "16進法",
					},
					ctcicc14: {
						zh: "发送成功！",
						en: "Sent successfully!",
						vi: "Gửi thành công!",
						ru: "Отправлено успешно!",
						tr: "Başarıyla gönderildi!",
						ja: "送信成功！",
					},
					ctcicc15: {
						zh: "发送失败！",
						en: "Failed to send!",
						vi: "Gửi thất bại!",
						ru: "Не удалось отправить сообщение!",
						tr: "Gönderilemedi!",
						ja: "送信に失敗しました！",
					},
					ctcicc16: {
						zh: "编辑成功！",
						en: "Edited successfully!",
						vi: "Đã chỉnh sửa thành công!",
						ru: "Отредактировано успешно!",
						tr: "Başarıyla düzenlendi!",
						ja: "編集に成功しました！",
					},
					ctcicc17: {
						zh: "编辑失败！",
						en: "Edit failed!",
						vi: "Chỉnh sửa không thành công!",
						ru: "Ошибка редактирования!",
						tr: "Düzenleme başarısız oldu!",
						ja: "編集に失敗しました！",
					},
					ctcicc18: {
						zh: "数据类型",
						en: "Data Type",
						vi: "Loại dữ liệu",
						ru: "Тип данных",
						tr: "Veri Türü",
						ja: "データタイプ"
					},
					ctcicc19: {
						zh: "协议内容",
						en: "Protocol Content",
						vi: "Nội dung giao thức",
						ru: "Содержание протокола",
						tr: "Protokol İçeriği",
						ja: "プロトコル内容"
					}

				},
				OtherSettings: {
					ctcio1: {
						zh: "输出分辨率:(大于等于屏幕分辨率且不小于256)",
						en: "Output resolution: (greater than or equal to screen resolution and not less than 256)",
						vi: "Độ phân giải đầu ra (lớn hơn hoặc bằng độ phân giải màn hình và không nhỏ hơn 256)",
						ru: "Выходное разрешение: (больше или равно разрешению экрана и не менее 256)",
						tr: "Çıkış çözünürlüğü: (ekran çözünürlüğüne eşit veya daha büyük ve 256'dan az değil)",
						ja: "出力解像度：（スクリーン解像度以上256以上）",
					},
					ctcio2: {
						zh: "宽 :",
						en: "Width :",
						vi: "Chiều rộng",
						ru: "большой :",
						tr: "Genişlik :",
						ja: "幅:",
					},
					ctcio3: {
						zh: "请输入宽",
						en: "Please enter width",
						vi: "Vui lòng nhập chiều rộng",
						ru: "Пожалуйста, введите ширину",
						tr: "Lütfen genişliği girin",
						ja: "幅を入力してください",
					},
					ctcio4: {
						zh: "高 :",
						en: "high :",
						vi: "cao",
						ru: "высота :",
						tr: "yüksek :",
						ja: "高さ:",
					},
					ctcio5: {
						zh: "请输入高",
						en: "Please enter a high",
						vi: "Vui lòng nhập mức cao",
						ru: "Пожалуйста, введите высокий",
						tr: "Lütfen yüksek bir değer girin",
						ja: "高さを入力してください",
					},
					ctcio6: {
						zh: "刷 新",
						en: "refresh",
						vi: "Làm mới",
						ru: "Освежить",
						tr: "yenileme",
						ja: "リフレッシュ",
					},
					ctcio7: {
						zh: "重启后立即生效，是否立即重启？",
						en: "The system will take effect immediately after reboot. Do you want to reboot immediately?",
						vi: "Hệ thống sẽ có hiệu lực ngay sau khi khởi động lại. Bạn có muốn khởi động lại ngay lập tức không?",
						ru: "Он вступит в силу сразу после перезагрузки. Будет ли он перезапущен немедленно?",
						tr: "Sistem, yeniden başlatmanın hemen ardından etkinleşecektir. Hemen yeniden başlatmak istiyor musunuz?",
						ja: "再起動後すぐに有効になりますが、すぐに再起動しますか？",
					},
					ctcio8: {
						zh: "确定应用！",
						en: "OK to apply!",
						vi: "xác nhận áp dụng",
						ru: "Определите область применения!",
						tr: "Başvurmak için tamam!",
						ja: "アプリケーションを確定します！",
					},
					ctcio9: {
						zh: "应用",
						en: "application",
						vi: "ứng dụng",
						ru: "приложение",
						tr: "başvuru",
						ja: "適用＃テキヨウ＃",
					},
					ctcio10: {
						zh: "软件打折(用于超宽超高屏)",
						en: "Software discounts (for ultra-wide and ultra-tall screens)",
						vi: "Giảm giá phần mềm (cho màn hình siêu rộng và siêu cao)",
						ru: "Скидка на программное обеспечение (для сверхшироких и сверхвысоких экранов)",
						tr: "Yazılım indirimleri (ultra geniş ve ultra uzun ekranlar için)",
						ja: "ソフトウェア割引（超ワイド超高画面用）",
					},
					ctcio11: {
						zh: "屏幕类型",
						en: "Screen type",
						vi: "Loại màn hình",
						ru: "Тип экрана",
						tr: "Ekran tipi",
						ja: "画面タイプ",
					},
					ctcio12: {
						zh: "请输入高",
						en: "Please enter a high",
						vi: "Vui lòng nhập mức cao",
						ru: "Пожалуйста, введите высокий",
						tr: "Lütfen yüksek bir değer girin",
						ja: "高さを入力してください",
					},
					ctcio13: {
						zh: "确定应用！",
						en: "OK to apply!",
						vi: "xác nhận áp dụng",
						ru: "Определите область применения!",
						tr: "Başvurmak için tamam!",
						ja: "アプリケーションを確定します！",
					},
					ctcio14: {
						zh: "监控连接状态当断开请选择分钟时自动重连",
						en: "Monitor connection status. When disconnected, please select the minutes to automatically reconnect.",
						vi: "Theo dõi trạng thái kết nối. Khi ngắt kết nối hãy chọn số phút để tự động kết nối lại.",
						ru: "Следите за состоянием соединения и автоматически подключайтесь снова при отключении, пожалуйста, выберите минуты",
						tr: "Bağlantı durumunu izleyin. Bağlantı kesildiğinde, lütfen otomatik olarak yeniden bağlanılacak dakikayı seçin.",
						ja: "接続状態を監視切断時は分を選択して自動再接続してください",
					},
					ctcio15: {
						zh: "定时重启",
						en: "Scheduled restart",
						vi: "Khởi động lại theo lịch trình",
						ru: "Синхронизированный перезапуск",
						tr: "Planlanmış yeniden başlatma",
						ja: "スケジュール再起動",
					},
					ctcio16: {
						zh: "设置任意时间点自动重启任务",
						en: "Set up automatic restart of tasks at any time",
						vi: "Thiết lập tự động khởi động lại tác vụ bất cứ lúc nào",
						ru: "Установите любой момент времени для автоматического перезапуска задачи",
						tr: "Görevlerin istediğiniz zaman otomatik olarak yeniden başlatılmasını ayarlayın",
						ja: "任意の時点での自動再起動タスクの設定",
					},
					ctcio17: {
						zh: "传感器总开关",
						en: "Sensor master switch",
						vi: "Công tắc cảm biến chính",
						ru: "Главный выключатель датчика",
						tr: "Sensör ana anahtarı",
						ja: "センサマスタスイッチ",
					},
					ctcio18: {
						zh: "自动亮度开关",
						en: "Automatic brightness switch",
						vi: "Công tắc độ sáng tự động",
						ru: "Автоматический переключатель яркости",
						tr: "Otomatik parlaklık anahtarı",
						ja: "じどうきどスイッチ",
					},
					ctcio19: {
						zh: "不打折",
						en: "no discount",
						vi: "không giảm giá",
						ru: "Без скидки",
						tr: "indirim yok",
						ja: "割引なし",
					},
					ctcio20: {
						zh: "超宽屏",
						en: "Ultra-wide screen",
						vi: "Màn hình siêu rộng",
						ru: "Сверхширокий экран",
						tr: "Ultra geniş ekran",
						ja: "超ワイドスクリーン"
					},
					ctcio21: {
						zh: "超高屏",
						en: "Ultra-tall screen",
						vi: "Màn hình siêu cao",
						ru: "Сверхвысокий экран",
						tr: "Ultra yüksek ekran",
						ja: "超高画面"
					},
					ctcio22: {
						zh: "指令设置成功！",
						en: "The command was set successfully!",
						vi: "Lệnh đã được đặt thành công!",
						ru: "Инструкция была успешно выполнена!",
						tr: "Komut başarıyla ayarlandı!",
						ja: "コマンド設定に成功しました！",
					},
					ctcio23: {
						zh: "确认应用",
						en: "application",
						vi: "ứng dụng",
						ru: "приложение",
						tr: "başvuru",
						ja: "適用＃テキヨウ＃",
					},
				},
				PanelMonitoring: {
					ctcip1: {
						zh: "每30S自动刷新",
						en: "Automatically refresh every 30S",
						vi: "Tự động làm mới sau mỗi 30 giây",
						ru: "Автоматическое обновление каждые 30 секунд",
						tr: "Her 30 saniyede bir otomatik olarak yenile",
						ja: "30 Sごとに自動リフレッシュ",
					},
					ctcip2: {
						zh: "未接入传感器",
						en: "No sensor connected",
						vi: "Không có cảm biến được kết nối",
						ru: "Не подключен к датчику",
						tr: "Bağlı sensör yok",
						ja: "センサが接続されていません",
					},
					ctcip3: {
						zh: "刷 新",
						en: "refresh",
						vi: "Làm mới",
						ru: "Освежить",
						tr: "yenileme",
						ja: "リフレッシュ",
					},
					ctcip4: {
						zh: "拼命加载中",
						en: "Loading",
						vi: "Đang tải",
						ru: "Отчаянно загружаясь",
						tr: "Yükleniyor",
						ja: "命がけでロード中",
					},
					ctcip5: {
						zh: "发送卡接收卡",
						en: "Sending card Receiving card",
						vi: "thẻ phát thẻ nhận",
						ru: "Отправка карточки получение карточки",
						tr: "Kart gönderiliyor Kart alınıyor",
						ja: "送信カード受信カード",
					},
					ctcip6: {
						zh: "序号",
						en: "NO.",
						vi: "Số seri",
						ru: "серийный номер",
						tr: "Seri numarası",
						ja: "シーケンス番号",
					},
					ctcip7: {
						zh: "设备类型",
						en: "Equipment type",
						vi: "Loại thiết bị",
						ru: "Тип устройства",
						tr: "Ekipman türü",
						ja: "デバイスタイプ",
					},
					ctcip8: {
						zh: "工作状态",
						en: "Working status",
						vi: "Tình trạng làm việc",
						ru: "Рабочее состояние",
						tr: "Çalışma durumu",
						ja: "動作状態",
					},
					ctcip9: {
						zh: "刷 新",
						en: "refresh",
						vi: "Làm mới",
						ru: "Освежить",
						tr: "yenileme",
						ja: "リフレッシュ",
					},
					ctcip10: {
						zh: "屏体温度",
						en: "Screen temperature",
						vi: "Nhiệt độ màn hình",
						ru: "Температура экрана",
						tr: "Ekran sıcaklığı",
						ja: "スクリーン温度",
					},
					ctcip11: {
						zh: "屏体湿度",
						en: "Screen humidity",
						vi: "Độ ẩm màn hình",
						ru: "Влажность экрана",
						tr: "Ekran nemi",
						ja: "スクリーン湿度",
					},
					ctcip12: {
						zh: "环境亮度",
						en: "Ambient brightness",
						vi: "Độ sáng xung quanh",
						ru: "Окружающая яркость",
						tr: "Ortam parlaklığı",
						ja: "環境輝度",
					},
					ctcip13: {
						zh: "烟感",
						en: "Smoke",
						vi: "Đầu báo khói",
						ru: "Ощущение дыма",
						tr: "Duman",
						ja: "スモークインダクタンス",
					},
					ctcip14: {
						zh: "发送卡",
						en: "Send Card",
						vi: "thẻ phát",
						ru: "Отправить открытку",
						tr: "Kart Gönder",
						ja: "送信カード",
					},
					ctcip15: {
						zh: "接收卡",
						en: "receive card",
						vi: "thẻ nhận",
						ru: "Получение карточки",
						tr: "kart al",
						ja: "じゅしんカード",
					},
					ctcip16: {
						zh: "电源监控",
						en: "Power Monitoring",
						vi: "Giám sát nguồn điện",
						ru: "Мониторинг питания",
						tr: "Güç İzleme",
						ja: "電源監視"
					},
					ctcip17: {
						zh: "正常",
						en: "Normal",
						vi: "Bình thường",
						ru: "Нормально",
						tr: "Normal",
						ja: "正常"
					},
					ctcip18: {
						zh: "异常",
						en: "Abnormal",
						vi: "Bất thường",
						ru: "Аномалия",
						tr: "Anormal",
						ja: "異常"
					},
					ctcip19: {
						zh: "配置",
						en: "Configuration",
						vi: "Cấu hình",
						ru: "Конфигурация",
						tr: "Yapılandırma",
						ja: "設定"
					},
					ctcip20: {
						zh: "监控端口配置",
						en: "Monitoring Port Configuration",
						vi: "Cấu hình cổng giám sát",
						ru: "Конфигурация порта мониторинга",
						tr: "İzleme Portu Yapılandırması",
						ja: "監視ポート設定"
					},
					ctcip21: {
						zh: "电源",
						en: "Power",
						vi: "Nguồn điện",
						ru: "Питание",
						tr: "Güç",
						ja: "電源"
					}

				},
				RelayControlDetail: {
					ctcir1: {
						zh: "确定",
						en: "Sure",
						vi: "Chắc chắn",
						ru: "уверенный",
						tr: "Elbette",
						ja: "を選択して、",
					}
				},
				RemoteLock: {
					ctcirl1: {
						zh: "拼命加载中",
						en: "Loading",
						vi: "Đang tải",
						ru: "Отчаянно загружаясь",
						tr: "Yükleniyor",
						ja: "命がけでロード中",
					},
					ctcirl2: {
						zh: "设备状态",
						en: "device status",
						vi: "trạng thái thiết bị",
						ru: "Состояние устройства",
						tr: "cihaz durumu",
						ja: "デバイスの状態",
					},
					ctcirl3: {
						zh: "序号",
						en: "Serial number",
						vi: "Số seri",
						ru: "серийный номер",
						tr: "Seri numarası",
						ja: "シーケンス番号",
					},
					ctcirl4: {
						zh: "设备类型",
						en: "Equipment type",
						vi: "Loại thiết bị",
						ru: "Тип устройства",
						tr: "Ekipman türü",
						ja: "デバイスタイプ",
					},
					ctcirl5: {
						zh: "工作状态",
						en: "Working status",
						vi: "Tình trạng làm việc",
						ru: "Рабочее состояние",
						tr: "Çalışma durumu",
						ja: "動作状態",
					},
					ctcirl6: {
						zh: "立即锁定",
						en: "Lock now",
						vi: "Khóa ngay",
						ru: "Запереть сейчас же",
						tr: "Şimdi kilitle",
						ja: "今すぐロック",
					},
					ctcirl7: {
						zh: "设置锁定计划",
						en: "Setting up a lock schedule",
						vi: "Thiết lập lịch khóa",
						ru: "Разработайте план локаута",
						tr: "Kilit zamanlamasını ayarlama",
						ja: "ロック計画の設定",
					},
					ctcirl8: {
						zh: "立即解锁",
						en: "Unlock now",
						vi: "Mở khóa ngay bây giờ",
						ru: "Разблокируй сейчас",
						tr: "Şimdi kilidini aç",
						ja: "即時ロック解除",
					},
					ctcirl9: {
						zh: "请输入密码",
						en: "Please enter your password",
						vi: "Vui lòng nhập mật khẩu của bạn",
						ru: "Пожалуйста, введите пароль",
						tr: "Lütfen şifrenizi girin",
						ja: "パスワードを入力してください",
					},
					ctcirl10: {
						zh: "设置密码",
						en: "set password",
						vi: "đặt mật khẩu",
						ru: "Установить пароль",
						tr: "şifre belirle",
						ja: "パスワードの設定",
					},
					ctcirl11: {
						zh: "验证密码",
						en: "verify password",
						vi: "Xác nhận lại mật khẩu",
						ru: "Подтвердите пароль",
						tr: "şifreyi doğrula",
						ja: "パスワードの検証",
					},
					ctcirl12: {
						zh: "锁定计划",
						en: "Locking plan",
						vi: "Kế hoạch khóa",
						ru: "План закрепления",
						tr: "Kilitleme planı",
						ja: "計画のロック",
					},
					ctcirl13: {
						zh: "锁定",
						en: "locking",
						vi: "khóa",
						ru: "блокировка",
						tr: "kilitleme",
						ja: "ロック＃ロック＃",
					},
					ctcirl14: {
						zh: "取消",
						en: "Cancel",
						vi: "Hủy bỏ",
						ru: "отменять",
						tr: "İptal etmek",
						ja: "キャンセル",
					},
					ctcirl15: {
						zh: "设置锁定计划",
						en: "Setting up a lock schedule",
						vi: "Thiết lập lịch khóa",
						ru: "Разработайте план локаута",
						tr: "Kilit zamanlamasını ayarlama",
						ja: "ロック計画の設定",
					},
					ctcirl16: {
						zh: "选择日期时间",
						en: "Select date and time",
						vi: "Chọn ngày và giờ",
						ru: "Выберите дату и время",
						tr: "Tarih ve saati seçin",
						ja: "日付時刻の選択",
					},
					ctcirl17: {
						zh: "注:设备将在预设的计划时刻进行上锁。",
						en: "Note: The device will lock at the preset scheduled time.",
						vi: "Lưu ý Thiết bị sẽ khóa vào thời gian đã định trước.",
						ru: "Примечание: Устройство будет заблокировано в заранее установленное время по расписанию.",
						tr: "Not: Cihaz önceden ayarlanan programlanan saatte kilitlenecektir.",
						ja: "メモ：デバイスは事前に設定された計画時刻にロックされます。",
					},
					ctcirl18: {
						zh: "接收卡",
						en: "receive card",
						vi: "thẻ nhận",
						ru: "Получение карточки",
						tr: "kart al",
						ja: "じゅしんカード",
					},
					ctcirl19: {
						zh: "发送卡",
						en: "Send Card",
						vi: "thẻ phát",
						ru: "Отправить открытку",
						tr: "Kart Gönder",
						ja: "送信カード",
					},
					ctcirl20: {
						zh: "工程锁设置成功",
						en: "Engineering lock is set successfully",
						vi: "Khóa kỹ thuật được đặt thành công",
						ru: "Инженерный шлюз был успешно установлен",
						tr: "Mühendislik kilidi başarıyla ayarlandı",
						ja: "エンジニアリングロックの設定に成功しました",
					},
					ctcirl21: {
						zh: "验证失败",
						en: "verification failed",
						vi: "xác minh không hoàn thành",
						ru: "Не удалось выполнить проверку",
						tr: "doğrulama başarısız oldu",
						ja: "検証に失敗しました",
					}
				}
			},
			AddBatchDevice: {
				ctca1: {
					zh: "数据拼命解析中...",
					en: "The data is being analyzed...",
					vi: "Dữ liệu đang được phân tích...",
					ru: "Эти данные в настоящее время анализируются...",
					tr: "Veriler analiz ediliyor...",
					ja: "データ必死解析中…",
				},
				ctca2: {
					zh: "导入",
					en: "Import",
					vi: "Nhập",
					ru: "импортировать",
					tr: "İçe aktarmak",
					ja: "インポート＃インポート＃",
				},
				ctca3: {
					zh: "设备导入模板.xlsx",
					en: "Equipment import template.xlsx",
					vi: "Mẫu nhập thiết bị.xlsx",
					ru: "Шаблон импорта устройства.xlsx",
					tr: "Ekipman içe aktarma şablonu.xlsx",
					ja: "デバイスインポートテンプレート.xlsx",
				},
				ctca4: {
					zh: "下载模板",
					en: "Download the template",
					vi: "Tải xuống mẫu",
					ru: "Скачать шаблон",
					tr: "Şablonu indirin",
					ja: "テンプレートのダウンロード",
				}
			},
			AddDevice: {
				ctcad1: {
					zh: "设备名称",
					en: "Device Name",
					vi: "Tên thiết bị",
					ru: "Имя устройства",
					tr: "Cihaz Adı",
					ja: "デバイス名",
				},
				ctcad2: {
					zh: "组织结构",
					en: "Groups",
					vi: "Cơ cấu tổ chức",
					ru: "структура",
					tr: "Organizasyon Yapısı",
					ja: "組織構造",
				},
				ctcad3: {
					zh: "请选择组织结构",
					en: "Please select your organizational structure",
					vi: "Vui lòng chọn cơ cấu tổ chức của bạn",
					ru: "Пожалуйста, выберите организационную структуру",
					tr: "Lütfen organizasyon yapınızı seçin",
					ja: "組織構造を選択してください",
				},
				ctcad4: {
					zh: "分辨率",
					en: "Resolution",
					vi: "Độ phân giải",
					ru: "разрешение",
					tr: "Çözünürlük",
					ja: "解像度",
				},
				ctcad5: {
					zh: "请选择分辨率",
					en: "Please select resolution",
					vi: "Vui lòng chọn độ phân giải",
					ru: "Пожалуйста, выберите разрешение",
					tr: "Lütfen çözünürlüğü seçin",
					ja: "解像度を選択してください",
				},
				ctcad6: {
					zh: "自定义",
					en: "customize",
					vi: "tùy chỉnh",
					ru: "настроить",
					tr: "özelleştirmek",
					ja: "カスタム＃カスタム＃",
				},
				ctcad7: {
					zh: "设备类型",
					en: "Equipment type",
					vi: "Loại thiết bị",
					ru: "Тип устройства",
					tr: "Ekipman türü",
					ja: "デバイスタイプ",
				},
				ctcad8: {
					zh: "请选择设备类型",
					en: "Please select device type",
					vi: "Vui lòng chọn loại thiết bị",
					ru: "Пожалуйста, выберите тип устройства",
					tr: "Lütfen cihaz tipini seçin",
					ja: "デバイスタイプを選択してください",
				},
				ctcad9: {
					zh: "密匙",
					en: "Key",
					vi: "phím",
					ru: "ключ",
					tr: "Anahtar",
					ja: "みつさじ",
				},
				ctcad10: {
					zh: "备注",
					en: "Remark",
					vi: "Nhận xét",
					ru: "Замечания",
					tr: "Açıklama",
					ja: "コメント",
				},
				ctcad11: {
					zh: "设备名称不能为空",
					en: "Device name cannot be empty",
					vi: "Tên thiết bị không được để trống",
					ru: "Имя устройства не может быть пустым",
					tr: "Cihaz adı boş olamaz",
					ja: "デバイス名を空にすることはできません",
				},
				ctcad12: {
					zh: "组织结构不能为空",
					en: "Organization structure cannot be empty",
					vi: "Cơ cấu tổ chức không được để trống",
					ru: "Организационная структура не может быть пустой",
					tr: "Organizasyon yapısı boş olamaz",
					ja: "組織構造を空にすることはできません",
				},
				ctcad13: {
					zh: "SN不能为空",
					en: "SN cannot be empty",
					vi: "SN không thể trống",
					ru: "SN не может быть пустым",
					tr: "SN boş olamaz",
					ja: "SNを空にすることはできません",
				},
				ctcad14: {
					zh: "屏幕分辨率不能为空",
					en: "Screen resolution cannot be empty",
					vi: "Độ phân giải màn hình không được để trống",
					ru: "Разрешение экрана не может быть пустым",
					tr: "Ekran çözünürlüğü boş olamaz",
					ja: "画面解像度を空にすることはできません",
				},
				ctcad15: {
					zh: "分辨率W为空",
					en: "Resolution W is empty",
					vi: "Độ phân giải W trống",
					ru: "Разрешение W пустое",
					tr: "Çözünürlük W boş",
					ja: "解像度WがNULL",
				},
				ctcad16: {
					zh: "分辨率H为空",
					en: "Resolution H is empty",
					vi: "Độ phân giải H trống",
					ru: "Разрешение H пустое",
					tr: "Çözünürlük H boş",
					ja: "解像度HがNULL",
				},
				ctcad17: {
					zh: "位置X为空",
					en: "Position X is empty",
					vi: "Vị trí X trống",
					ru: "Позиция X пуста",
					tr: "X konumu boş",
					ja: "位置Xが空です",
				},
				ctcad18: {
					zh: "位置Y为空",
					en: "Position Y is empty",
					vi: "Vị trí Y trống",
					ru: "Позиция Y пуста",
					tr: "Y konumu boş",
					ja: "位置Yが空です",
				},
				ctcad19: {
					zh: "本地分辨率存在..",
					en: "Native resolution exists..",
					vi: "Độ phân giải gốc tồn tại ..",
					ru: "Существует локальное разрешение..",
					tr: "Yerel çözünürlük mevcut..",
					ja: "ローカル解像度が存在します...",
				},
				ctcad20: {
					zh: "编辑参数.....",
					en: "Edit Parameters...",
					vi: "Chỉnh sửa thông số...",
					ru: "Отредактируйте параметры.....",
					tr: "Parametreleri Düzenle...",
					ja: "パラメータを編集....",
				}
			},
			DeviceDetail: {
				ctcde1: {
					zh: "暂无数据",
					en: "No data",
					vi: "Không có dữ liệu",
					ru: "Нет доступных данных",
					tr: "Veri yok",
					ja: "データが一時的にありません",
				}
			},
			DeviceDetailOpen: {
				ctcddo1: {
					zh: "截屏",
					en: "screenshot",
					vi: "ảnh chụp màn hình",
					ru: "скриншот",
					tr: "ekran görüntüsü",
					ja: "スクリーン枚",
				},
				ctcddo2: {
					zh: "屏体监控",
					en: "Screen monitoring",
					vi: "Giám sát màn hình",
					ru: "Мониторинг экрана",
					tr: "Ekran izleme",
					ja: "スクリーンモニタ",
				},
				ctcddo3: {
					zh: "其他设置",
					en: "other settings",
					vi: "các thiết lập khác",
					ru: "Другие настройки",
					tr: "diğer ayarlar",
					ja: "その他の設定",
				},
				ctcddo4: {
					zh: "暂无数据",
					en: "No data",
					vi: "Không có dữ liệu",
					ru: "Нет доступных данных",
					tr: "Veri yok",
					ja: "データが一時的にありません",
				},
				ctcddo5: {
					zh: "无需升级",
					en: "No upgrade required",
					vi: "Không cần nâng cấp",
					ru: "Нет необходимости в обновлении",
					tr: "Yükseltme gerekmez",
					ja: "アップグレード不要",
				},
				ctcddo6: {
					zh: "上传完成",
					en: "upload completed",
					vi: "Hoàn tất tải lên",
					ru: "Загрузка завершена",
					tr: "yükleme tamamlandı",
					ja: "アップロード完了",
				},
				ctcddo7: {
					zh: "定时播放",
					en: "Scheduled playback",
					vi: "Phát lại theo lịch trình",
					ru: "Синхронизированное воспроизведение",
					tr: "Zamanlanmış oynatma",
					ja: "タイミング再生",
				},
				ctcddo8: {
					zh: "WIFI网络",
					en: "WIFI network",
					vi: "Mạng wifi",
					ru: "Сеть Wi-FI",
					tr: "Wi-Fi ağı",
					ja: "WIFIネットワーク",
				},
				ctcddo9: {
					zh: "有线网络",
					en: "Wired network",
					vi: "Mạng có dây",
					ru: "Проводная сеть",
					tr: "Kablolu ağ",
					ja: "有線ネットワーク",
				},
				ctcddo10: {
					zh: "同步播放",
					en: "Synchronous playback",
					vi: "Phát lại đồng bộ",
					ru: "Синхронное воспроизведение",
					tr: "Senkronize oynatma",
					ja: "同期再生",
				},
				ctcddo11: {
					zh: "websocket截图",
					en: "websocket screenshot",
					vi: "ảnh chụp màn hình websocket",
					ru: "скриншот веб-сокета",
					tr: "websocket ekran görüntüsü",
					ja: "websocketスクリーンショット",
				}
			},
			EditTimePlan: {
				ctce1: {
					zh: "定时播放编辑",
					en: "Timed playback editing",
					vi: "Chỉnh sửa phát lại theo thời gian",
					ru: "Редактирование воспроизведения по времени",
					tr: "Zamanlanmış oynatma düzenleme",
					ja: "タイミング再生編集",
				},
				ctce2: {
					zh: "名称",
					en: "name",
					vi: "tên",
					ru: "название",
					tr: "isim",
					ja: "の名前をあげる",
				},
				ctce3: {
					zh: "执行时间",
					en: "execution time",
					vi: "thời gian thực hiện",
					ru: "Время выполнения",
					tr: "yürütme süresi",
					ja: "じっこうじかん",
				},
				ctce4: {
					zh: "开始时间",
					en: "Starting time",
					vi: "Thời gian bắt đầu",
					ru: "Время начала",
					tr: "Başlangıç ​​zamanı",
					ja: "開始時間",
				},
				ctce5: {
					zh: "至",
					en: "to",
					vi: "ĐẾN",
					ru: "до",
					tr: "ile",
					ja: "終了",
				},
				ctce6: {
					zh: "结束时间",
					en: "End Time",
					vi: "Thời gian kết thúc",
					ru: "Время окончания",
					tr: "Bitiş Zamanı",
					ja: "終了時間",
				},
				ctce7: {
					zh: "有效日期",
					en: "Effective Date",
					vi: "Ngày có hiệu lực",
					ru: "Дата вступления в силу",
					tr: "Yürürlük Tarihi",
					ja: "有効日",
				}
			},
			HandleOrder: {
				ctch1: {
					zh: "发布紧急信息",
					en: "Release emergency information",
					vi: "Công bố thông tin khẩn cấp",
					ru: "Публиковать информацию о чрезвычайных ситуациях",
					tr: "Acil durum bilgilerini yayınlayın",
					ja: "緊急情報の発行",
				},
				ctch2: {
					zh: "取消紧急信息",
					en: "Cancel emergency information",
					vi: "Hủy thông tin khẩn cấp",
					ru: "Отменить экстренную информацию",
					tr: "Acil durum bilgilerini iptal et",
					ja: "緊急情報の取消し",
				},
				ctch3: {
					zh: "截屏所有选中设备？",
					en: "Take screenshot of all selected devices?",
					vi: "Chụp ảnh màn hình của tất cả các thiết bị đã chọn?",
					ru: "Сделайте скриншоты всех выбранных устройств?",
					tr: "Seçilen tüm cihazların ekran görüntüsü alınsın mı?",
					ja: "選択したすべてのデバイスをスクリーンショットしますか？",
				},
				ctch4: {
					zh: "启用云平台看护",
					en: "Enable cloud platform maintenance",
					vi: "Kích hoạt bảo trì nền tảng đám mây",
					ru: "Включить поддержку облачной платформы",
					tr: "Bulut platformu bakımını etkinleştirin",
					ja: "クラウドプラットフォームによる介護の有効化",
				},
				ctch5: {
					zh: "监控云平台连接状态，当连接断开请选择时，盒子自动尝试重启再登录。",
					en: "Monitor the cloud platform connection status. When the connection is disconnected, please select it and the box will automatically try to restart and log in again.",
					vi: "Theo dõi trạng thái kết nối nền tảng đám mây. Khi kết nối bị ngắt, vui lòng chọn nó và hộp sẽ tự động khởi động lại và đăng nhập lại.",
					ru: "Следите за состоянием подключения к облачной платформе. Когда подключение будет отключено, пожалуйста, установите флажок, после чего автоматически попытайтесь перезагрузиться, а затем войдите в систему.",
					tr: "Bulut platformu bağlantı durumunu izleyin. Bağlantı kesildiğinde lütfen onu seçin; kutu otomatik olarak yeniden başlamayı ve tekrar oturum açmayı deneyecektir.",
					ja: "クラウドプラットフォームの接続状態を監視し、接続が切断された場合に選択してください。ボックスは自動的に再ログインを試みます。",
				},
				ctch6: {
					zh: "开启上传",
					en: "Enable Upload",
					vi: "Bật tải lên",
					ru: "Открыть загрузку",
					tr: "Yüklemeyi Etkinleştir",
					ja: "アップロードの有効化",
				},
				ctch7: {
					zh: "关闭上传",
					en: "Close Upload",
					vi: "Đóng tải lên",
					ru: "Закрыть загрузку",
					tr: "Yüklemeyi Kapat",
					ja: "アップロードを閉じる",
				},
				ctch8: {
					zh: "全屏",
					en: "full screen",
					vi: "toàn màn hình",
					ru: "Полноэкранный режим",
					tr: "Tam ekran",
					ja: "フルスクリーン",
				},
				ctch9: {
					zh: "信息内容",
					en: "information",
					vi: "thông tin",
					ru: "Информационное наполнение",
					tr: "bilgi",
					ja: "情報の内容",
				},
				ctch10: {
					zh: "选择文本",
					en: "Select text",
					vi: "Chọn văn bản",
					ru: "Выделите текст",
					tr: "Metni seçin",
					ja: "テキストの選択",
				},
				ctch11: {
					zh: "请输入内容",
					en: "Please enter content",
					vi: "Vui lòng nhập nội dung",
					ru: "Пожалуйста, введите содержание",
					tr: "Lütfen içeriği girin",
					ja: "内容を入力してください",
				},
				ctch12: {
					zh: "文字大小",
					en: "font size",
					vi: "cỡ chữ",
					ru: "Размер текста",
					tr: "yazı tipi boyutu",
					ja: "文字サイズ",
				},
				ctch13: {
					zh: "文字颜色",
					en: "Text Color",
					vi: "Màu chữ",
					ru: "Цвет текста",
					tr: "Metin Rengi",
					ja: "テキストの色",
				},
				ctch14: {
					zh: "文字背景",
					en: "Text background",
					vi: "Nền chữ",
					ru: "Текстовый фон",
					tr: "Metin arka planı",
					ja: "テキストの背景",
				},
				ctch15: {
					zh: "持续时间",
					en: "duration",
					vi: "khoảng thời gian",
					ru: "продолжительность",
					tr: "süre",
					ja: "継続時間",
				},
				ctch16: {
					zh: "任意时间点",
					en: "Any time point",
					vi: "Bất kỳ thời điểm nào",
					ru: "В любой момент времени",
					tr: "Herhangi bir zaman noktası",
					ja: "任意の時点",
				},
				ctch17: {
					zh: "播出类型",
					en: "Broadcast Type",
					vi: "Loại phát sóng",
					ru: "Тип широковещательной передачи",
					tr: "Yayın Türü",
					ja: "放送タイプ",
				},
				ctch18: {
					zh: "声音控制",
					en: "voice control",
					vi: "điều khiển giọng nói",
					ru: "Управление звуком",
					tr: "ses kontrolü",
					ja: "サウンドコントロール",
				},
				ctch19: {
					zh: "请选择",
					en: "please choose",
					vi: "xin vui lòng chọn",
					ru: "Пожалуйста выберите",
					tr: "lütfen seç",
					ja: "選択してください",
				},
				ctch20: {
					zh: "立即发送",
					en: "send immediately",
					vi: "gửi ngay lập tức",
					ru: "Отправляйте прямо сейчас",
					tr: "hemen gönder",
					ja: "今すぐ送信",
				},
				ctch21: {
					zh: "取消",
					en: "Cancel",
					vi: "Hủy bỏ",
					ru: "отменять",
					tr: "İptal etmek",
					ja: "キャンセル",
				},
				ctch22: {
					zh: "确定取消所选终端的紧急信息？",
					en: "Are you sure you want to cancel the emergency information for the selected terminal?",
					vi: "Bạn có chắc chắn muốn hủy thông tin khẩn cấp cho thiết bị đầu cuối đã chọn không?",
					ru: "Вы уверены, что хотите отменить экстренную информацию о выбранном терминале?",
					tr: "Seçilen terminalin acil durum bilgilerini iptal etmek istediğinizden emin misiniz?",
					ja: "選択した端末の緊急情報をキャンセルしますか？",
				},
				ctch23: {
					zh: "版式选择",
					en: "Layout Selection",
					vi: "Lựa chọn bố cục",
					ru: "Выбор макета",
					tr: "Düzen Seçimi",
					ja: "レイアウトの選択",
				},
				ctch24: {
					zh: "请选择",
					en: "please choose",
					vi: "xin vui lòng chọn",
					ru: "Пожалуйста выберите",
					tr: "lütfen seç",
					ja: "選択してください",
				},
				ctch25: {
					zh: "模式选择",
					en: "Mode Selection",
					vi: "Chế độ lựa chọn",
					ru: "Выбор режима",
					tr: "Mod Seçimi",
					ja: "モード選択",
				},
				ctch26: {
					zh: "模式",
					en: "model",
					vi: "Chế độ",
					ru: "режим",
					tr: "modeli",
					ja: "パターン＃パターン＃",
				},
				ctch27: {
					zh: "开启全局流媒体播放",
					en: "Enable global streaming",
					vi: "Bật phát trực tuyến toàn cầu",
					ru: "Включите глобальное потоковое воспроизведение мультимедиа",
					tr: "Küresel akışı etkinleştir",
					ja: "グローバルストリーミングの開始",
				},
				ctch28: {
					zh: "请输入内容",
					en: "Please enter content",
					vi: "Vui lòng nhập nội dung",
					ru: "Пожалуйста, введите содержание",
					tr: "Lütfen içeriği girin",
					ja: "内容を入力してください",
				},
				ctch29: {
					zh: "请输入流地址",
					en: "Please enter the stream address",
					vi: "Vui lòng nhập địa chỉ luồng",
					ru: "Пожалуйста, введите адрес трансляции",
					tr: "Lütfen akış adresini girin",
					ja: "ストリームアドレスを入力してください",
				},
				ctch30: {
					zh: "紧急消息",
					en: "Urgent Message",
					vi: "Thông báo khẩn cấp",
					ru: "Срочное сообщение",
					tr: "Acil Mesaj",
					ja: "緊急メッセージ",
				},
				ctch31: {
					zh: "亮度调节",
					en: "Dimming",
					vi: "Làm mờ",
					ru: "Регулировка яркости",
					tr: "Karartma",
					ja: "きどちょうせい",
				},
				ctch32: {
					zh: "音量调节",
					en: "Volume adjustment",
					vi: "Điều chỉnh âm lượng",
					ru: "Регулировка громкости",
					tr: "Ses ayarı",
					ja: "音量調節",
				},
				ctch33: {
					zh: "关闭屏幕",
					en: "Screen off ",
					vi: "Tắt màn hình",
					ru: "Выключите экран",
					tr: "Ekranı kapat",
					ja: "画面を閉じる",
				},
				ctch34: {
					zh: "开启屏幕",
					en: "Screen on",
					vi: "Bật màn hình",
					ru: "Включите экран",
					tr: "Ekranı aç",
					ja: "画面を開く",
				},
				ctch35: {
					zh: "全屏显示",
					en: "full-screen display",
					vi: "hiển thị toàn màn hình",
					ru: "Полноэкранный дисплей",
					tr: "tam ekran görüntü",
					ja: "全画面表示",
				},
				ctch36: {
					zh: "滚动显示",
					en: "Scroll Display",
					vi: "Hiển thị cuộn",
					ru: "Дисплей с прокруткой",
					tr: "Kaydırmalı Ekran",
					ja: "スクロール表示",
				},
				ctch37: {
					zh: "选项1",
					en: "Option 1",
					vi: "lựa chọn 1",
					ru: "Вариант 1",
					tr: "Seçenek 1",
					ja: "オプション1",
				},
				ctch38: {
					zh: "请选择0-100之间'",
					en: "Please select between 0-100",
					vi: "Vui lòng chọn trong khoảng 0-100",
					ru: "Пожалуйста, выберите значение от 0 до 100",
					tr: "Lütfen 0-100 arasında seçim yapın",
					ja: "0～100の間を選択してください'",
				},
				ctch39: {
					zh: "保存成功",
					en: "Saved successfully",
					vi: "đã lưu thành công",
					ru: "Успешно сохранен",
					tr: "Başarıyla kaydedildi",
					ja: "保存に成功しました",
				},
				ctch40: {
					zh: "模板已存在,请更改名称",
					en: "The template already exists, please change the name",
					vi: "Mẫu đã tồn tại, vui lòng đổi tên",
					ru: "Шаблон уже существует, пожалуйста, измените название",
					tr: "Şablon zaten mevcut, lütfen adını değiştirin",
					ja: "テンプレートは既に存在します。名前を変更してください",
				},
				ctch41: {
					zh: "取消成功!",
					en: "Cancel success!",
					vi: "Hủy bỏ thành công!",
					ru: "Отмена прошла успешно!",
					tr: "Başarıyı iptal edin!",
					ja: "キャンセル成功！",
				},
				ctch42: {
					zh: "请设置数值参数",
					en: "Please set the numerical parameters",
					vi: "Hãy thiết lập các thông số số",
					ru: "Пожалуйста, задайте числовые параметры",
					tr: "Lütfen sayısal parametreleri ayarlayın",
					ja: "数値パラメータを設定してください",
				},
				ctch43: {
					zh: "信息内容不能为空！",
					en: "The information content cannot be empty!",
					vi: "Nội dung thông tin không được để trống!",
					ru: "Информационное наполнение не может быть пустым!",
					tr: "Bilgi içeriği boş olamaz!",
					ja: "メッセージの内容を空にすることはできません！",
				},
				ctch44: {
					zh: "确定立即发送紧急信息?",
					en: "Are you sure you want to send an emergency message immediately?",
					vi: "Bạn có chắc chắn muốn gửi tin nhắn khẩn cấp ngay lập tức không?",
					ru: "Вы уверены, что нужно немедленно отправить экстренное сообщение?",
					tr: "Hemen acil durum mesajı göndermek istediğinizden emin misiniz?",
					ja: "緊急メッセージをすぐに送信しますか？",
				},
				ctch45: {
					zh: "紧急信息",
					en: "Emergency Information",
					vi: "Thông tin khẩn cấp",
					ru: "Экстренная информация",
					tr: "Acil Durum Bilgileri",
					ja: "緊急情報",
				},
				ctch46: {
					zh: "发送成功!",
					en: "Sent successfully!",
					vi: "Gửi thành công!",
					ru: "Отправлено успешно!",
					tr: "Başarıyla gönderildi!",
					ja: "送信成功！",
				},
				ctch47: {
					zh: "截屏",
					en: "screenshot",
					vi: "ảnh chụp màn hình",
					ru: "скриншот",
					tr: "ekran görüntüsü",
					ja: "スクリーン枚",
				},
				ctch48: {
					zh: "云看护",
					en: "Cloud Care",
					vi: "Chăm sóc đám mây",
					ru: "Уход за облаком",
					tr: "Bulut Bakımı",
					ja: "クラウドケア",
				},
				ctch49: {
					zh: "云看护开关",
					en: "Cloud Guardian Switch",
					vi: "Công tắc bảo vệ đám mây",
					ru: "Карданный переключатель",
					tr: "Bulut Koruma Anahtarı",
					ja: "クラウドケアスイッチ",
				},
				ctch50: {
					zh: "日志上传设置",
					en: "Log upload settings",
					vi: "Cài đặt tải lên nhật ký",
					ru: "Настройки загрузки журнала",
					tr: "Günlük yükleme ayarları",
					ja: "ログアップロード設定",
				},
				ctch51: {
					zh: "紧急消息发布",
					en: "Emergency message release",
					vi: "Phát hành tin nhắn khẩn cấp",
					ru: "Экстренный выпуск новостей",
					tr: "Acil durum mesajının yayınlanması",
					ja: "緊急メッセージの発行",
				},
				ctch52: {
					zh: "紧急消息取消",
					en: "Emergency message cancellation",
					vi: "Hủy tin nhắn khẩn cấp",
					ru: "Экстренное сообщение отменено",
					tr: "Acil mesaj iptali",
					ja: "緊急メッセージのキャンセル",
				},
				ctch53: {
					zh: "紧急消息模式切换",
					en: "Emergency message mode switch",
					vi: "Chuyển đổi chế độ tin nhắn khẩn cấp",
					ru: "Переключатель режима аварийного сообщения",
					tr: "Acil durum mesajı modu anahtarı",
					ja: "緊急メッセージモード切り替え",
				},
				ctch54: {
					zh: "紧急版式",
					en: "Emergency Layout",
					vi: "Bố cục khẩn cấp",
					ru: "Аварийная планировка",
					tr: "Acil Durum Düzeni",
					ja: "緊急レイアウト",
				},
				ctch55: {
					zh: "已发送",
					en: "Has been sent",
					vi: "Đã được gửi đi",
					ru: "Отправлено",
					tr: "Gönderildi",
					ja: "送信済み",
				},
				ctch56: {
					zh: "云平台地址",
					en: "Cloud Platform Address",
					vi: "Địa chỉ nền tảng đám mây",
					ru: "Адрес облачной платформы",
					tr: "Bulut Platformu Adresi",
					ja: "クラウドプラットフォームアドレス",
				},
				ctch57: {
					zh: "注意:请务必单台设置成功后，再进行批量设置，此操作不可逆。",
					en: "Note: Please make sure to set up a single device successfully before performing batch settings. This operation is irreversible.",
					vi: "Lưu ý: Vui lòng đảm bảo thiết lập thành công cho một thiết bị trước khi thực hiện thiết lập hàng loạt. Hoạt động này không thể đảo ngược.",
					ru: "Примечание: Пожалуйста, убедитесь, что установка для одного устройства прошла успешно, прежде чем выполнять массовую установку. Эта операция необратима.",
					tr: "Not: Toplu ayarlar yapmadan önce tek bir aygıtın başarıyla ayarlandığından emin olun. Bu işlem geri alınamaz.",
					ja: "注意：バッチ設定を行う前に、必ず単体で設定が成功したことを確認してください。この操作は元に戻せません。",
				}
			}
		},
		Control: {
			ctco1: {
				zh: "安装日期",
				en: "Installation Date",
				vi: "Ngày cài đặt",
				ru: "Дата установки",
				tr: "Kurulum Tarihi",
				ja: "インストール日",
			},
			ctco2: {
				zh: "选择日期时间",
				en: "Select date and time",
				vi: "Chọn ngày và giờ",
				ru: "Выберите дату и время",
				tr: "Tarih ve saati seçin",
				ja: "日付時刻の選択",
			},
			ctco3: {
				zh: "测试",
				en: "test",
				vi: "Kiểm tra",
				ru: "проверка",
				tr: "test",
				ja: "テスト",
			},
			ctco4: {
				zh: "确定",
				en: "Sure",
				vi: "Chắc chắn",
				ru: "уверенный",
				tr: "Elbette",
				ja: "を選択して、",
			},
			ctco5: {
				zh: "数据拼命解析中",
				en: "Data is being analyzed",
				vi: "Dữ liệu đang được phân tích",
				ru: "Данные анализируются",
				tr: "Veriler analiz ediliyor",
				ja: "データ必死解析中",
			},
			ctco6: {
				zh: "导入",
				en: "Import",
				vi: "Nhập khẩu",
				ru: "импортировать",
				tr: "İçe aktarmak",
				ja: "インポート＃インポート＃",
			},
			ctco7: {
				zh: "下载模板",
				en: "Download the template",
				vi: "Tải xuống mẫu",
				ru: "Скачать шаблон",
				tr: "Şablonu indirin",
				ja: "テンプレートのダウンロード",
			},
			ctco8: {
				zh: "请检查格式",
				en: "Please check the format",
				vi: "Vui lòng kiểm tra định dạng",
				ru: "Пожалуйста, проверьте формат",
				tr: "Lütfen formatı kontrol edin",
				ja: "フォーマットを確認してください",
			},
			ctco9: {
				zh: "全部",
				en: "ALL",
				vi: "Tất cả",
				ru: "Все",
				tr: "Tümü",
				ja: "全て",
			},
			ctco10: {
				zh: "在线",
				en: "ONLINE",
				vi: "Trực tuyến",
				ru: "Онлайн",
				tr: "Çevrimiçi",
				ja: "オンライン",
			},
			ctco11: {
				zh: "离线",
				en: "OFFLINE",
				vi: "Ngoại tuyến",
				ru: "Офлайн",
				tr: "Çevrimdışı",
				ja: "オフライン",
			},
			ctco12: {
				zh: "开屏",
				en: "SCREEN_ON",
				vi: "Màn hình bật",
				ru: "Экран вкл.",
				tr: "Ekran Açık",
				ja: "画面オン",
			},
			ctco13: {
				zh: "关屏",
				en: "SCREEN_OFF",
				vi: "Màn hình tắt",
				ru: "Экран выкл.",
				tr: "Ekran Kapalı",
				ja: "画面オフ",
			}
		}
	},
	router: {
		index: {
			ri1: {
				zh: "帮助",
				en: "help",
				vi: "giúp đỡ",
				ru: "помогать",
				tr: "yardım",
				ja: "ヘルプ",
			},
			ri2: {
				zh: "素材管理",
				en: "Media",
				vi: "Quản lý vật liệu",
				ru: "Управление материальными ресурсами",
				tr: "Malzeme Yönetimi",
				ja: "マテリアル管理",
			},
			ri3: {
				zh: "媒体列表",
				en: "Media List",
				vi: "Danh sách phương tiện",
				ru: "Список носителей",
				tr: "Medya Listesi",
				ja: "メディアリスト",
			},
			ri4: {
				zh: "新媒体列表",
				en: "New Media List",
				vi: "Danh sách phương tiện mới",
				ru: "Список новых носителей",
				tr: "Yeni Medya Listesi",
				ja: "新しいメディアリスト",
			},
			ri5: {
				zh: "媒体上传",
				en: "Media Upload",
				vi: "Tải lên phương tiện",
				ru: "Загрузка мультимедиа",
				tr: "Medya Yükleme",
				ja: "メディアのアップロード",
			},
			ri6: {
				zh: "节目管理",
				en: "Program",
				vi: "Quản lý chương trình",
				ru: "Управление программами",
				tr: "Program Yönetimi",
				ja: "プログラム管理",
			},
			ri7: {
				zh: "节目编辑",
				en: "Solution",
				vi: "Chỉnh sửa chương trình",
				ru: "Редактор программ",
				tr: "Program Düzenleme",
				ja: "番組編集",
			},
			ri8: {
				zh: "高级发布",
				en: "Schedule",
				vi: "Xuất bản nâng cao",
				ru: "Расширенный выпуск",
				tr: "Gelişmiş Yayıncılık",
				ja: "詳細なパブリケーション",
			},
			ri9: {
				zh: "插播管理",
				en: "Interlude Management",
				vi: "Quản lý xen kẽ",
				ru: "Промежуточное управление",
				tr: "Interlude Yönetimi",
				ja: "補間管理",
			},
			ri10: {
				zh: "权限配置",
				en: "Rights Profile",
				vi: "Hồ sơ quyền",
				ru: "Настройка разрешений",
				tr: "Hak Profili",
				ja: "権限設定",
			},
			ri11: {
				zh: "新建插播",
				en: "Create a new insert",
				vi: "Tạo một phần chèn mới",
				ru: "Новый интерстициальный",
				tr: "Yeni bir ek oluştur",
				ja: "新規補間",
			},
			ri12: {
				zh: "节目编辑窗口",
				en: "Program editing window",
				vi: "Cửa sổ soạn thảo chương trình",
				ru: "Окно редактирования программы",
				tr: "Program düzenleme penceresi",
				ja: "番組編集ウィンドウ",
			},
			ri13: {
				zh: "节目发布窗口",
				en: "Program release window",
				vi: "Cửa sổ phát hành chương trình",
				ru: "Окно выпуска программы",
				tr: "Program yayınlama penceresi",
				ja: "番組発表ウィンドウ",
			},
			ri14: {
				zh: "终端管理",
				en: "Screen",
				vi: "Quản lý thiết bị đầu cuối",
				ru: "Управление терминалом",
				tr: "Terminal Yönetimi",
				ja: "ターミナル管理",
			},
			ri15: {
				zh: "审核管理",
				en: "Check",
				vi: "Quản lý kiểm toán",
				ru: "Управление аудитом",
				tr: "Denetim Yönetimi",
				ja: "監査管理",
			},
			ri16: {
				zh: "素材审核",
				en: "Material review",
				vi: "Đánh giá tài liệu",
				ru: "Обзор материалов",
				tr: "Malzeme incelemesi",
				ja: "素材審査",
			},
			ri17: {
				zh: "节目审核",
				en: "Program Review",
				vi: "Đánh giá chương trình",
				ru: "Обзор программы",
				tr: "Program İncelemesi",
				ja: "番組審査",
			},
			ri18: {
				zh: "发布审核",
				en: "Release Review",
				vi: "Đánh giá phát hành",
				ru: "Обзор выпуска",
				tr: "Sürüm İncelemesi",
				ja: "レビューの発行",
			},
			ri19: {
				zh: "审核管理",
				en: "Audit Management",
				vi: "Quản lý kiểm toán",
				ru: "Управление аудитом",
				tr: "Denetim Yönetimi",
				ja: "監査管理",
			},
			ri20: {
				zh: "日志管理",
				en: "Log Management",
				vi: "Quản lý nhật ký",
				ru: "Управление журналами",
				tr: "Günlük Yönetimi",
				ja: "ログ管理",
			},
			ri21: {
				zh: "登录日志",
				en: "Login Log",
				vi: "Đăng nhập Nhật ký",
				ru: "Журнал входа в систему",
				tr: "Giriş Giriş",
				ja: "ログインログ",
			},
			ri22: {
				zh: "操作日志",
				en: "Operation log",
				vi: "Nhật ký hoạt động",
				ru: "Журнал операций",
				tr: "Operasyon günlüğü",
				ja: "操作ログ",
			},
			ri23: {
				zh: "终端日志",
				en: "Terminal log",
				vi: "Nhật ký thiết bị đầu cuối",
				ru: "Журнал регистрации терминала",
				tr: "Terminal günlüğü",
				ja: "ターミナルログ",
			},
			ri24: {
				zh: "终端管理",
				en: "Terminal Management",
				vi: "Quản lý thiết bị đầu cuối",
				ru: "Управление терминалом",
				tr: "Terminal Yönetimi",
				ja: "ターミナル管理",
			},
			ri25: {
				zh: "终端详情",
				en: "Terminal Details",
				vi: "Chi tiết thiết bị đầu cuối",
				ru: "Сведения о терминале",
				tr: "Terminal Detayları",
				ja: "端末の詳細",
			},
			ri26: {
				zh: "获取设备",
				en: "Get the device",
				vi: "Nhận thiết bị",
				ru: "Получить оборудование",
				tr: "Cihazı alın",
				ja: "デバイスの取得",
			},
			ri27: {
				zh: "高级管理",
				en: "Senior Management",
				vi: "Quản lí cấp cao",
				ru: "Высшее руководство",
				tr: "Üst Yönetim",
				ja: "高度な管理",
			},
			ri28: {
				zh: "组织结构",
				en: "Groups",
				vi: "Cơ cấu tổ chức",
				ru: "структура",
				tr: "Organizasyon Yapısı",
				ja: "組織構造",
			},
			ri29: {
				zh: "媒体目录管理",
				en: "Media Catalog Management",
				vi: "Quản lý danh mục phương tiện truyền thông",
				ru: "Управление каталогом мультимедиа",
				tr: "Medya Katalog Yönetimi",
				ja: "メディアディレクトリ管理",
			},
			ri30: {
				zh: "用户管理",
				en: "User Management",
				vi: "Quản lý người dùng",
				ru: "Управление пользователями",
				tr: "Kullanıcı Yönetimi",
				ja: "ユーザー管理",
			},
			ri31: {
				zh: "角色管理",
				en: "Role Management",
				vi: "Quản lý vai trò",
				ru: "Управление ролями",
				tr: "Rol Yönetimi",
				ja: "ロール管理",
			},
			ri32: {
				zh: "系统设置",
				en: "System Settings",
				vi: "Cài đặt hệ thống",
				ru: "Системные настройки",
				tr: "Sistem Ayarları",
				ja: "システム設定",
			},
			ri33: {
				zh: "节点管理",
				en: "Node Management",
				vi: "Quản lý nút",
				ru: "Управление узлами",
				tr: "Düğüm Yönetimi",
				ja: "ノード管理",
			},
			ri34: {
				zh: "个人中心",
				en: "Personal Center",
				vi: "Trung tâm cá nhân",
				ru: "Персональный центр",
				tr: "Kişisel Merkez",
				ja: "パーソナルセンター",
			},
			ri35: {
				zh: "权限配置",
				en: "Rights Profile",
				vi: "Hồ sơ quyền",
				ru: "Настройка разрешений",
				tr: "Hak Profili",
				ja: "権限設定",
			},
			ri36: {
				zh: "审核设置",
				en: "Audit settings",
				vi: "Cài đặt kiểm tra",
				ru: "Настройки аудита",
				tr: "Denetim ayarları",
				ja: "監査設定",
			},
			ri37: {
				zh: "推荐码",
				en: "Referral Code",
				vi: "Mã giới thiệu",
				ru: "Рекомендательный код",
				tr: "Yönlendirme Kodu",
				ja: "推奨コード",
			},
			ri38: {
				zh: "紧急内容配置",
				en: "Emergency content configuration",
				vi: "Cấu hình nội dung khẩn cấp",
				ru: "Настройка аварийного содержимого",
				tr: "Acil durum içerik yapılandırması",
				ja: "緊急コンテンツ構成",
			},
			ri39: {
				zh: "断点续传测试",
				en: "Breakpoint resume test",
				vi: "Kiểm tra tiếp tục điểm dừng",
				ru: "Проверка возобновления работы точки останова",
				tr: "Kesme noktası devam testi",
				ja: "ブレークポイント再送信テスト",
			}
		}
	},
	views: {
		Login: {
			vl1: {
				zh: "请输入服务器地址",
				en: "Please enter the server address",
				vi: "Vui lòng nhập địa chỉ máy chủ",
				ru: "Пожалуйста, введите адрес сервера",
				tr: "Lütfen sunucu adresini girin",
				ja: "サーバーアドレスを入力してください",
			},
			vl2: {
				zh: "进 入",
				en: "Enter",
				vi: "nhập",
				ru: "входить",
				tr: "Girmek",
				ja: "に入る",
			},
			vl3: {
				zh: "历史访问记录",
				en: "Historical access records",
				vi: "Hồ sơ truy cập lịch sử",
				ru: "Историческая запись доступа",
				tr: "Geçmiş erişim kayıtları",
				ja: "履歴アクセス履歴",
			},
			vl4: {
				zh: "清除",
				en: "Clear",
				vi: "xoá",
				ru: "очистить",
				tr: "Temizlemek",
				ja: "パージ",
			},
			vl5: {
				zh: "修改服务器地址",
				en: "Modify the server address",
				vi: "Sửa đổi địa chỉ máy chủ",
				ru: "Изменить адрес сервера",
				tr: "Sunucu adresini değiştirin",
				ja: "サーバーアドレスの変更",
			},
			vl6: {
				zh: "账户不能为空",
				en: "Account cannot be empty",
				vi: "Tài khoản không thể trống",
				ru: "Учетная запись не может быть пустой",
				tr: "Hesap boş olamaz",
				ja: "アカウントを空にすることはできません",
			},
			vl7: {
				zh: "密码不能为空",
				en: "password can not be blank",
				vi: "mật khẩu không thể để trống",
				ru: "Пароль не может быть пустым",
				tr: "şifre boş olamaz",
				ja: "パスワードを空にすることはできません",
			},
			vl8: {
				zh: "验证码输入错误",
				en: "incorrect verification code",
				vi: "Mã xác minh không chính xác",
				ru: "Ошибка при вводе проверочного кода",
				tr: "yanlış doğrulama kodu",
				ja: "認証コード入力エラー",
			},
			vl9: {
				zh: "浏览器语言是中文",
				en: "The browser language is Chinese",
				vi: "Ngôn ngữ trình duyệt là tiếng Trung Quốc",
				ru: "Язык браузера - китайский",
				tr: "Tarayıcı dili Çincedir",
				ja: "ブラウザ言語は中国語",
			},
			vl10: {
				zh: "浏览器语言是英文",
				en: "The browser language is English",
				vi: "Ngôn ngữ trình duyệt là tiếng Anh",
				ru: "Язык браузера - английский",
				tr: "Tarayıcı dili İngilizcedir",
				ja: "ブラウザ言語は英語です",
			},
			vl11: {
				zh: "浏览器语言是其它",
				en: "Browser language is Other",
				vi: "Ngôn ngữ trình duyệt là Khác",
				ru: "Язык браузера - другой",
				tr: "Tarayıcı dili Diğer",
				ja: "ブラウザ言語はその他です",
			},
			vl12: {
				zh: "提示",
				en: "hint",
				vi: "gợi ý",
				ru: "подсказка",
				tr: "ipucu",
				ja: "ヒント",
			},
			vl13: {
				zh: "为了保证系统功能正常使用，建议您使用<a target=_blank href='https://www.google.cn/intl/zh-CN/chrome/'>Chrome浏览器</a>最新版本进行访问!",
				en: "In order to ensure the normal use of system functions, it is recommended that you use the latest version of <a target=_blank href='https://www.google.cn/intl/zh-CN/chrome/'> to access!",
				vi: "Để đảm bảo các chức năng của hệ thống có thể sử dụng bình thường, bạn nên sử dụng phiên bản mới nhất của &lt;<a target=_blank href='https://www.google.cn/intl/zh-CN/chrome/'> để truy cập!",
				ru: "Чтобы обеспечить нормальное использование системных функций, рекомендуется использовать <a target=_blank href='https://www.google.cn/intl/zh-CN/chrome/'> Доступна последняя версия!",
				tr: "Sistem işlevlerinin normal kullanımını sağlamak için &lt;a target=_blank href=&quot;https://www.google.cn/intl/zh-CN/chrome/&quot'un en son sürümünü kullanmanız önerilir. Erişmek için ;&gt;Chrome tarayıcı</a>!",
				ja: "システム機能を正常に使用するためには、<a target=_ blank href='https://www.google.cn/intl/zh-CN/chrome/'>Chromeブラウザ</a>の最新バージョンにアクセス！",
			}
		},
		Mytest: {
			vm1: {
				zh: "点击上传",
				en: "Click Upload",
				vi: "Nhấp vào Tải lên",
				ru: "Нажмите кнопку загрузить",
				tr: "Yükle'ye tıklayın",
				ja: "アップロードをクリック",
			}
		}
	},
	temporary: {
		temporary1: {
			zh: "板载电源",
			en: "Onboard Power",
			vi: "Nguồn onboard",
			ru: "Встроенное питание",
			tr: "Dahili güç",
			ja: "オンボード電源",
		},
		temporary2: {
			zh: "播放终端",
			en: "Playback Terminal",
			vi: "Thiết bị phát",
			ru: "Терминал",
			tr: "Oynatma Terminali",
			ja: "再生端末",
		},
		temporary3: {
			zh: "发送卡",
			en: "Sending Card",
			vi: "Thẻ gửi",
			ru: "ПОтправить",
			tr: "Gönderme Kartı",
			ja: "送信カード",
		},
		temporary4: {
			zh: "接收卡",
			en: "Receiving Card",
			vi: "Thẻ nhận",
			ru: "Загрузка карты",
			tr: "Alıcı Kartı",
			ja: "受信カード",
		},
		temporary5: {
			zh: "监控连接状态",
			en: "Monitor Connection Status",
			vi: "Giám sát trạng thái kết nối",
			ru: "Мониторинг соединения",
			tr: "Bağlantı Durumunu İzle",
			ja: "接続状態を監視",
		},
		temporary6: {
			zh: "当断开",
			en: "When disconnected",
			vi: "Khi bị ngắt kết nối",
			ru: "При отключении",
			tr: "Bağlantı kesildiğinde",
			ja: "切断時に",
		},
		temporary6_1: {
			zh: "分钟时自动重连",
			en: "auto reconnect after minutes",
			vi: "tự động kết nối lại sau vài phút",
			ru: "автоматически переподключиться через несколько минут",
			tr: "dakika sonra otomatik yeniden bağlan",
			ja: "分後に自動再接続",
		},
		temporary7: {
			zh: "同步本地时间",
			en: "Sync Local Time",
			vi: "Đồng bộ thời gian cục bộ",
			ru: "Местное время",
			tr: "Yerel Zamanı Eşitle",
			ja: "ローカル時間と同期",
		},
		temporary8: {
			zh: "与Internet时间服务器同步",
			en: "Sync with Internet Time Server",
			vi: "Đồng bộ với máy chủ thời gian Internet",
			ru: "Синхронизация NTP",
			tr: "İnternet Zaman Sunucusuyla Eşitle",
			ja: "インターネット時間サーバーと同期",
		},
		temporary9: {
			zh: "每折大小",
			en: "Size per Fold",
			vi: "Kích thước mỗi gấp",
			ru: "Размер на складку",
			tr: "Katlama Başına Boyut",
			ja: "折りごとのサイズ",
		},
		temporary10: {
			zh: "超级管理员",
			en: "Super Administrator",
			vi: "Quản trị viên cấp cao",
			ru: "Администратор",
			tr: "Süper Yönetici",
			ja: "スーパ管理者",
		},
		temporary11: {
			zh: "已选",
			en: "Selected",
			vi: "Đã chọn",
			ru: "Выбрано",
			tr: "Seçildi",
			ja: "選択済み",
		},
		temporary14: {
			zh: "账户不能为空",
			en: "Account Cannot Be Empty",
			vi: "Tài khoản không được để trống",
			ru: "Введите имя пользователя",
			tr: "Hesap Boş Olamaz",
			ja: "アカウントを空にすることはできません",
		},
		temporary15: {
			zh: "密码不能为空",
			en: "Password Cannot Be Empty",
			vi: "Mật khẩu không được để trống",
			ru: "Введите пароль",
			tr: "Şifre Boş Olamaz",
			ja: "パスワードを空にすることはできません",
		},
		temporary16: {
			zh: "参数有误",
			en: "Invalid Parameters",
			vi: "Tham số không hợp lệ",
			ru: "Не введены необходимые данные",
			tr: "Geçersiz Parametreler",
			ja: "パラメーターが無効です",
		},
		temporary17: {
			zh: "七天内免登录",
			en: "Auto Login for 7 Days",
			vi: "Tự động đăng nhập trong 7 ngày",
			ru: "Запомнить на 7 дней",
			tr: "7 Gün Otomatik Giriş",
			ja: "7日間ログイン不要",
		},
		temporary18: {
			zh: "设置",
			en: "Settings",
			vi: "Cài đặt",
			ru: "Настройки",
			tr: "Ayarlar",
			ja: "設定",
		},
		temporary19: {
			zh: "自动重启任务",
			en: "Auto Restart Task",
			vi: "Tác vụ khởi động lại tự động",
			ru: "Автоматический перезапуск задачи",
			tr: "Otomatik Yeniden Başlatma Görevi",
			ja: "自動再起動タスク",
		},
		temporary20: {
			zh: "等待中",
			en: "Waiting",
			vi: "Đang chờ",
			ru: "Ожидание",
			tr: "Bekleniyor",
			ja: "待機中",
		},
		temporary21: {
			zh: "下载中",
			en: "Downloading",
			vi: "Đang tải xuống",
			ru: "Загрузка",
			tr: "İndiriliyor",
			ja: "ダウンロード中",
		},
		temporary22: {
			zh: "下载失败",
			en: "Failed",
			vi: "Tải xuống thất bại",
			ru: "Ошибка загрузки",
			tr: "İndirme Başarısız",
			ja: "ダウンロード失敗",
		},
		temporary23: {
			zh: "下载成功",
			en: "Success",
			vi: "Tải xuống thành công",
			ru: "Успешная загрузка",
			tr: "İndirme Başarılı",
			ja: "ダウンロード成功",
		},
		temporary24: {
			zh: "重连失效",
			en: "Reconnect Failed",
			vi: "Kết nối lại thất bại",
			ru: "Ошибка переподключения",
			tr: "Yeniden Bağlantı Başarısız",
			ja: "再接続失敗",
		},
		temporary25: {
			zh: "设备离线",
			en: "Offline",
			vi: "Thiết bị ngoại tuyến",
			ru: "Устройство отключено",
			tr: "Cihaz Çevrimdışı",
			ja: "デバイスがオフライン",
		},
		temporary26: {
			zh: "已取消",
			en: "Cancel",
			vi: "Đã hủy",
			ru: "Отменено",
			tr: "İptal Edildi",
			ja: "キャンセル済み",
		},
		temporary27: {
			zh: "无状态",
			en: "No Status",
			vi: "Không có trạng thái",
			ru: "Нет статуса",
			tr: "Durum Yok",
			ja: "ステータスなし",
		},
		temporary28: {
			zh: "验证码输入错误",
			en: "Incorrect verification code",
			vi: "Mã xác minh không đúng",
			ru: "Неверный проверочный код",
			tr: "Doğrulama kodu hatalı",
			ja: "認証コードが間違っています"
		},
		temporary29: {
			zh: "系统版本",
			en: "System Version",
			vi: "Phiên bản hệ thống",
			ru: "Версия системы",
			tr: "Sistem Sürümü",
			ja: "システムバージョン"
		},
		temporary30: {
			zh: "关于系统",
			en: "About System",
			vi: "Giới thiệu hệ thống",
			ru: "О системе",
			tr: "Sistem Hakkında",
			ja: "システムについて"
		},
		temporary31: {
			zh: "定点投放",
			en: "Targeted advertising",
			vi: "Thả điểm",
			ru: "Сброс с фиксированной точкой",
			tr: "Sabit nokta teslimatı",
			ja: "定点配置",
		},
		temporary32: {
			zh: "虚拟屏开关",
			en: "Virtual Screen Toggle",
			vi: "Bật/Tắt màn hình ảo",
			ru: "Переключатель виртуального экрана",
			tr: "Sanal Ekran Anahtarı",
			ja: "仮想画面スイッチ"
		},
		temporary33: {
			zh: "开启该功能，屏幕实际分辨率宽最大8192，分辨率高1080",
			en: "When enabled, the screen's actual resolution width is up to 8192, and height is 1080",
			vi: "Khi bật, độ phân giải thực tế của màn hình rộng tối đa 8192 và cao 1080",
			ru: "При включении фактическое разрешение экрана составляет до 8192 в ширину и 1080 в высоту",
			tr: "Etkinleştirildiğinde, ekranın gerçek çözünürlüğü genişlikte maksimum 8192, yükseklikte 1080'dir",
			ja: "この機能を有効にすると、画面の実際の解像度は幅が最大8192、高さが1080になります"
		},
		temporary34: {
			zh: "屏幕实际分辨率",
			en: "Virtual Screen Toggle",
			vi: "Bật/Tắt màn hình ảo",
			ru: "Переключатель виртуального экрана",
			tr: "Sanal Ekran Anahtarı",
			ja: "仮想画面スイッチ"
		},
		temporary35: {
			zh: "自适应屏幕和U盘直播根据此屏幕分辨率铺满全屏播放",
			en: "Virtual Screen Toggle",
			vi: "Bật/Tắt màn hình ảo",
			ru: "Переключатель виртуального экрана",
			tr: "Sanal Ekran Anahtarı",
			ja: "仮想画面スイッチ"
		},
		temporary36: {
			zh: "扩展电源",
			en: "Extended Power",
			vi: "Nguồn mở rộng",
			ru: "Расширенное питание",
			tr: "Genişletilmiş güç",
			ja: "拡張電源"
		},
		temporary37: {
			zh: "APP 升级",
			en: "APP Upgrade",
			vi: "Nâng cấp ứng dụng",
			ru: "Обновление приложения",
			tr: "Uygulama Güncellemesi",
			ja: "APP アップグレード"
		},
		temporary38: {
			zh: "云平台迁移",
			en: "Cloud Platform Migration",
			vi: "Di chuyển nền tảng đám mây",
			ru: "Миграция облачной платформы",
			tr: "Bulut Platformu Taşıma",
			ja: "クラウドプラットフォーム移行"
		}
	},
	app: {
		app1: {
			zh: "WebSocket连接超时",
			en: "WebSocket connection timeout",
			vi: "WebSocket kết nối hết thời gian",
			ru: "Истекло время ожидания соединения WebSocket",
			tr: "WebSocket bağlantısı zaman aşımına uğradı",
			ja: "WebSocket接続がタイムアウトしました"
		},
		app2: {
			zh: "WebSocket连接断开",
			en: "WebSocket connection disconnected",
			vi: "WebSocket kết nối bị ngắt",
			ru: "Соединение WebSocket разорвано",
			tr: "WebSocket bağlantısı kesildi",
			ja: "WebSocket接続が切断されました"
		}
	}
};

const object = flatObjectAll(language);
const languages = { zh: {}, en: {}, vi: {}, ru: {}, tr: {}, ja: {} };

for (const key in object) {
	if (Object.hasOwnProperty.call(object, key)) {
		const { zh, en, vi, ru, tr, ja } = object[key];
		languages['zh'][key] = zh;
		languages['en'][key] = en;
		languages['vi'][key] = vi;
		languages['ru'][key] = ru;
		languages['tr'][key] = tr;
		languages['ja'][key] = ja;
	}
}
export default languages;
